"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Layup endpoints
 * Welcome to The Layup Swagger page. This page allows developers to interactively explore the API. For more detailed documentation see [The Layup documentation page](https://documentation.layup.co.za/).  # Introduction  ## What is LayUp  LayUp is a lay-by payment solution. LayUp Schedules payments and ensures that your clients pay securely, effectively and on time. Depending on your parameters LayUp schedules a payment plan for your clients. Once a payment plan has been completed we notify you. There are 3 stories that are of importance to a merchant:  1. Order Creation 2. Deposit Received (and holding Stock for your client) 3. Order Completion.  LayUp allows you to take full control over the entire payment process if you wish to do so. We also provide a convenient front-end for users to use. The front-end should significantly reduce the time to integrate and get you started using LayUp as soon as possible.  Once an order is completed a notification will be sent to the merchant so that you can provide the client with their product.  ## How to use LayUp  As a merchant who wants to place an order through LayUp, you want to send the relevant information to the LayUp API to create the order. The API will return an order ID. Unless your integration is using a custom user interface, you want to send the user to the LayUp customer payment widget. The URL for this widget is <u>https://shopper.layup.co.za/order/{orderId}</u> for production and <u>https://shopper-sandbox.layup.co.za/order/{orderId}</u> for sandbox.
 *
 * The version of the OpenAPI document: 1.4.16
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebitOrderMandateServiceApiAxiosParamCreator = exports.DebiCheckServiceApi = exports.DebiCheckServiceApiFactory = exports.DebiCheckServiceApiFp = exports.DebiCheckServiceApiAxiosParamCreator = exports.ConnectorServiceApi = exports.ConnectorServiceApiFactory = exports.ConnectorServiceApiFp = exports.ConnectorServiceApiAxiosParamCreator = exports.CardServiceApi = exports.CardServiceApiFactory = exports.CardServiceApiFp = exports.CardServiceApiAxiosParamCreator = exports.BankTransactionServiceApi = exports.BankTransactionServiceApiFactory = exports.BankTransactionServiceApiFp = exports.BankTransactionServiceApiAxiosParamCreator = exports.BankServiceApi = exports.BankServiceApiFactory = exports.BankServiceApiFp = exports.BankServiceApiAxiosParamCreator = exports.AuthServiceApi = exports.AuthServiceApiFactory = exports.AuthServiceApiFp = exports.AuthServiceApiAxiosParamCreator = exports.AbsaEftServiceApi = exports.AbsaEftServiceApiFactory = exports.AbsaEftServiceApiFp = exports.AbsaEftServiceApiAxiosParamCreator = exports.AbsaDebiCheckServiceApi = exports.AbsaDebiCheckServiceApiFactory = exports.AbsaDebiCheckServiceApiFp = exports.AbsaDebiCheckServiceApiAxiosParamCreator = exports.ModelUserResponseRoleEnum = exports.ModelUserRequestRoleEnum = exports.ModelUserRoleEnum = exports.ModelTokenRequestActionEnum = exports.ModelPaymentPlanResponseFrequencyEnum = exports.ModelPaymentPlanPreviewResponseManyDepositTypeEnum = exports.ModelPaymentPlanPreviewRequestDepositTypeEnum = exports.ModelPaymentPlanPreviewRequestFrequencyEnum = exports.ModelOrderSendRequestPaymentMethodEnum = exports.ModelOrderSendRequestTypeEnum = exports.ModelOrderResponseDepositTypeEnum = exports.ModelOrderResponseStateEnum = exports.ModelOrderRequestDepositTypeEnum = exports.ModelDebiCheckMediumEnum = exports.ModelDebiCheckIdentificationTypeEnum = exports.ModelDebiCheckAccountTypeEnum = exports.ModelCancellationPolicyNameEnum = void 0;
exports.PaymentServiceApiFp = exports.PaymentServiceApiAxiosParamCreator = exports.PaymentProviderSettlementServiceApi = exports.PaymentProviderSettlementServiceApiFactory = exports.PaymentProviderSettlementServiceApiFp = exports.PaymentProviderSettlementServiceApiAxiosParamCreator = exports.PaymentPlanServiceApi = exports.PaymentPlanServiceApiFactory = exports.PaymentPlanServiceApiFp = exports.PaymentPlanServiceApiAxiosParamCreator = exports.PayAtServiceApi = exports.PayAtServiceApiFactory = exports.PayAtServiceApiFp = exports.PayAtServiceApiAxiosParamCreator = exports.OrderServiceGetManyStateEnum = exports.OrderServiceApi = exports.OrderServiceApiFactory = exports.OrderServiceApiFp = exports.OrderServiceApiAxiosParamCreator = exports.OrderAmendmentServiceApi = exports.OrderAmendmentServiceApiFactory = exports.OrderAmendmentServiceApiFp = exports.OrderAmendmentServiceApiAxiosParamCreator = exports.MerchantServiceApi = exports.MerchantServiceApiFactory = exports.MerchantServiceApiFp = exports.MerchantServiceApiAxiosParamCreator = exports.JournalServiceApi = exports.JournalServiceApiFactory = exports.JournalServiceApiFp = exports.JournalServiceApiAxiosParamCreator = exports.JournalFeeServiceApi = exports.JournalFeeServiceApiFactory = exports.JournalFeeServiceApiFp = exports.JournalFeeServiceApiAxiosParamCreator = exports.InvoicesServiceApi = exports.InvoicesServiceApiFactory = exports.InvoicesServiceApiFp = exports.InvoicesServiceApiAxiosParamCreator = exports.IntegrationServiceApi = exports.IntegrationServiceApiFactory = exports.IntegrationServiceApiFp = exports.IntegrationServiceApiAxiosParamCreator = exports.EmailServiceApi = exports.EmailServiceApiFactory = exports.EmailServiceApiFp = exports.EmailServiceApiAxiosParamCreator = exports.DebitOrderMandateServiceApi = exports.DebitOrderMandateServiceApiFactory = exports.DebitOrderMandateServiceApiFp = void 0;
exports.VerifyServiceApi = exports.VerifyServiceApiFactory = exports.VerifyServiceApiFp = exports.VerifyServiceApiAxiosParamCreator = exports.UserServiceApi = exports.UserServiceApiFactory = exports.UserServiceApiFp = exports.UserServiceApiAxiosParamCreator = exports.TokenServiceApi = exports.TokenServiceApiFactory = exports.TokenServiceApiFp = exports.TokenServiceApiAxiosParamCreator = exports.TerminalServiceApi = exports.TerminalServiceApiFactory = exports.TerminalServiceApiFp = exports.TerminalServiceApiAxiosParamCreator = exports.TerminalPaymentAppsServiceApi = exports.TerminalPaymentAppsServiceApiFactory = exports.TerminalPaymentAppsServiceApiFp = exports.TerminalPaymentAppsServiceApiAxiosParamCreator = exports.SmsOriginNumberServiceApi = exports.SmsOriginNumberServiceApiFactory = exports.SmsOriginNumberServiceApiFp = exports.SmsOriginNumberServiceApiAxiosParamCreator = exports.ShopifyServiceApi = exports.ShopifyServiceApiFactory = exports.ShopifyServiceApiFp = exports.ShopifyServiceApiAxiosParamCreator = exports.SettlementServiceApi = exports.SettlementServiceApiFactory = exports.SettlementServiceApiFp = exports.SettlementServiceApiAxiosParamCreator = exports.PaymentServiceV2Api = exports.PaymentServiceV2ApiFactory = exports.PaymentServiceV2ApiFp = exports.PaymentServiceV2ApiAxiosParamCreator = exports.PaymentServiceApi = exports.PaymentServiceApiFactory = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.ModelCancellationPolicyNameEnum = {
    Deposit: 'Deposit',
    Percentage: 'Percentage',
    FlatFee: 'FlatFee',
    Combination: 'Combination'
};
/**
 *
 * @export
 * @enum {number}
 */
exports.ModelDebiCheckAccountTypeEnum = {
    Current: 0,
    Savings: 1,
    Transmission: 2
};
/**
 *
 * @export
 * @enum {number}
 */
exports.ModelDebiCheckIdentificationTypeEnum = {
    IdentityDocument: 0,
    Passport: 1,
    TemporaryResidence: 2
};
/**
 *
 * @export
 * @enum {number}
 */
exports.ModelDebiCheckMediumEnum = {
    /**
    * Phone Number (in international format, e.g., +1 415 555 2671)
    */
    PhoneNumber: 0,
    /**
    * Email address
    */
    EmailAddress: 1
};
exports.ModelOrderRequestDepositTypeEnum = {
    Instalment: 'INSTALMENT',
    Flat: 'FLAT',
    Percentage: 'PERCENTAGE'
};
exports.ModelOrderResponseStateEnum = {
    Partial: 'PARTIAL',
    Placed: 'PLACED',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    Cancelling: 'CANCELLING',
    Expired: 'EXPIRED',
    Suspended: 'SUSPENDED'
};
exports.ModelOrderResponseDepositTypeEnum = {
    Instalment: 'INSTALMENT',
    Flat: 'FLAT',
    Percentage: 'PERCENTAGE'
};
exports.ModelOrderSendRequestTypeEnum = {
    Sms: 'sms',
    Email: 'email',
    None: 'none'
};
exports.ModelOrderSendRequestPaymentMethodEnum = {
    Card: 'CARD',
    Eft: 'EFT',
    Debicheck: 'DEBICHECK'
};
exports.ModelPaymentPlanPreviewRequestFrequencyEnum = {
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY'
};
exports.ModelPaymentPlanPreviewRequestDepositTypeEnum = {
    Instalment: 'INSTALMENT',
    Flat: 'FLAT',
    Percentage: 'PERCENTAGE'
};
exports.ModelPaymentPlanPreviewResponseManyDepositTypeEnum = {
    Instalment: 'INSTALMENT',
    Flat: 'FLAT',
    Percentage: 'PERCENTAGE'
};
exports.ModelPaymentPlanResponseFrequencyEnum = {
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY'
};
exports.ModelTokenRequestActionEnum = {
    Verifyaccount: 'VERIFYACCOUNT',
    Createpaymentplan: 'CREATEPAYMENTPLAN',
    Viewpaymentplan: 'VIEWPAYMENTPLAN',
    Verifyaccountcreatepaymentplan: 'VERIFYACCOUNTCREATEPAYMENTPLAN'
};
exports.ModelUserRoleEnum = {
    Client: 'CLIENT',
    Merchant: 'MERCHANT',
    Admin: 'ADMIN'
};
exports.ModelUserRequestRoleEnum = {
    Client: 'CLIENT',
    Merchant: 'MERCHANT',
    Admin: 'ADMIN'
};
exports.ModelUserResponseRoleEnum = {
    Client: 'CLIENT',
    Merchant: 'MERCHANT',
    Admin: 'ADMIN'
};
/**
 * AbsaDebiCheckServiceApi - axios parameter creator
 * @export
 */
const AbsaDebiCheckServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelAbsaDebiCheckOutputRequest} modelAbsaDebiCheckOutputRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absaDebiCheckServiceOutput: async (modelAbsaDebiCheckOutputRequest, options = {}) => {
            // verify required parameter 'modelAbsaDebiCheckOutputRequest' is not null or undefined
            (0, common_1.assertParamExists)('absaDebiCheckServiceOutput', 'modelAbsaDebiCheckOutputRequest', modelAbsaDebiCheckOutputRequest);
            const localVarPath = `/v1/absa/debicheck/output`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelAbsaDebiCheckOutputRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelAbsaDebiCheckReplyRequest} modelAbsaDebiCheckReplyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absaDebiCheckServiceReply: async (modelAbsaDebiCheckReplyRequest, options = {}) => {
            // verify required parameter 'modelAbsaDebiCheckReplyRequest' is not null or undefined
            (0, common_1.assertParamExists)('absaDebiCheckServiceReply', 'modelAbsaDebiCheckReplyRequest', modelAbsaDebiCheckReplyRequest);
            const localVarPath = `/v1/absa/debicheck/reply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelAbsaDebiCheckReplyRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AbsaDebiCheckServiceApiAxiosParamCreator = AbsaDebiCheckServiceApiAxiosParamCreator;
/**
 * AbsaDebiCheckServiceApi - functional programming interface
 * @export
 */
const AbsaDebiCheckServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AbsaDebiCheckServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelAbsaDebiCheckOutputRequest} modelAbsaDebiCheckOutputRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absaDebiCheckServiceOutput(modelAbsaDebiCheckOutputRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absaDebiCheckServiceOutput(modelAbsaDebiCheckOutputRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AbsaDebiCheckServiceApi.absaDebiCheckServiceOutput']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelAbsaDebiCheckReplyRequest} modelAbsaDebiCheckReplyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absaDebiCheckServiceReply(modelAbsaDebiCheckReplyRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absaDebiCheckServiceReply(modelAbsaDebiCheckReplyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AbsaDebiCheckServiceApi.absaDebiCheckServiceReply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.AbsaDebiCheckServiceApiFp = AbsaDebiCheckServiceApiFp;
/**
 * AbsaDebiCheckServiceApi - factory interface
 * @export
 */
const AbsaDebiCheckServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AbsaDebiCheckServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {AbsaDebiCheckServiceApiAbsaDebiCheckServiceOutputRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absaDebiCheckServiceOutput(requestParameters, options) {
            return localVarFp.absaDebiCheckServiceOutput(requestParameters.modelAbsaDebiCheckOutputRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AbsaDebiCheckServiceApiAbsaDebiCheckServiceReplyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absaDebiCheckServiceReply(requestParameters, options) {
            return localVarFp.absaDebiCheckServiceReply(requestParameters.modelAbsaDebiCheckReplyRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AbsaDebiCheckServiceApiFactory = AbsaDebiCheckServiceApiFactory;
/**
 * AbsaDebiCheckServiceApi - object-oriented interface
 * @export
 * @class AbsaDebiCheckServiceApi
 * @extends {BaseAPI}
 */
class AbsaDebiCheckServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {AbsaDebiCheckServiceApiAbsaDebiCheckServiceOutputRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsaDebiCheckServiceApi
     */
    absaDebiCheckServiceOutput(requestParameters, options) {
        return (0, exports.AbsaDebiCheckServiceApiFp)(this.configuration).absaDebiCheckServiceOutput(requestParameters.modelAbsaDebiCheckOutputRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AbsaDebiCheckServiceApiAbsaDebiCheckServiceReplyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsaDebiCheckServiceApi
     */
    absaDebiCheckServiceReply(requestParameters, options) {
        return (0, exports.AbsaDebiCheckServiceApiFp)(this.configuration).absaDebiCheckServiceReply(requestParameters.modelAbsaDebiCheckReplyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AbsaDebiCheckServiceApi = AbsaDebiCheckServiceApi;
/**
 * AbsaEftServiceApi - axios parameter creator
 * @export
 */
const AbsaEftServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelAbsaEftOutputRequest} modelAbsaEftOutputRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absaEftServiceOutput: async (modelAbsaEftOutputRequest, options = {}) => {
            // verify required parameter 'modelAbsaEftOutputRequest' is not null or undefined
            (0, common_1.assertParamExists)('absaEftServiceOutput', 'modelAbsaEftOutputRequest', modelAbsaEftOutputRequest);
            const localVarPath = `/v1/absa/eft/output`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelAbsaEftOutputRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelAbsaEftReplyRequest} modelAbsaEftReplyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absaEftServiceReply: async (modelAbsaEftReplyRequest, options = {}) => {
            // verify required parameter 'modelAbsaEftReplyRequest' is not null or undefined
            (0, common_1.assertParamExists)('absaEftServiceReply', 'modelAbsaEftReplyRequest', modelAbsaEftReplyRequest);
            const localVarPath = `/v1/absa/eft/reply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelAbsaEftReplyRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AbsaEftServiceApiAxiosParamCreator = AbsaEftServiceApiAxiosParamCreator;
/**
 * AbsaEftServiceApi - functional programming interface
 * @export
 */
const AbsaEftServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AbsaEftServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelAbsaEftOutputRequest} modelAbsaEftOutputRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absaEftServiceOutput(modelAbsaEftOutputRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absaEftServiceOutput(modelAbsaEftOutputRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AbsaEftServiceApi.absaEftServiceOutput']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelAbsaEftReplyRequest} modelAbsaEftReplyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absaEftServiceReply(modelAbsaEftReplyRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absaEftServiceReply(modelAbsaEftReplyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AbsaEftServiceApi.absaEftServiceReply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.AbsaEftServiceApiFp = AbsaEftServiceApiFp;
/**
 * AbsaEftServiceApi - factory interface
 * @export
 */
const AbsaEftServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AbsaEftServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {AbsaEftServiceApiAbsaEftServiceOutputRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absaEftServiceOutput(requestParameters, options) {
            return localVarFp.absaEftServiceOutput(requestParameters.modelAbsaEftOutputRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AbsaEftServiceApiAbsaEftServiceReplyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absaEftServiceReply(requestParameters, options) {
            return localVarFp.absaEftServiceReply(requestParameters.modelAbsaEftReplyRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AbsaEftServiceApiFactory = AbsaEftServiceApiFactory;
/**
 * AbsaEftServiceApi - object-oriented interface
 * @export
 * @class AbsaEftServiceApi
 * @extends {BaseAPI}
 */
class AbsaEftServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {AbsaEftServiceApiAbsaEftServiceOutputRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsaEftServiceApi
     */
    absaEftServiceOutput(requestParameters, options) {
        return (0, exports.AbsaEftServiceApiFp)(this.configuration).absaEftServiceOutput(requestParameters.modelAbsaEftOutputRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AbsaEftServiceApiAbsaEftServiceReplyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AbsaEftServiceApi
     */
    absaEftServiceReply(requestParameters, options) {
        return (0, exports.AbsaEftServiceApiFp)(this.configuration).absaEftServiceReply(requestParameters.modelAbsaEftReplyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AbsaEftServiceApi = AbsaEftServiceApi;
/**
 * AuthServiceApi - axios parameter creator
 * @export
 */
const AuthServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelForgotPasswordRequest} modelForgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceForgotPassword: async (modelForgotPasswordRequest, options = {}) => {
            // verify required parameter 'modelForgotPasswordRequest' is not null or undefined
            (0, common_1.assertParamExists)('authServiceForgotPassword', 'modelForgotPasswordRequest', modelForgotPasswordRequest);
            const localVarPath = `/v1/request-password-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelForgotPasswordRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Warning: Calling this endpoint will replace any existing apikeys on your account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceGenerateApiKey: async (options = {}) => {
            const localVarPath = `/v1/auth/apikey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [serial]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceGenerateTerminalApiKey: async (serial, options = {}) => {
            const localVarPath = `/v1/auth/terminal-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (serial !== undefined) {
                localVarQueryParameter['serial'] = serial;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceGetMe: async (options = {}) => {
            const localVarPath = `/v1/auth/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelLoginRequest} modelLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceLogin: async (modelLoginRequest, options = {}) => {
            // verify required parameter 'modelLoginRequest' is not null or undefined
            (0, common_1.assertParamExists)('authServiceLogin', 'modelLoginRequest', modelLoginRequest);
            const localVarPath = `/v1/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelLoginRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelMerchantBillingSettlementRequest} modelMerchantBillingSettlementRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceMerchantBillingChangesRequest: async (modelMerchantBillingSettlementRequest, options = {}) => {
            // verify required parameter 'modelMerchantBillingSettlementRequest' is not null or undefined
            (0, common_1.assertParamExists)('authServiceMerchantBillingChangesRequest', 'modelMerchantBillingSettlementRequest', modelMerchantBillingSettlementRequest);
            const localVarPath = `/v1/send-billing-settlements-change-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelMerchantBillingSettlementRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelUserRequest} modelUserRequest
         * @param {string} [id]
         * @param {string} [avs]
         * @param {boolean} [isRealtimeVerification]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceRegister: async (modelUserRequest, id, avs, isRealtimeVerification, options = {}) => {
            // verify required parameter 'modelUserRequest' is not null or undefined
            (0, common_1.assertParamExists)('authServiceRegister', 'modelUserRequest', modelUserRequest);
            const localVarPath = `/v1/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            if (avs !== undefined) {
                localVarQueryParameter['avs'] = avs;
            }
            if (isRealtimeVerification !== undefined) {
                localVarQueryParameter['isRealtimeVerification'] = isRealtimeVerification;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelUserRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AuthServiceApiAxiosParamCreator = AuthServiceApiAxiosParamCreator;
/**
 * AuthServiceApi - functional programming interface
 * @export
 */
const AuthServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AuthServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelForgotPasswordRequest} modelForgotPasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceForgotPassword(modelForgotPasswordRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceForgotPassword(modelForgotPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AuthServiceApi.authServiceForgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Warning: Calling this endpoint will replace any existing apikeys on your account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceGenerateApiKey(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceGenerateApiKey(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AuthServiceApi.authServiceGenerateApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [serial]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceGenerateTerminalApiKey(serial, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceGenerateTerminalApiKey(serial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AuthServiceApi.authServiceGenerateTerminalApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceGetMe(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceGetMe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AuthServiceApi.authServiceGetMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelLoginRequest} modelLoginRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceLogin(modelLoginRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceLogin(modelLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AuthServiceApi.authServiceLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelMerchantBillingSettlementRequest} modelMerchantBillingSettlementRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceMerchantBillingChangesRequest(modelMerchantBillingSettlementRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceMerchantBillingChangesRequest(modelMerchantBillingSettlementRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AuthServiceApi.authServiceMerchantBillingChangesRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelUserRequest} modelUserRequest
         * @param {string} [id]
         * @param {string} [avs]
         * @param {boolean} [isRealtimeVerification]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authServiceRegister(modelUserRequest, id, avs, isRealtimeVerification, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authServiceRegister(modelUserRequest, id, avs, isRealtimeVerification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['AuthServiceApi.authServiceRegister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.AuthServiceApiFp = AuthServiceApiFp;
/**
 * AuthServiceApi - factory interface
 * @export
 */
const AuthServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AuthServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {AuthServiceApiAuthServiceForgotPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceForgotPassword(requestParameters, options) {
            return localVarFp.authServiceForgotPassword(requestParameters.modelForgotPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Warning: Calling this endpoint will replace any existing apikeys on your account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceGenerateApiKey(options) {
            return localVarFp.authServiceGenerateApiKey(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthServiceApiAuthServiceGenerateTerminalApiKeyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceGenerateTerminalApiKey(requestParameters = {}, options) {
            return localVarFp.authServiceGenerateTerminalApiKey(requestParameters.serial, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceGetMe(options) {
            return localVarFp.authServiceGetMe(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthServiceApiAuthServiceLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceLogin(requestParameters, options) {
            return localVarFp.authServiceLogin(requestParameters.modelLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthServiceApiAuthServiceMerchantBillingChangesRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceMerchantBillingChangesRequest(requestParameters, options) {
            return localVarFp.authServiceMerchantBillingChangesRequest(requestParameters.modelMerchantBillingSettlementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AuthServiceApiAuthServiceRegisterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authServiceRegister(requestParameters, options) {
            return localVarFp.authServiceRegister(requestParameters.modelUserRequest, requestParameters.id, requestParameters.avs, requestParameters.isRealtimeVerification, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AuthServiceApiFactory = AuthServiceApiFactory;
/**
 * AuthServiceApi - object-oriented interface
 * @export
 * @class AuthServiceApi
 * @extends {BaseAPI}
 */
class AuthServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {AuthServiceApiAuthServiceForgotPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    authServiceForgotPassword(requestParameters, options) {
        return (0, exports.AuthServiceApiFp)(this.configuration).authServiceForgotPassword(requestParameters.modelForgotPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Warning: Calling this endpoint will replace any existing apikeys on your account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    authServiceGenerateApiKey(options) {
        return (0, exports.AuthServiceApiFp)(this.configuration).authServiceGenerateApiKey(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthServiceApiAuthServiceGenerateTerminalApiKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    authServiceGenerateTerminalApiKey(requestParameters = {}, options) {
        return (0, exports.AuthServiceApiFp)(this.configuration).authServiceGenerateTerminalApiKey(requestParameters.serial, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    authServiceGetMe(options) {
        return (0, exports.AuthServiceApiFp)(this.configuration).authServiceGetMe(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthServiceApiAuthServiceLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    authServiceLogin(requestParameters, options) {
        return (0, exports.AuthServiceApiFp)(this.configuration).authServiceLogin(requestParameters.modelLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthServiceApiAuthServiceMerchantBillingChangesRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    authServiceMerchantBillingChangesRequest(requestParameters, options) {
        return (0, exports.AuthServiceApiFp)(this.configuration).authServiceMerchantBillingChangesRequest(requestParameters.modelMerchantBillingSettlementRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AuthServiceApiAuthServiceRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthServiceApi
     */
    authServiceRegister(requestParameters, options) {
        return (0, exports.AuthServiceApiFp)(this.configuration).authServiceRegister(requestParameters.modelUserRequest, requestParameters.id, requestParameters.avs, requestParameters.isRealtimeVerification, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AuthServiceApi = AuthServiceApi;
/**
 * BankServiceApi - axios parameter creator
 * @export
 */
const BankServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelBankCreateRequest} modelBankCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankServiceCreate: async (modelBankCreateRequest, options = {}) => {
            // verify required parameter 'modelBankCreateRequest' is not null or undefined
            (0, common_1.assertParamExists)('bankServiceCreate', 'modelBankCreateRequest', modelBankCreateRequest);
            const localVarPath = `/v1/banks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelBankCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankServiceDelete: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('bankServiceDelete', 'id', id);
            const localVarPath = `/v1/banks/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankServiceGetMany: async (options = {}) => {
            const localVarPath = `/v1/banks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {ModelBankUpdateRequest} modelBankUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankServiceUpdate: async (id, modelBankUpdateRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('bankServiceUpdate', 'id', id);
            // verify required parameter 'modelBankUpdateRequest' is not null or undefined
            (0, common_1.assertParamExists)('bankServiceUpdate', 'modelBankUpdateRequest', modelBankUpdateRequest);
            const localVarPath = `/v1/banks/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelBankUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.BankServiceApiAxiosParamCreator = BankServiceApiAxiosParamCreator;
/**
 * BankServiceApi - functional programming interface
 * @export
 */
const BankServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.BankServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelBankCreateRequest} modelBankCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankServiceCreate(modelBankCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankServiceCreate(modelBankCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['BankServiceApi.bankServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankServiceDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankServiceDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['BankServiceApi.bankServiceDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankServiceGetMany(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankServiceGetMany(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['BankServiceApi.bankServiceGetMany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {ModelBankUpdateRequest} modelBankUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankServiceUpdate(id, modelBankUpdateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankServiceUpdate(id, modelBankUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['BankServiceApi.bankServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.BankServiceApiFp = BankServiceApiFp;
/**
 * BankServiceApi - factory interface
 * @export
 */
const BankServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.BankServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {BankServiceApiBankServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankServiceCreate(requestParameters, options) {
            return localVarFp.bankServiceCreate(requestParameters.modelBankCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BankServiceApiBankServiceDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankServiceDelete(requestParameters, options) {
            return localVarFp.bankServiceDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankServiceGetMany(options) {
            return localVarFp.bankServiceGetMany(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BankServiceApiBankServiceUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankServiceUpdate(requestParameters, options) {
            return localVarFp.bankServiceUpdate(requestParameters.id, requestParameters.modelBankUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.BankServiceApiFactory = BankServiceApiFactory;
/**
 * BankServiceApi - object-oriented interface
 * @export
 * @class BankServiceApi
 * @extends {BaseAPI}
 */
class BankServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {BankServiceApiBankServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankServiceApi
     */
    bankServiceCreate(requestParameters, options) {
        return (0, exports.BankServiceApiFp)(this.configuration).bankServiceCreate(requestParameters.modelBankCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BankServiceApiBankServiceDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankServiceApi
     */
    bankServiceDelete(requestParameters, options) {
        return (0, exports.BankServiceApiFp)(this.configuration).bankServiceDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankServiceApi
     */
    bankServiceGetMany(options) {
        return (0, exports.BankServiceApiFp)(this.configuration).bankServiceGetMany(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BankServiceApiBankServiceUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankServiceApi
     */
    bankServiceUpdate(requestParameters, options) {
        return (0, exports.BankServiceApiFp)(this.configuration).bankServiceUpdate(requestParameters.id, requestParameters.modelBankUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BankServiceApi = BankServiceApi;
/**
 * BankTransactionServiceApi - axios parameter creator
 * @export
 */
const BankTransactionServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelBankTransactionCreateRequest} modelBankTransactionCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankTransactionServiceCreate: async (modelBankTransactionCreateRequest, options = {}) => {
            // verify required parameter 'modelBankTransactionCreateRequest' is not null or undefined
            (0, common_1.assertParamExists)('bankTransactionServiceCreate', 'modelBankTransactionCreateRequest', modelBankTransactionCreateRequest);
            const localVarPath = `/v1/bank-transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelBankTransactionCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {ModelBankTransactionPaymentRequest} modelBankTransactionPaymentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankTransactionServiceCreatePayment: async (id, modelBankTransactionPaymentRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('bankTransactionServiceCreatePayment', 'id', id);
            // verify required parameter 'modelBankTransactionPaymentRequest' is not null or undefined
            (0, common_1.assertParamExists)('bankTransactionServiceCreatePayment', 'modelBankTransactionPaymentRequest', modelBankTransactionPaymentRequest);
            const localVarPath = `/v1/bank-transactions/{id}/payment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelBankTransactionPaymentRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} bankTransactionBatchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankTransactionServiceLinkBatch: async (ids, bankTransactionBatchId, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('bankTransactionServiceLinkBatch', 'ids', ids);
            // verify required parameter 'bankTransactionBatchId' is not null or undefined
            (0, common_1.assertParamExists)('bankTransactionServiceLinkBatch', 'bankTransactionBatchId', bankTransactionBatchId);
            const localVarPath = `/v1/bank-transactions/link-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (bankTransactionBatchId !== undefined) {
                localVarQueryParameter['bankTransactionBatchId'] = bankTransactionBatchId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelBankTransactionUpdate} modelBankTransactionUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankTransactionServiceUpdate: async (modelBankTransactionUpdate, options = {}) => {
            // verify required parameter 'modelBankTransactionUpdate' is not null or undefined
            (0, common_1.assertParamExists)('bankTransactionServiceUpdate', 'modelBankTransactionUpdate', modelBankTransactionUpdate);
            const localVarPath = `/v1/release-suspense`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelBankTransactionUpdate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.BankTransactionServiceApiAxiosParamCreator = BankTransactionServiceApiAxiosParamCreator;
/**
 * BankTransactionServiceApi - functional programming interface
 * @export
 */
const BankTransactionServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.BankTransactionServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelBankTransactionCreateRequest} modelBankTransactionCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankTransactionServiceCreate(modelBankTransactionCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankTransactionServiceCreate(modelBankTransactionCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['BankTransactionServiceApi.bankTransactionServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {ModelBankTransactionPaymentRequest} modelBankTransactionPaymentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankTransactionServiceCreatePayment(id, modelBankTransactionPaymentRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankTransactionServiceCreatePayment(id, modelBankTransactionPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['BankTransactionServiceApi.bankTransactionServiceCreatePayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} bankTransactionBatchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankTransactionServiceLinkBatch(ids, bankTransactionBatchId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankTransactionServiceLinkBatch(ids, bankTransactionBatchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['BankTransactionServiceApi.bankTransactionServiceLinkBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelBankTransactionUpdate} modelBankTransactionUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankTransactionServiceUpdate(modelBankTransactionUpdate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankTransactionServiceUpdate(modelBankTransactionUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['BankTransactionServiceApi.bankTransactionServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.BankTransactionServiceApiFp = BankTransactionServiceApiFp;
/**
 * BankTransactionServiceApi - factory interface
 * @export
 */
const BankTransactionServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.BankTransactionServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {BankTransactionServiceApiBankTransactionServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankTransactionServiceCreate(requestParameters, options) {
            return localVarFp.bankTransactionServiceCreate(requestParameters.modelBankTransactionCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BankTransactionServiceApiBankTransactionServiceCreatePaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankTransactionServiceCreatePayment(requestParameters, options) {
            return localVarFp.bankTransactionServiceCreatePayment(requestParameters.id, requestParameters.modelBankTransactionPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BankTransactionServiceApiBankTransactionServiceLinkBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankTransactionServiceLinkBatch(requestParameters, options) {
            return localVarFp.bankTransactionServiceLinkBatch(requestParameters.ids, requestParameters.bankTransactionBatchId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BankTransactionServiceApiBankTransactionServiceUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankTransactionServiceUpdate(requestParameters, options) {
            return localVarFp.bankTransactionServiceUpdate(requestParameters.modelBankTransactionUpdate, options).then((request) => request(axios, basePath));
        },
    };
};
exports.BankTransactionServiceApiFactory = BankTransactionServiceApiFactory;
/**
 * BankTransactionServiceApi - object-oriented interface
 * @export
 * @class BankTransactionServiceApi
 * @extends {BaseAPI}
 */
class BankTransactionServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {BankTransactionServiceApiBankTransactionServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTransactionServiceApi
     */
    bankTransactionServiceCreate(requestParameters, options) {
        return (0, exports.BankTransactionServiceApiFp)(this.configuration).bankTransactionServiceCreate(requestParameters.modelBankTransactionCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BankTransactionServiceApiBankTransactionServiceCreatePaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTransactionServiceApi
     */
    bankTransactionServiceCreatePayment(requestParameters, options) {
        return (0, exports.BankTransactionServiceApiFp)(this.configuration).bankTransactionServiceCreatePayment(requestParameters.id, requestParameters.modelBankTransactionPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BankTransactionServiceApiBankTransactionServiceLinkBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTransactionServiceApi
     */
    bankTransactionServiceLinkBatch(requestParameters, options) {
        return (0, exports.BankTransactionServiceApiFp)(this.configuration).bankTransactionServiceLinkBatch(requestParameters.ids, requestParameters.bankTransactionBatchId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BankTransactionServiceApiBankTransactionServiceUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTransactionServiceApi
     */
    bankTransactionServiceUpdate(requestParameters, options) {
        return (0, exports.BankTransactionServiceApiFp)(this.configuration).bankTransactionServiceUpdate(requestParameters.modelBankTransactionUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BankTransactionServiceApi = BankTransactionServiceApi;
/**
 * CardServiceApi - axios parameter creator
 * @export
 */
const CardServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelCardRequest} modelCardRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardServiceCreate: async (modelCardRequest, id, options = {}) => {
            // verify required parameter 'modelCardRequest' is not null or undefined
            (0, common_1.assertParamExists)('cardServiceCreate', 'modelCardRequest', modelCardRequest);
            const localVarPath = `/v1/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelCardRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardServiceGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('cardServiceGet', 'id', id);
            const localVarPath = `/v1/cards/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardServiceGetMany: async (limit, options = {}) => {
            const localVarPath = `/v1/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardServiceRemove: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('cardServiceRemove', 'id', id);
            const localVarPath = `/v1/cards/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {ModelCardRequest} modelCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardServiceUpdate: async (id, modelCardRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('cardServiceUpdate', 'id', id);
            // verify required parameter 'modelCardRequest' is not null or undefined
            (0, common_1.assertParamExists)('cardServiceUpdate', 'modelCardRequest', modelCardRequest);
            const localVarPath = `/v1/cards/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelCardRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CardServiceApiAxiosParamCreator = CardServiceApiAxiosParamCreator;
/**
 * CardServiceApi - functional programming interface
 * @export
 */
const CardServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CardServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelCardRequest} modelCardRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardServiceCreate(modelCardRequest, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardServiceCreate(modelCardRequest, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['CardServiceApi.cardServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardServiceGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardServiceGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['CardServiceApi.cardServiceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardServiceGetMany(limit, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardServiceGetMany(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['CardServiceApi.cardServiceGetMany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardServiceRemove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardServiceRemove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['CardServiceApi.cardServiceRemove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {ModelCardRequest} modelCardRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cardServiceUpdate(id, modelCardRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cardServiceUpdate(id, modelCardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['CardServiceApi.cardServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.CardServiceApiFp = CardServiceApiFp;
/**
 * CardServiceApi - factory interface
 * @export
 */
const CardServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CardServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {CardServiceApiCardServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardServiceCreate(requestParameters, options) {
            return localVarFp.cardServiceCreate(requestParameters.modelCardRequest, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CardServiceApiCardServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardServiceGet(requestParameters, options) {
            return localVarFp.cardServiceGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CardServiceApiCardServiceGetManyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardServiceGetMany(requestParameters = {}, options) {
            return localVarFp.cardServiceGetMany(requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CardServiceApiCardServiceRemoveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardServiceRemove(requestParameters, options) {
            return localVarFp.cardServiceRemove(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CardServiceApiCardServiceUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cardServiceUpdate(requestParameters, options) {
            return localVarFp.cardServiceUpdate(requestParameters.id, requestParameters.modelCardRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CardServiceApiFactory = CardServiceApiFactory;
/**
 * CardServiceApi - object-oriented interface
 * @export
 * @class CardServiceApi
 * @extends {BaseAPI}
 */
class CardServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {CardServiceApiCardServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceApi
     */
    cardServiceCreate(requestParameters, options) {
        return (0, exports.CardServiceApiFp)(this.configuration).cardServiceCreate(requestParameters.modelCardRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CardServiceApiCardServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceApi
     */
    cardServiceGet(requestParameters, options) {
        return (0, exports.CardServiceApiFp)(this.configuration).cardServiceGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CardServiceApiCardServiceGetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceApi
     */
    cardServiceGetMany(requestParameters = {}, options) {
        return (0, exports.CardServiceApiFp)(this.configuration).cardServiceGetMany(requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CardServiceApiCardServiceRemoveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceApi
     */
    cardServiceRemove(requestParameters, options) {
        return (0, exports.CardServiceApiFp)(this.configuration).cardServiceRemove(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CardServiceApiCardServiceUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceApi
     */
    cardServiceUpdate(requestParameters, options) {
        return (0, exports.CardServiceApiFp)(this.configuration).cardServiceUpdate(requestParameters.id, requestParameters.modelCardRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CardServiceApi = CardServiceApi;
/**
 * ConnectorServiceApi - axios parameter creator
 * @export
 */
const ConnectorServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} paymentProviderPaymentId
         * @param {ModelConnectorRequest} modelConnectorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectorServiceUpdate: async (paymentProviderPaymentId, modelConnectorRequest, options = {}) => {
            // verify required parameter 'paymentProviderPaymentId' is not null or undefined
            (0, common_1.assertParamExists)('connectorServiceUpdate', 'paymentProviderPaymentId', paymentProviderPaymentId);
            // verify required parameter 'modelConnectorRequest' is not null or undefined
            (0, common_1.assertParamExists)('connectorServiceUpdate', 'modelConnectorRequest', modelConnectorRequest);
            const localVarPath = `/v1/connectors/{paymentProviderPaymentId}`
                .replace(`{${"paymentProviderPaymentId"}}`, encodeURIComponent(String(paymentProviderPaymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelConnectorRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ConnectorServiceApiAxiosParamCreator = ConnectorServiceApiAxiosParamCreator;
/**
 * ConnectorServiceApi - functional programming interface
 * @export
 */
const ConnectorServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ConnectorServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} paymentProviderPaymentId
         * @param {ModelConnectorRequest} modelConnectorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectorServiceUpdate(paymentProviderPaymentId, modelConnectorRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectorServiceUpdate(paymentProviderPaymentId, modelConnectorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['ConnectorServiceApi.connectorServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.ConnectorServiceApiFp = ConnectorServiceApiFp;
/**
 * ConnectorServiceApi - factory interface
 * @export
 */
const ConnectorServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ConnectorServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {ConnectorServiceApiConnectorServiceUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectorServiceUpdate(requestParameters, options) {
            return localVarFp.connectorServiceUpdate(requestParameters.paymentProviderPaymentId, requestParameters.modelConnectorRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ConnectorServiceApiFactory = ConnectorServiceApiFactory;
/**
 * ConnectorServiceApi - object-oriented interface
 * @export
 * @class ConnectorServiceApi
 * @extends {BaseAPI}
 */
class ConnectorServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {ConnectorServiceApiConnectorServiceUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectorServiceApi
     */
    connectorServiceUpdate(requestParameters, options) {
        return (0, exports.ConnectorServiceApiFp)(this.configuration).connectorServiceUpdate(requestParameters.paymentProviderPaymentId, requestParameters.modelConnectorRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ConnectorServiceApi = ConnectorServiceApi;
/**
 * DebiCheckServiceApi - axios parameter creator
 * @export
 */
const DebiCheckServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelDebiCheckRequest} modelDebiCheckRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debiCheckServiceCreate: async (modelDebiCheckRequest, id, options = {}) => {
            // verify required parameter 'modelDebiCheckRequest' is not null or undefined
            (0, common_1.assertParamExists)('debiCheckServiceCreate', 'modelDebiCheckRequest', modelDebiCheckRequest);
            const localVarPath = `/v2/debi-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelDebiCheckRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelDebiCheckCollectionRequest} modelDebiCheckCollectionRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debiCheckServiceCreateCollection: async (modelDebiCheckCollectionRequest, id, options = {}) => {
            // verify required parameter 'modelDebiCheckCollectionRequest' is not null or undefined
            (0, common_1.assertParamExists)('debiCheckServiceCreateCollection', 'modelDebiCheckCollectionRequest', modelDebiCheckCollectionRequest);
            const localVarPath = `/v1/debicheck/collection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelDebiCheckCollectionRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelDebiCheckRequestLegacy} modelDebiCheckRequestLegacy
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debiCheckServiceCreateLegacy: async (modelDebiCheckRequestLegacy, id, options = {}) => {
            // verify required parameter 'modelDebiCheckRequestLegacy' is not null or undefined
            (0, common_1.assertParamExists)('debiCheckServiceCreateLegacy', 'modelDebiCheckRequestLegacy', modelDebiCheckRequestLegacy);
            const localVarPath = `/v1/debicheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelDebiCheckRequestLegacy, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debiCheckServiceGetMandate: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('debiCheckServiceGetMandate', 'id', id);
            const localVarPath = `/v1/debicheck/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debiCheckServiceGetMandateList: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('debiCheckServiceGetMandateList', 'id', id);
            const localVarPath = `/v1/debicheck/list/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [due]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debiCheckServiceGetManyCollection: async (due, options = {}) => {
            const localVarPath = `/v1/debicheck/collection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (due !== undefined) {
                localVarQueryParameter['due'] = due;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DebiCheckServiceApiAxiosParamCreator = DebiCheckServiceApiAxiosParamCreator;
/**
 * DebiCheckServiceApi - functional programming interface
 * @export
 */
const DebiCheckServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DebiCheckServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelDebiCheckRequest} modelDebiCheckRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debiCheckServiceCreate(modelDebiCheckRequest, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.debiCheckServiceCreate(modelDebiCheckRequest, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DebiCheckServiceApi.debiCheckServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelDebiCheckCollectionRequest} modelDebiCheckCollectionRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debiCheckServiceCreateCollection(modelDebiCheckCollectionRequest, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.debiCheckServiceCreateCollection(modelDebiCheckCollectionRequest, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DebiCheckServiceApi.debiCheckServiceCreateCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelDebiCheckRequestLegacy} modelDebiCheckRequestLegacy
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debiCheckServiceCreateLegacy(modelDebiCheckRequestLegacy, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.debiCheckServiceCreateLegacy(modelDebiCheckRequestLegacy, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DebiCheckServiceApi.debiCheckServiceCreateLegacy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debiCheckServiceGetMandate(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.debiCheckServiceGetMandate(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DebiCheckServiceApi.debiCheckServiceGetMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debiCheckServiceGetMandateList(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.debiCheckServiceGetMandateList(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DebiCheckServiceApi.debiCheckServiceGetMandateList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [due]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debiCheckServiceGetManyCollection(due, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.debiCheckServiceGetManyCollection(due, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DebiCheckServiceApi.debiCheckServiceGetManyCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.DebiCheckServiceApiFp = DebiCheckServiceApiFp;
/**
 * DebiCheckServiceApi - factory interface
 * @export
 */
const DebiCheckServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DebiCheckServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {DebiCheckServiceApiDebiCheckServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debiCheckServiceCreate(requestParameters, options) {
            return localVarFp.debiCheckServiceCreate(requestParameters.modelDebiCheckRequest, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DebiCheckServiceApiDebiCheckServiceCreateCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debiCheckServiceCreateCollection(requestParameters, options) {
            return localVarFp.debiCheckServiceCreateCollection(requestParameters.modelDebiCheckCollectionRequest, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DebiCheckServiceApiDebiCheckServiceCreateLegacyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debiCheckServiceCreateLegacy(requestParameters, options) {
            return localVarFp.debiCheckServiceCreateLegacy(requestParameters.modelDebiCheckRequestLegacy, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DebiCheckServiceApiDebiCheckServiceGetMandateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debiCheckServiceGetMandate(requestParameters, options) {
            return localVarFp.debiCheckServiceGetMandate(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DebiCheckServiceApiDebiCheckServiceGetMandateListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debiCheckServiceGetMandateList(requestParameters, options) {
            return localVarFp.debiCheckServiceGetMandateList(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DebiCheckServiceApiDebiCheckServiceGetManyCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debiCheckServiceGetManyCollection(requestParameters = {}, options) {
            return localVarFp.debiCheckServiceGetManyCollection(requestParameters.due, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DebiCheckServiceApiFactory = DebiCheckServiceApiFactory;
/**
 * DebiCheckServiceApi - object-oriented interface
 * @export
 * @class DebiCheckServiceApi
 * @extends {BaseAPI}
 */
class DebiCheckServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {DebiCheckServiceApiDebiCheckServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebiCheckServiceApi
     */
    debiCheckServiceCreate(requestParameters, options) {
        return (0, exports.DebiCheckServiceApiFp)(this.configuration).debiCheckServiceCreate(requestParameters.modelDebiCheckRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DebiCheckServiceApiDebiCheckServiceCreateCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebiCheckServiceApi
     */
    debiCheckServiceCreateCollection(requestParameters, options) {
        return (0, exports.DebiCheckServiceApiFp)(this.configuration).debiCheckServiceCreateCollection(requestParameters.modelDebiCheckCollectionRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DebiCheckServiceApiDebiCheckServiceCreateLegacyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebiCheckServiceApi
     */
    debiCheckServiceCreateLegacy(requestParameters, options) {
        return (0, exports.DebiCheckServiceApiFp)(this.configuration).debiCheckServiceCreateLegacy(requestParameters.modelDebiCheckRequestLegacy, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DebiCheckServiceApiDebiCheckServiceGetMandateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebiCheckServiceApi
     */
    debiCheckServiceGetMandate(requestParameters, options) {
        return (0, exports.DebiCheckServiceApiFp)(this.configuration).debiCheckServiceGetMandate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DebiCheckServiceApiDebiCheckServiceGetMandateListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebiCheckServiceApi
     */
    debiCheckServiceGetMandateList(requestParameters, options) {
        return (0, exports.DebiCheckServiceApiFp)(this.configuration).debiCheckServiceGetMandateList(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DebiCheckServiceApiDebiCheckServiceGetManyCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebiCheckServiceApi
     */
    debiCheckServiceGetManyCollection(requestParameters = {}, options) {
        return (0, exports.DebiCheckServiceApiFp)(this.configuration).debiCheckServiceGetManyCollection(requestParameters.due, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DebiCheckServiceApi = DebiCheckServiceApi;
/**
 * DebitOrderMandateServiceApi - axios parameter creator
 * @export
 */
const DebitOrderMandateServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelDebitOrderMandateCreateRequest} modelDebitOrderMandateCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debitOrderMandateServiceCreate: async (modelDebitOrderMandateCreateRequest, options = {}) => {
            // verify required parameter 'modelDebitOrderMandateCreateRequest' is not null or undefined
            (0, common_1.assertParamExists)('debitOrderMandateServiceCreate', 'modelDebitOrderMandateCreateRequest', modelDebitOrderMandateCreateRequest);
            const localVarPath = `/v1/debit-order-mandates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelDebitOrderMandateCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} merchantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debitOrderMandateServiceGet: async (merchantId, options = {}) => {
            // verify required parameter 'merchantId' is not null or undefined
            (0, common_1.assertParamExists)('debitOrderMandateServiceGet', 'merchantId', merchantId);
            const localVarPath = `/v1/merchants/{merchantId}/debit-order-mandates`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DebitOrderMandateServiceApiAxiosParamCreator = DebitOrderMandateServiceApiAxiosParamCreator;
/**
 * DebitOrderMandateServiceApi - functional programming interface
 * @export
 */
const DebitOrderMandateServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DebitOrderMandateServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelDebitOrderMandateCreateRequest} modelDebitOrderMandateCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debitOrderMandateServiceCreate(modelDebitOrderMandateCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.debitOrderMandateServiceCreate(modelDebitOrderMandateCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DebitOrderMandateServiceApi.debitOrderMandateServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} merchantId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async debitOrderMandateServiceGet(merchantId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.debitOrderMandateServiceGet(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DebitOrderMandateServiceApi.debitOrderMandateServiceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.DebitOrderMandateServiceApiFp = DebitOrderMandateServiceApiFp;
/**
 * DebitOrderMandateServiceApi - factory interface
 * @export
 */
const DebitOrderMandateServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DebitOrderMandateServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {DebitOrderMandateServiceApiDebitOrderMandateServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debitOrderMandateServiceCreate(requestParameters, options) {
            return localVarFp.debitOrderMandateServiceCreate(requestParameters.modelDebitOrderMandateCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DebitOrderMandateServiceApiDebitOrderMandateServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        debitOrderMandateServiceGet(requestParameters, options) {
            return localVarFp.debitOrderMandateServiceGet(requestParameters.merchantId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DebitOrderMandateServiceApiFactory = DebitOrderMandateServiceApiFactory;
/**
 * DebitOrderMandateServiceApi - object-oriented interface
 * @export
 * @class DebitOrderMandateServiceApi
 * @extends {BaseAPI}
 */
class DebitOrderMandateServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {DebitOrderMandateServiceApiDebitOrderMandateServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebitOrderMandateServiceApi
     */
    debitOrderMandateServiceCreate(requestParameters, options) {
        return (0, exports.DebitOrderMandateServiceApiFp)(this.configuration).debitOrderMandateServiceCreate(requestParameters.modelDebitOrderMandateCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DebitOrderMandateServiceApiDebitOrderMandateServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebitOrderMandateServiceApi
     */
    debitOrderMandateServiceGet(requestParameters, options) {
        return (0, exports.DebitOrderMandateServiceApiFp)(this.configuration).debitOrderMandateServiceGet(requestParameters.merchantId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DebitOrderMandateServiceApi = DebitOrderMandateServiceApi;
/**
 * EmailServiceApi - axios parameter creator
 * @export
 */
const EmailServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelEmailBody} modelEmailBody
         * @param {Array<string>} [emails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailServiceSendEmail: async (modelEmailBody, emails, options = {}) => {
            // verify required parameter 'modelEmailBody' is not null or undefined
            (0, common_1.assertParamExists)('emailServiceSendEmail', 'modelEmailBody', modelEmailBody);
            const localVarPath = `/v1/emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (emails) {
                localVarQueryParameter['emails'] = emails;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelEmailBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.EmailServiceApiAxiosParamCreator = EmailServiceApiAxiosParamCreator;
/**
 * EmailServiceApi - functional programming interface
 * @export
 */
const EmailServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EmailServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelEmailBody} modelEmailBody
         * @param {Array<string>} [emails]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailServiceSendEmail(modelEmailBody, emails, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailServiceSendEmail(modelEmailBody, emails, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['EmailServiceApi.emailServiceSendEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.EmailServiceApiFp = EmailServiceApiFp;
/**
 * EmailServiceApi - factory interface
 * @export
 */
const EmailServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EmailServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {EmailServiceApiEmailServiceSendEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailServiceSendEmail(requestParameters, options) {
            return localVarFp.emailServiceSendEmail(requestParameters.modelEmailBody, requestParameters.emails, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EmailServiceApiFactory = EmailServiceApiFactory;
/**
 * EmailServiceApi - object-oriented interface
 * @export
 * @class EmailServiceApi
 * @extends {BaseAPI}
 */
class EmailServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {EmailServiceApiEmailServiceSendEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailServiceApi
     */
    emailServiceSendEmail(requestParameters, options) {
        return (0, exports.EmailServiceApiFp)(this.configuration).emailServiceSendEmail(requestParameters.modelEmailBody, requestParameters.emails, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmailServiceApi = EmailServiceApi;
/**
 * IntegrationServiceApi - axios parameter creator
 * @export
 */
const IntegrationServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} cellNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationServiceGetCueOrders: async (cellNumber, options = {}) => {
            // verify required parameter 'cellNumber' is not null or undefined
            (0, common_1.assertParamExists)('integrationServiceGetCueOrders', 'cellNumber', cellNumber);
            const localVarPath = `/v1/integrations/cue/user/{cellNumber}/orders`
                .replace(`{${"cellNumber"}}`, encodeURIComponent(String(cellNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.IntegrationServiceApiAxiosParamCreator = IntegrationServiceApiAxiosParamCreator;
/**
 * IntegrationServiceApi - functional programming interface
 * @export
 */
const IntegrationServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.IntegrationServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} cellNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationServiceGetCueOrders(cellNumber, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationServiceGetCueOrders(cellNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['IntegrationServiceApi.integrationServiceGetCueOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.IntegrationServiceApiFp = IntegrationServiceApiFp;
/**
 * IntegrationServiceApi - factory interface
 * @export
 */
const IntegrationServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.IntegrationServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {IntegrationServiceApiIntegrationServiceGetCueOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationServiceGetCueOrders(requestParameters, options) {
            return localVarFp.integrationServiceGetCueOrders(requestParameters.cellNumber, options).then((request) => request(axios, basePath));
        },
    };
};
exports.IntegrationServiceApiFactory = IntegrationServiceApiFactory;
/**
 * IntegrationServiceApi - object-oriented interface
 * @export
 * @class IntegrationServiceApi
 * @extends {BaseAPI}
 */
class IntegrationServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {IntegrationServiceApiIntegrationServiceGetCueOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationServiceApi
     */
    integrationServiceGetCueOrders(requestParameters, options) {
        return (0, exports.IntegrationServiceApiFp)(this.configuration).integrationServiceGetCueOrders(requestParameters.cellNumber, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.IntegrationServiceApi = IntegrationServiceApi;
/**
 * InvoicesServiceApi - axios parameter creator
 * @export
 */
const InvoicesServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelDateTimeRange} modelDateTimeRange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceCreate: async (modelDateTimeRange, options = {}) => {
            // verify required parameter 'modelDateTimeRange' is not null or undefined
            (0, common_1.assertParamExists)('invoicesServiceCreate', 'modelDateTimeRange', modelDateTimeRange);
            const localVarPath = `/v1/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelDateTimeRange, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelInvoiceFeesCreateRequest} modelInvoiceFeesCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceCreateByFees: async (modelInvoiceFeesCreateRequest, options = {}) => {
            // verify required parameter 'modelInvoiceFeesCreateRequest' is not null or undefined
            (0, common_1.assertParamExists)('invoicesServiceCreateByFees', 'modelInvoiceFeesCreateRequest', modelInvoiceFeesCreateRequest);
            const localVarPath = `/v1/invoices/fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelInvoiceFeesCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceGetInvoiceById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('invoicesServiceGetInvoiceById', 'id', id);
            const localVarPath = `/v1/invoices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceGetInvoiceReportById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('invoicesServiceGetInvoiceReportById', 'id', id);
            const localVarPath = `/v1/invoices/{id}/report`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {string} [reference]
         * @param {string} [status]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceGetMany: async (from, to, reference, status, limit, skip, options = {}) => {
            const localVarPath = `/v1/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (reference !== undefined) {
                localVarQueryParameter['reference'] = reference;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceGetPdf: async (id, options = {}) => {
            const localVarPath = `/v1/invoices/:id/pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelInvoiceUpdateRequest} modelInvoiceUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceUpdate: async (modelInvoiceUpdateRequest, options = {}) => {
            // verify required parameter 'modelInvoiceUpdateRequest' is not null or undefined
            (0, common_1.assertParamExists)('invoicesServiceUpdate', 'modelInvoiceUpdateRequest', modelInvoiceUpdateRequest);
            const localVarPath = `/v1/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelInvoiceUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {ModelInvoiceUpdatePdfRequest} modelInvoiceUpdatePdfRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceUpdatePdf: async (id, modelInvoiceUpdatePdfRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('invoicesServiceUpdatePdf', 'id', id);
            // verify required parameter 'modelInvoiceUpdatePdfRequest' is not null or undefined
            (0, common_1.assertParamExists)('invoicesServiceUpdatePdf', 'modelInvoiceUpdatePdfRequest', modelInvoiceUpdatePdfRequest);
            const localVarPath = `/v1/invoice/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelInvoiceUpdatePdfRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.InvoicesServiceApiAxiosParamCreator = InvoicesServiceApiAxiosParamCreator;
/**
 * InvoicesServiceApi - functional programming interface
 * @export
 */
const InvoicesServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.InvoicesServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelDateTimeRange} modelDateTimeRange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoicesServiceCreate(modelDateTimeRange, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoicesServiceCreate(modelDateTimeRange, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['InvoicesServiceApi.invoicesServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelInvoiceFeesCreateRequest} modelInvoiceFeesCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoicesServiceCreateByFees(modelInvoiceFeesCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoicesServiceCreateByFees(modelInvoiceFeesCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['InvoicesServiceApi.invoicesServiceCreateByFees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoicesServiceGetInvoiceById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoicesServiceGetInvoiceById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['InvoicesServiceApi.invoicesServiceGetInvoiceById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoicesServiceGetInvoiceReportById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoicesServiceGetInvoiceReportById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['InvoicesServiceApi.invoicesServiceGetInvoiceReportById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {string} [reference]
         * @param {string} [status]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoicesServiceGetMany(from, to, reference, status, limit, skip, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoicesServiceGetMany(from, to, reference, status, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['InvoicesServiceApi.invoicesServiceGetMany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoicesServiceGetPdf(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoicesServiceGetPdf(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['InvoicesServiceApi.invoicesServiceGetPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelInvoiceUpdateRequest} modelInvoiceUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoicesServiceUpdate(modelInvoiceUpdateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoicesServiceUpdate(modelInvoiceUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['InvoicesServiceApi.invoicesServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {ModelInvoiceUpdatePdfRequest} modelInvoiceUpdatePdfRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoicesServiceUpdatePdf(id, modelInvoiceUpdatePdfRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoicesServiceUpdatePdf(id, modelInvoiceUpdatePdfRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['InvoicesServiceApi.invoicesServiceUpdatePdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.InvoicesServiceApiFp = InvoicesServiceApiFp;
/**
 * InvoicesServiceApi - factory interface
 * @export
 */
const InvoicesServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.InvoicesServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {InvoicesServiceApiInvoicesServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceCreate(requestParameters, options) {
            return localVarFp.invoicesServiceCreate(requestParameters.modelDateTimeRange, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InvoicesServiceApiInvoicesServiceCreateByFeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceCreateByFees(requestParameters, options) {
            return localVarFp.invoicesServiceCreateByFees(requestParameters.modelInvoiceFeesCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InvoicesServiceApiInvoicesServiceGetInvoiceByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceGetInvoiceById(requestParameters, options) {
            return localVarFp.invoicesServiceGetInvoiceById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InvoicesServiceApiInvoicesServiceGetInvoiceReportByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceGetInvoiceReportById(requestParameters, options) {
            return localVarFp.invoicesServiceGetInvoiceReportById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InvoicesServiceApiInvoicesServiceGetManyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceGetMany(requestParameters = {}, options) {
            return localVarFp.invoicesServiceGetMany(requestParameters.from, requestParameters.to, requestParameters.reference, requestParameters.status, requestParameters.limit, requestParameters.skip, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InvoicesServiceApiInvoicesServiceGetPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceGetPdf(requestParameters = {}, options) {
            return localVarFp.invoicesServiceGetPdf(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InvoicesServiceApiInvoicesServiceUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceUpdate(requestParameters, options) {
            return localVarFp.invoicesServiceUpdate(requestParameters.modelInvoiceUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InvoicesServiceApiInvoicesServiceUpdatePdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicesServiceUpdatePdf(requestParameters, options) {
            return localVarFp.invoicesServiceUpdatePdf(requestParameters.id, requestParameters.modelInvoiceUpdatePdfRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.InvoicesServiceApiFactory = InvoicesServiceApiFactory;
/**
 * InvoicesServiceApi - object-oriented interface
 * @export
 * @class InvoicesServiceApi
 * @extends {BaseAPI}
 */
class InvoicesServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {InvoicesServiceApiInvoicesServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesServiceApi
     */
    invoicesServiceCreate(requestParameters, options) {
        return (0, exports.InvoicesServiceApiFp)(this.configuration).invoicesServiceCreate(requestParameters.modelDateTimeRange, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InvoicesServiceApiInvoicesServiceCreateByFeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesServiceApi
     */
    invoicesServiceCreateByFees(requestParameters, options) {
        return (0, exports.InvoicesServiceApiFp)(this.configuration).invoicesServiceCreateByFees(requestParameters.modelInvoiceFeesCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InvoicesServiceApiInvoicesServiceGetInvoiceByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesServiceApi
     */
    invoicesServiceGetInvoiceById(requestParameters, options) {
        return (0, exports.InvoicesServiceApiFp)(this.configuration).invoicesServiceGetInvoiceById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InvoicesServiceApiInvoicesServiceGetInvoiceReportByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesServiceApi
     */
    invoicesServiceGetInvoiceReportById(requestParameters, options) {
        return (0, exports.InvoicesServiceApiFp)(this.configuration).invoicesServiceGetInvoiceReportById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InvoicesServiceApiInvoicesServiceGetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesServiceApi
     */
    invoicesServiceGetMany(requestParameters = {}, options) {
        return (0, exports.InvoicesServiceApiFp)(this.configuration).invoicesServiceGetMany(requestParameters.from, requestParameters.to, requestParameters.reference, requestParameters.status, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InvoicesServiceApiInvoicesServiceGetPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesServiceApi
     */
    invoicesServiceGetPdf(requestParameters = {}, options) {
        return (0, exports.InvoicesServiceApiFp)(this.configuration).invoicesServiceGetPdf(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InvoicesServiceApiInvoicesServiceUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesServiceApi
     */
    invoicesServiceUpdate(requestParameters, options) {
        return (0, exports.InvoicesServiceApiFp)(this.configuration).invoicesServiceUpdate(requestParameters.modelInvoiceUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InvoicesServiceApiInvoicesServiceUpdatePdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesServiceApi
     */
    invoicesServiceUpdatePdf(requestParameters, options) {
        return (0, exports.InvoicesServiceApiFp)(this.configuration).invoicesServiceUpdatePdf(requestParameters.id, requestParameters.modelInvoiceUpdatePdfRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.InvoicesServiceApi = InvoicesServiceApi;
/**
 * JournalFeeServiceApi - axios parameter creator
 * @export
 */
const JournalFeeServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelJournalFeeResponse} modelJournalFeeResponse
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        journalFeeServiceCreate: async (modelJournalFeeResponse, id, options = {}) => {
            // verify required parameter 'modelJournalFeeResponse' is not null or undefined
            (0, common_1.assertParamExists)('journalFeeServiceCreate', 'modelJournalFeeResponse', modelJournalFeeResponse);
            const localVarPath = `/v1/journal-fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelJournalFeeResponse, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.JournalFeeServiceApiAxiosParamCreator = JournalFeeServiceApiAxiosParamCreator;
/**
 * JournalFeeServiceApi - functional programming interface
 * @export
 */
const JournalFeeServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.JournalFeeServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelJournalFeeResponse} modelJournalFeeResponse
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async journalFeeServiceCreate(modelJournalFeeResponse, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.journalFeeServiceCreate(modelJournalFeeResponse, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['JournalFeeServiceApi.journalFeeServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.JournalFeeServiceApiFp = JournalFeeServiceApiFp;
/**
 * JournalFeeServiceApi - factory interface
 * @export
 */
const JournalFeeServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.JournalFeeServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {JournalFeeServiceApiJournalFeeServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        journalFeeServiceCreate(requestParameters, options) {
            return localVarFp.journalFeeServiceCreate(requestParameters.modelJournalFeeResponse, requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
exports.JournalFeeServiceApiFactory = JournalFeeServiceApiFactory;
/**
 * JournalFeeServiceApi - object-oriented interface
 * @export
 * @class JournalFeeServiceApi
 * @extends {BaseAPI}
 */
class JournalFeeServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {JournalFeeServiceApiJournalFeeServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalFeeServiceApi
     */
    journalFeeServiceCreate(requestParameters, options) {
        return (0, exports.JournalFeeServiceApiFp)(this.configuration).journalFeeServiceCreate(requestParameters.modelJournalFeeResponse, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.JournalFeeServiceApi = JournalFeeServiceApi;
/**
 * JournalServiceApi - axios parameter creator
 * @export
 */
const JournalServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelJournalRequest} modelJournalRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        journalServiceCreate: async (modelJournalRequest, id, options = {}) => {
            // verify required parameter 'modelJournalRequest' is not null or undefined
            (0, common_1.assertParamExists)('journalServiceCreate', 'modelJournalRequest', modelJournalRequest);
            const localVarPath = `/v1/journals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelJournalRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.JournalServiceApiAxiosParamCreator = JournalServiceApiAxiosParamCreator;
/**
 * JournalServiceApi - functional programming interface
 * @export
 */
const JournalServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.JournalServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelJournalRequest} modelJournalRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async journalServiceCreate(modelJournalRequest, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.journalServiceCreate(modelJournalRequest, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['JournalServiceApi.journalServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.JournalServiceApiFp = JournalServiceApiFp;
/**
 * JournalServiceApi - factory interface
 * @export
 */
const JournalServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.JournalServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {JournalServiceApiJournalServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        journalServiceCreate(requestParameters, options) {
            return localVarFp.journalServiceCreate(requestParameters.modelJournalRequest, requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
exports.JournalServiceApiFactory = JournalServiceApiFactory;
/**
 * JournalServiceApi - object-oriented interface
 * @export
 * @class JournalServiceApi
 * @extends {BaseAPI}
 */
class JournalServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {JournalServiceApiJournalServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalServiceApi
     */
    journalServiceCreate(requestParameters, options) {
        return (0, exports.JournalServiceApiFp)(this.configuration).journalServiceCreate(requestParameters.modelJournalRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.JournalServiceApi = JournalServiceApi;
/**
 * MerchantServiceApi - axios parameter creator
 * @export
 */
const MerchantServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelMerchantRequest} modelMerchantRequest
         * @param {string} [id]
         * @param {string} [avs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceCreate: async (modelMerchantRequest, id, avs, options = {}) => {
            // verify required parameter 'modelMerchantRequest' is not null or undefined
            (0, common_1.assertParamExists)('merchantServiceCreate', 'modelMerchantRequest', modelMerchantRequest);
            const localVarPath = `/v1/merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            if (avs !== undefined) {
                localVarQueryParameter['avs'] = avs;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelMerchantRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceDel: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('merchantServiceDel', 'id', id);
            const localVarPath = `/v1/merchants/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('merchantServiceGet', 'id', id);
            const localVarPath = `/v1/merchants/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceGetMerchantsToSettle: async (options = {}) => {
            const localVarPath = `/v1/merchants-to-settle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [featured]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceGetShops: async (featured, options = {}) => {
            const localVarPath = `/v1/merchants/shop-directory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (featured !== undefined) {
                localVarQueryParameter['featured'] = featured;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceGetShopsV2: async (options = {}) => {
            const localVarPath = `/v2/merchants/shop-directory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {ModelMerchantRequest} modelMerchantRequest
         * @param {string} [avs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceUpdate: async (id, modelMerchantRequest, avs, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('merchantServiceUpdate', 'id', id);
            // verify required parameter 'modelMerchantRequest' is not null or undefined
            (0, common_1.assertParamExists)('merchantServiceUpdate', 'modelMerchantRequest', modelMerchantRequest);
            const localVarPath = `/v1/merchants/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (avs !== undefined) {
                localVarQueryParameter['avs'] = avs;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelMerchantRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MerchantServiceApiAxiosParamCreator = MerchantServiceApiAxiosParamCreator;
/**
 * MerchantServiceApi - functional programming interface
 * @export
 */
const MerchantServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.MerchantServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelMerchantRequest} modelMerchantRequest
         * @param {string} [id]
         * @param {string} [avs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantServiceCreate(modelMerchantRequest, id, avs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merchantServiceCreate(modelMerchantRequest, id, avs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['MerchantServiceApi.merchantServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantServiceDel(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merchantServiceDel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['MerchantServiceApi.merchantServiceDel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantServiceGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merchantServiceGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['MerchantServiceApi.merchantServiceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantServiceGetMerchantsToSettle(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merchantServiceGetMerchantsToSettle(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['MerchantServiceApi.merchantServiceGetMerchantsToSettle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {boolean} [featured]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantServiceGetShops(featured, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merchantServiceGetShops(featured, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['MerchantServiceApi.merchantServiceGetShops']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantServiceGetShopsV2(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merchantServiceGetShopsV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['MerchantServiceApi.merchantServiceGetShopsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {ModelMerchantRequest} modelMerchantRequest
         * @param {string} [avs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantServiceUpdate(id, modelMerchantRequest, avs, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merchantServiceUpdate(id, modelMerchantRequest, avs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['MerchantServiceApi.merchantServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.MerchantServiceApiFp = MerchantServiceApiFp;
/**
 * MerchantServiceApi - factory interface
 * @export
 */
const MerchantServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.MerchantServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {MerchantServiceApiMerchantServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceCreate(requestParameters, options) {
            return localVarFp.merchantServiceCreate(requestParameters.modelMerchantRequest, requestParameters.id, requestParameters.avs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MerchantServiceApiMerchantServiceDelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceDel(requestParameters, options) {
            return localVarFp.merchantServiceDel(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MerchantServiceApiMerchantServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceGet(requestParameters, options) {
            return localVarFp.merchantServiceGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceGetMerchantsToSettle(options) {
            return localVarFp.merchantServiceGetMerchantsToSettle(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MerchantServiceApiMerchantServiceGetShopsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceGetShops(requestParameters = {}, options) {
            return localVarFp.merchantServiceGetShops(requestParameters.featured, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceGetShopsV2(options) {
            return localVarFp.merchantServiceGetShopsV2(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MerchantServiceApiMerchantServiceUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantServiceUpdate(requestParameters, options) {
            return localVarFp.merchantServiceUpdate(requestParameters.id, requestParameters.modelMerchantRequest, requestParameters.avs, options).then((request) => request(axios, basePath));
        },
    };
};
exports.MerchantServiceApiFactory = MerchantServiceApiFactory;
/**
 * MerchantServiceApi - object-oriented interface
 * @export
 * @class MerchantServiceApi
 * @extends {BaseAPI}
 */
class MerchantServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {MerchantServiceApiMerchantServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantServiceApi
     */
    merchantServiceCreate(requestParameters, options) {
        return (0, exports.MerchantServiceApiFp)(this.configuration).merchantServiceCreate(requestParameters.modelMerchantRequest, requestParameters.id, requestParameters.avs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MerchantServiceApiMerchantServiceDelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantServiceApi
     */
    merchantServiceDel(requestParameters, options) {
        return (0, exports.MerchantServiceApiFp)(this.configuration).merchantServiceDel(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MerchantServiceApiMerchantServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantServiceApi
     */
    merchantServiceGet(requestParameters, options) {
        return (0, exports.MerchantServiceApiFp)(this.configuration).merchantServiceGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantServiceApi
     */
    merchantServiceGetMerchantsToSettle(options) {
        return (0, exports.MerchantServiceApiFp)(this.configuration).merchantServiceGetMerchantsToSettle(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MerchantServiceApiMerchantServiceGetShopsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantServiceApi
     */
    merchantServiceGetShops(requestParameters = {}, options) {
        return (0, exports.MerchantServiceApiFp)(this.configuration).merchantServiceGetShops(requestParameters.featured, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantServiceApi
     */
    merchantServiceGetShopsV2(options) {
        return (0, exports.MerchantServiceApiFp)(this.configuration).merchantServiceGetShopsV2(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MerchantServiceApiMerchantServiceUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantServiceApi
     */
    merchantServiceUpdate(requestParameters, options) {
        return (0, exports.MerchantServiceApiFp)(this.configuration).merchantServiceUpdate(requestParameters.id, requestParameters.modelMerchantRequest, requestParameters.avs, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MerchantServiceApi = MerchantServiceApi;
/**
 * OrderAmendmentServiceApi - axios parameter creator
 * @export
 */
const OrderAmendmentServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelOrderAmendmentRequest} modelOrderAmendmentRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderAmendmentServiceCreate: async (modelOrderAmendmentRequest, id, options = {}) => {
            // verify required parameter 'modelOrderAmendmentRequest' is not null or undefined
            (0, common_1.assertParamExists)('orderAmendmentServiceCreate', 'modelOrderAmendmentRequest', modelOrderAmendmentRequest);
            const localVarPath = `/v1/order-amendments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelOrderAmendmentRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderAmendmentServiceGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('orderAmendmentServiceGet', 'id', id);
            const localVarPath = `/v1/order-amendments/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderAmendmentServiceGetMany: async (orderId, options = {}) => {
            const localVarPath = `/v1/order-amendments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.OrderAmendmentServiceApiAxiosParamCreator = OrderAmendmentServiceApiAxiosParamCreator;
/**
 * OrderAmendmentServiceApi - functional programming interface
 * @export
 */
const OrderAmendmentServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.OrderAmendmentServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelOrderAmendmentRequest} modelOrderAmendmentRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderAmendmentServiceCreate(modelOrderAmendmentRequest, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderAmendmentServiceCreate(modelOrderAmendmentRequest, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['OrderAmendmentServiceApi.orderAmendmentServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderAmendmentServiceGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderAmendmentServiceGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['OrderAmendmentServiceApi.orderAmendmentServiceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderAmendmentServiceGetMany(orderId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderAmendmentServiceGetMany(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['OrderAmendmentServiceApi.orderAmendmentServiceGetMany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.OrderAmendmentServiceApiFp = OrderAmendmentServiceApiFp;
/**
 * OrderAmendmentServiceApi - factory interface
 * @export
 */
const OrderAmendmentServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.OrderAmendmentServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {OrderAmendmentServiceApiOrderAmendmentServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderAmendmentServiceCreate(requestParameters, options) {
            return localVarFp.orderAmendmentServiceCreate(requestParameters.modelOrderAmendmentRequest, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderAmendmentServiceApiOrderAmendmentServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderAmendmentServiceGet(requestParameters, options) {
            return localVarFp.orderAmendmentServiceGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderAmendmentServiceApiOrderAmendmentServiceGetManyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderAmendmentServiceGetMany(requestParameters = {}, options) {
            return localVarFp.orderAmendmentServiceGetMany(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.OrderAmendmentServiceApiFactory = OrderAmendmentServiceApiFactory;
/**
 * OrderAmendmentServiceApi - object-oriented interface
 * @export
 * @class OrderAmendmentServiceApi
 * @extends {BaseAPI}
 */
class OrderAmendmentServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {OrderAmendmentServiceApiOrderAmendmentServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAmendmentServiceApi
     */
    orderAmendmentServiceCreate(requestParameters, options) {
        return (0, exports.OrderAmendmentServiceApiFp)(this.configuration).orderAmendmentServiceCreate(requestParameters.modelOrderAmendmentRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderAmendmentServiceApiOrderAmendmentServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAmendmentServiceApi
     */
    orderAmendmentServiceGet(requestParameters, options) {
        return (0, exports.OrderAmendmentServiceApiFp)(this.configuration).orderAmendmentServiceGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderAmendmentServiceApiOrderAmendmentServiceGetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderAmendmentServiceApi
     */
    orderAmendmentServiceGetMany(requestParameters = {}, options) {
        return (0, exports.OrderAmendmentServiceApiFp)(this.configuration).orderAmendmentServiceGetMany(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OrderAmendmentServiceApi = OrderAmendmentServiceApi;
/**
 * OrderServiceApi - axios parameter creator
 * @export
 */
const OrderServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceAttach: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('orderServiceAttach', 'id', id);
            const localVarPath = `/v1/orders/attach/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelOrderRequest} modelOrderRequest
         * @param {string} [id]
         * @param {string} [clone]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceCreate: async (modelOrderRequest, id, clone, options = {}) => {
            // verify required parameter 'modelOrderRequest' is not null or undefined
            (0, common_1.assertParamExists)('orderServiceCreate', 'modelOrderRequest', modelOrderRequest);
            const localVarPath = `/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            if (clone !== undefined) {
                localVarQueryParameter['clone'] = clone;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelOrderRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceDel: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('orderServiceDel', 'id', id);
            const localVarPath = `/v1/orders/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {Array<string>} [populate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceGet: async (id, populate, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('orderServiceGet', 'id', id);
            const localVarPath = `/v1/orders/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (populate) {
                localVarQueryParameter['populate'] = populate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} reference
         * @param {string} cellNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceGetByReferenceAndCellNumber: async (reference, cellNumber, options = {}) => {
            // verify required parameter 'reference' is not null or undefined
            (0, common_1.assertParamExists)('orderServiceGetByReferenceAndCellNumber', 'reference', reference);
            // verify required parameter 'cellNumber' is not null or undefined
            (0, common_1.assertParamExists)('orderServiceGetByReferenceAndCellNumber', 'cellNumber', cellNumber);
            const localVarPath = `/v1/orders/reference/{reference}/cellNumber/{cellNumber}`
                .replace(`{${"reference"}}`, encodeURIComponent(String(reference)))
                .replace(`{${"cellNumber"}}`, encodeURIComponent(String(cellNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceGetCancellationTerms: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('orderServiceGetCancellationTerms', 'id', id);
            const localVarPath = `/v1/orders/{_id}/cancellation-terms`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<string>} [populate] Fields to populate in the response.
         * @param {number} [limit] The maximum number of results to return.
         * @param {number} [skip] The number of results to skip for pagination.
         * @param {string} [userId] Filter orders by user ID.
         * @param {OrderServiceGetManyStateEnum} [state] See the Enumerated Values below
         * @param {string} [from] The start date for filtering orders (ISO 8601 format).
         * @param {string} [to] The end date for filtering orders (ISO 8601 format).
         * @param {string} [select] Specify which fields to include in the response.
         * @param {string} [populateObjectPath]
         * @param {string} [populateObjectSelect]
         * @param {string} [populateObjectPopulatePath]
         * @param {string} [populateObjectPopulateSelect]
         * @param {string} [search] Search term to filter orders by reference, name, or other fields.
         * @param {string} [reference] Filter orders by specific reference number.
         * @param {string} [sort] The field by which to sort the results. Prefix with \&#39;-\&#39; for descending order.
         * @param {string} [stateUpdatedAt] Filter orders by state update timestamp.
         * @param {string} [cloneOriginalId] Filter orders by original order ID for cloned orders.
         * @param {string} [groupPaymentPlan] Filter orders by group payment plan ID.
         * @param {string} [orderCancellationRequest]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceGetMany: async (populate, limit, skip, userId, state, from, to, select, populateObjectPath, populateObjectSelect, populateObjectPopulatePath, populateObjectPopulateSelect, search, reference, sort, stateUpdatedAt, cloneOriginalId, groupPaymentPlan, orderCancellationRequest, type, options = {}) => {
            const localVarPath = `/v1/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (populate) {
                localVarQueryParameter['populate'] = populate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (select !== undefined) {
                localVarQueryParameter['select'] = select;
            }
            if (populateObjectPath !== undefined) {
                localVarQueryParameter['populateObject.path'] = populateObjectPath;
            }
            if (populateObjectSelect !== undefined) {
                localVarQueryParameter['populateObject.select'] = populateObjectSelect;
            }
            if (populateObjectPopulatePath !== undefined) {
                localVarQueryParameter['populateObject.populate.path'] = populateObjectPopulatePath;
            }
            if (populateObjectPopulateSelect !== undefined) {
                localVarQueryParameter['populateObject.populate.select'] = populateObjectPopulateSelect;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (reference !== undefined) {
                localVarQueryParameter['reference'] = reference;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (stateUpdatedAt !== undefined) {
                localVarQueryParameter['stateUpdatedAt'] = stateUpdatedAt;
            }
            if (cloneOriginalId !== undefined) {
                localVarQueryParameter['cloneOriginalId'] = cloneOriginalId;
            }
            if (groupPaymentPlan !== undefined) {
                localVarQueryParameter['groupPaymentPlan'] = groupPaymentPlan;
            }
            if (orderCancellationRequest !== undefined) {
                localVarQueryParameter['orderCancellationRequest'] = orderCancellationRequest;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelOrderSendRequest} modelOrderSendRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceSendOrderRequest: async (modelOrderSendRequest, options = {}) => {
            // verify required parameter 'modelOrderSendRequest' is not null or undefined
            (0, common_1.assertParamExists)('orderServiceSendOrderRequest', 'modelOrderSendRequest', modelOrderSendRequest);
            const localVarPath = `/v1/orders-send-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelOrderSendRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelStatementRequest} modelStatementRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceStatementRequest: async (modelStatementRequest, options = {}) => {
            // verify required parameter 'modelStatementRequest' is not null or undefined
            (0, common_1.assertParamExists)('orderServiceStatementRequest', 'modelStatementRequest', modelStatementRequest);
            const localVarPath = `/v1/statement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelStatementRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {ModelOrderUpdateRequest} modelOrderUpdateRequest
         * @param {string} [collectMissed] now, next or ISO 8601 Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceUpdate: async (id, modelOrderUpdateRequest, collectMissed, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('orderServiceUpdate', 'id', id);
            // verify required parameter 'modelOrderUpdateRequest' is not null or undefined
            (0, common_1.assertParamExists)('orderServiceUpdate', 'modelOrderUpdateRequest', modelOrderUpdateRequest);
            const localVarPath = `/v1/orders/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (collectMissed !== undefined) {
                localVarQueryParameter['collectMissed'] = collectMissed;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelOrderUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.OrderServiceApiAxiosParamCreator = OrderServiceApiAxiosParamCreator;
/**
 * OrderServiceApi - functional programming interface
 * @export
 */
const OrderServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.OrderServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceAttach(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceAttach(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['OrderServiceApi.orderServiceAttach']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelOrderRequest} modelOrderRequest
         * @param {string} [id]
         * @param {string} [clone]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceCreate(modelOrderRequest, id, clone, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceCreate(modelOrderRequest, id, clone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['OrderServiceApi.orderServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceDel(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceDel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['OrderServiceApi.orderServiceDel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {Array<string>} [populate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceGet(id, populate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceGet(id, populate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['OrderServiceApi.orderServiceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} reference
         * @param {string} cellNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceGetByReferenceAndCellNumber(reference, cellNumber, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceGetByReferenceAndCellNumber(reference, cellNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['OrderServiceApi.orderServiceGetByReferenceAndCellNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceGetCancellationTerms(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceGetCancellationTerms(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['OrderServiceApi.orderServiceGetCancellationTerms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<string>} [populate] Fields to populate in the response.
         * @param {number} [limit] The maximum number of results to return.
         * @param {number} [skip] The number of results to skip for pagination.
         * @param {string} [userId] Filter orders by user ID.
         * @param {OrderServiceGetManyStateEnum} [state] See the Enumerated Values below
         * @param {string} [from] The start date for filtering orders (ISO 8601 format).
         * @param {string} [to] The end date for filtering orders (ISO 8601 format).
         * @param {string} [select] Specify which fields to include in the response.
         * @param {string} [populateObjectPath]
         * @param {string} [populateObjectSelect]
         * @param {string} [populateObjectPopulatePath]
         * @param {string} [populateObjectPopulateSelect]
         * @param {string} [search] Search term to filter orders by reference, name, or other fields.
         * @param {string} [reference] Filter orders by specific reference number.
         * @param {string} [sort] The field by which to sort the results. Prefix with \&#39;-\&#39; for descending order.
         * @param {string} [stateUpdatedAt] Filter orders by state update timestamp.
         * @param {string} [cloneOriginalId] Filter orders by original order ID for cloned orders.
         * @param {string} [groupPaymentPlan] Filter orders by group payment plan ID.
         * @param {string} [orderCancellationRequest]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceGetMany(populate, limit, skip, userId, state, from, to, select, populateObjectPath, populateObjectSelect, populateObjectPopulatePath, populateObjectPopulateSelect, search, reference, sort, stateUpdatedAt, cloneOriginalId, groupPaymentPlan, orderCancellationRequest, type, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceGetMany(populate, limit, skip, userId, state, from, to, select, populateObjectPath, populateObjectSelect, populateObjectPopulatePath, populateObjectPopulateSelect, search, reference, sort, stateUpdatedAt, cloneOriginalId, groupPaymentPlan, orderCancellationRequest, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['OrderServiceApi.orderServiceGetMany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelOrderSendRequest} modelOrderSendRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceSendOrderRequest(modelOrderSendRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceSendOrderRequest(modelOrderSendRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['OrderServiceApi.orderServiceSendOrderRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelStatementRequest} modelStatementRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceStatementRequest(modelStatementRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceStatementRequest(modelStatementRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['OrderServiceApi.orderServiceStatementRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {ModelOrderUpdateRequest} modelOrderUpdateRequest
         * @param {string} [collectMissed] now, next or ISO 8601 Date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderServiceUpdate(id, modelOrderUpdateRequest, collectMissed, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderServiceUpdate(id, modelOrderUpdateRequest, collectMissed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['OrderServiceApi.orderServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.OrderServiceApiFp = OrderServiceApiFp;
/**
 * OrderServiceApi - factory interface
 * @export
 */
const OrderServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.OrderServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {OrderServiceApiOrderServiceAttachRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceAttach(requestParameters, options) {
            return localVarFp.orderServiceAttach(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderServiceApiOrderServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceCreate(requestParameters, options) {
            return localVarFp.orderServiceCreate(requestParameters.modelOrderRequest, requestParameters.id, requestParameters.clone, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderServiceApiOrderServiceDelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceDel(requestParameters, options) {
            return localVarFp.orderServiceDel(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderServiceApiOrderServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceGet(requestParameters, options) {
            return localVarFp.orderServiceGet(requestParameters.id, requestParameters.populate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderServiceApiOrderServiceGetByReferenceAndCellNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceGetByReferenceAndCellNumber(requestParameters, options) {
            return localVarFp.orderServiceGetByReferenceAndCellNumber(requestParameters.reference, requestParameters.cellNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderServiceApiOrderServiceGetCancellationTermsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceGetCancellationTerms(requestParameters, options) {
            return localVarFp.orderServiceGetCancellationTerms(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderServiceApiOrderServiceGetManyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceGetMany(requestParameters = {}, options) {
            return localVarFp.orderServiceGetMany(requestParameters.populate, requestParameters.limit, requestParameters.skip, requestParameters.userId, requestParameters.state, requestParameters.from, requestParameters.to, requestParameters.select, requestParameters.populateObjectPath, requestParameters.populateObjectSelect, requestParameters.populateObjectPopulatePath, requestParameters.populateObjectPopulateSelect, requestParameters.search, requestParameters.reference, requestParameters.sort, requestParameters.stateUpdatedAt, requestParameters.cloneOriginalId, requestParameters.groupPaymentPlan, requestParameters.orderCancellationRequest, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderServiceApiOrderServiceSendOrderRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceSendOrderRequest(requestParameters, options) {
            return localVarFp.orderServiceSendOrderRequest(requestParameters.modelOrderSendRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderServiceApiOrderServiceStatementRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceStatementRequest(requestParameters, options) {
            return localVarFp.orderServiceStatementRequest(requestParameters.modelStatementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderServiceApiOrderServiceUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderServiceUpdate(requestParameters, options) {
            return localVarFp.orderServiceUpdate(requestParameters.id, requestParameters.modelOrderUpdateRequest, requestParameters.collectMissed, options).then((request) => request(axios, basePath));
        },
    };
};
exports.OrderServiceApiFactory = OrderServiceApiFactory;
/**
 * OrderServiceApi - object-oriented interface
 * @export
 * @class OrderServiceApi
 * @extends {BaseAPI}
 */
class OrderServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {OrderServiceApiOrderServiceAttachRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    orderServiceAttach(requestParameters, options) {
        return (0, exports.OrderServiceApiFp)(this.configuration).orderServiceAttach(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderServiceApiOrderServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    orderServiceCreate(requestParameters, options) {
        return (0, exports.OrderServiceApiFp)(this.configuration).orderServiceCreate(requestParameters.modelOrderRequest, requestParameters.id, requestParameters.clone, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderServiceApiOrderServiceDelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    orderServiceDel(requestParameters, options) {
        return (0, exports.OrderServiceApiFp)(this.configuration).orderServiceDel(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderServiceApiOrderServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    orderServiceGet(requestParameters, options) {
        return (0, exports.OrderServiceApiFp)(this.configuration).orderServiceGet(requestParameters.id, requestParameters.populate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderServiceApiOrderServiceGetByReferenceAndCellNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    orderServiceGetByReferenceAndCellNumber(requestParameters, options) {
        return (0, exports.OrderServiceApiFp)(this.configuration).orderServiceGetByReferenceAndCellNumber(requestParameters.reference, requestParameters.cellNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderServiceApiOrderServiceGetCancellationTermsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    orderServiceGetCancellationTerms(requestParameters, options) {
        return (0, exports.OrderServiceApiFp)(this.configuration).orderServiceGetCancellationTerms(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderServiceApiOrderServiceGetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    orderServiceGetMany(requestParameters = {}, options) {
        return (0, exports.OrderServiceApiFp)(this.configuration).orderServiceGetMany(requestParameters.populate, requestParameters.limit, requestParameters.skip, requestParameters.userId, requestParameters.state, requestParameters.from, requestParameters.to, requestParameters.select, requestParameters.populateObjectPath, requestParameters.populateObjectSelect, requestParameters.populateObjectPopulatePath, requestParameters.populateObjectPopulateSelect, requestParameters.search, requestParameters.reference, requestParameters.sort, requestParameters.stateUpdatedAt, requestParameters.cloneOriginalId, requestParameters.groupPaymentPlan, requestParameters.orderCancellationRequest, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderServiceApiOrderServiceSendOrderRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    orderServiceSendOrderRequest(requestParameters, options) {
        return (0, exports.OrderServiceApiFp)(this.configuration).orderServiceSendOrderRequest(requestParameters.modelOrderSendRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderServiceApiOrderServiceStatementRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    orderServiceStatementRequest(requestParameters, options) {
        return (0, exports.OrderServiceApiFp)(this.configuration).orderServiceStatementRequest(requestParameters.modelStatementRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderServiceApiOrderServiceUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderServiceApi
     */
    orderServiceUpdate(requestParameters, options) {
        return (0, exports.OrderServiceApiFp)(this.configuration).orderServiceUpdate(requestParameters.id, requestParameters.modelOrderUpdateRequest, requestParameters.collectMissed, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OrderServiceApi = OrderServiceApi;
/**
 * @export
 */
exports.OrderServiceGetManyStateEnum = {
    Partial: 'PARTIAL',
    Expired: 'EXPIRED',
    Placed: 'PLACED',
    Completed: 'COMPLETED',
    Suspended: 'SUSPENDED',
    Cancelling: 'CANCELLING',
    Cancelled: 'CANCELLED'
};
/**
 * PayAtServiceApi - axios parameter creator
 * @export
 */
const PayAtServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelPayAtTransactionAdviceRequest} modelPayAtTransactionAdviceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payAtServiceAdviseTransaction: async (modelPayAtTransactionAdviceRequest, options = {}) => {
            // verify required parameter 'modelPayAtTransactionAdviceRequest' is not null or undefined
            (0, common_1.assertParamExists)('payAtServiceAdviseTransaction', 'modelPayAtTransactionAdviceRequest', modelPayAtTransactionAdviceRequest);
            const localVarPath = `/v1/payAt/adviseTransaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPayAtTransactionAdviceRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelPayAtAuthorizationRequest} modelPayAtAuthorizationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payAtServiceAuthorize: async (modelPayAtAuthorizationRequest, options = {}) => {
            // verify required parameter 'modelPayAtAuthorizationRequest' is not null or undefined
            (0, common_1.assertParamExists)('payAtServiceAuthorize', 'modelPayAtAuthorizationRequest', modelPayAtAuthorizationRequest);
            const localVarPath = `/v1/payAt/authorize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPayAtAuthorizationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelPayAtEchoTestRequest} modelPayAtEchoTestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payAtServiceEchoTest: async (modelPayAtEchoTestRequest, options = {}) => {
            // verify required parameter 'modelPayAtEchoTestRequest' is not null or undefined
            (0, common_1.assertParamExists)('payAtServiceEchoTest', 'modelPayAtEchoTestRequest', modelPayAtEchoTestRequest);
            const localVarPath = `/v1/payAt/echoTest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPayAtEchoTestRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelPayAtEnquiryRequest} modelPayAtEnquiryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payAtServiceEnquiry: async (modelPayAtEnquiryRequest, options = {}) => {
            // verify required parameter 'modelPayAtEnquiryRequest' is not null or undefined
            (0, common_1.assertParamExists)('payAtServiceEnquiry', 'modelPayAtEnquiryRequest', modelPayAtEnquiryRequest);
            const localVarPath = `/v1/payAt/enquire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPayAtEnquiryRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelPayAtReverseAuthorizationRequest} modelPayAtReverseAuthorizationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payAtServiceReverseAuthorization: async (modelPayAtReverseAuthorizationRequest, options = {}) => {
            // verify required parameter 'modelPayAtReverseAuthorizationRequest' is not null or undefined
            (0, common_1.assertParamExists)('payAtServiceReverseAuthorization', 'modelPayAtReverseAuthorizationRequest', modelPayAtReverseAuthorizationRequest);
            const localVarPath = `/v1/payAt/reverseAuthorization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPayAtReverseAuthorizationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PayAtServiceApiAxiosParamCreator = PayAtServiceApiAxiosParamCreator;
/**
 * PayAtServiceApi - functional programming interface
 * @export
 */
const PayAtServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PayAtServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelPayAtTransactionAdviceRequest} modelPayAtTransactionAdviceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async payAtServiceAdviseTransaction(modelPayAtTransactionAdviceRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.payAtServiceAdviseTransaction(modelPayAtTransactionAdviceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PayAtServiceApi.payAtServiceAdviseTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelPayAtAuthorizationRequest} modelPayAtAuthorizationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async payAtServiceAuthorize(modelPayAtAuthorizationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.payAtServiceAuthorize(modelPayAtAuthorizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PayAtServiceApi.payAtServiceAuthorize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelPayAtEchoTestRequest} modelPayAtEchoTestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async payAtServiceEchoTest(modelPayAtEchoTestRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.payAtServiceEchoTest(modelPayAtEchoTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PayAtServiceApi.payAtServiceEchoTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelPayAtEnquiryRequest} modelPayAtEnquiryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async payAtServiceEnquiry(modelPayAtEnquiryRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.payAtServiceEnquiry(modelPayAtEnquiryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PayAtServiceApi.payAtServiceEnquiry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelPayAtReverseAuthorizationRequest} modelPayAtReverseAuthorizationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async payAtServiceReverseAuthorization(modelPayAtReverseAuthorizationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.payAtServiceReverseAuthorization(modelPayAtReverseAuthorizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PayAtServiceApi.payAtServiceReverseAuthorization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.PayAtServiceApiFp = PayAtServiceApiFp;
/**
 * PayAtServiceApi - factory interface
 * @export
 */
const PayAtServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PayAtServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {PayAtServiceApiPayAtServiceAdviseTransactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payAtServiceAdviseTransaction(requestParameters, options) {
            return localVarFp.payAtServiceAdviseTransaction(requestParameters.modelPayAtTransactionAdviceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PayAtServiceApiPayAtServiceAuthorizeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payAtServiceAuthorize(requestParameters, options) {
            return localVarFp.payAtServiceAuthorize(requestParameters.modelPayAtAuthorizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PayAtServiceApiPayAtServiceEchoTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payAtServiceEchoTest(requestParameters, options) {
            return localVarFp.payAtServiceEchoTest(requestParameters.modelPayAtEchoTestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PayAtServiceApiPayAtServiceEnquiryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payAtServiceEnquiry(requestParameters, options) {
            return localVarFp.payAtServiceEnquiry(requestParameters.modelPayAtEnquiryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PayAtServiceApiPayAtServiceReverseAuthorizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payAtServiceReverseAuthorization(requestParameters, options) {
            return localVarFp.payAtServiceReverseAuthorization(requestParameters.modelPayAtReverseAuthorizationRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PayAtServiceApiFactory = PayAtServiceApiFactory;
/**
 * PayAtServiceApi - object-oriented interface
 * @export
 * @class PayAtServiceApi
 * @extends {BaseAPI}
 */
class PayAtServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {PayAtServiceApiPayAtServiceAdviseTransactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayAtServiceApi
     */
    payAtServiceAdviseTransaction(requestParameters, options) {
        return (0, exports.PayAtServiceApiFp)(this.configuration).payAtServiceAdviseTransaction(requestParameters.modelPayAtTransactionAdviceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PayAtServiceApiPayAtServiceAuthorizeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayAtServiceApi
     */
    payAtServiceAuthorize(requestParameters, options) {
        return (0, exports.PayAtServiceApiFp)(this.configuration).payAtServiceAuthorize(requestParameters.modelPayAtAuthorizationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PayAtServiceApiPayAtServiceEchoTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayAtServiceApi
     */
    payAtServiceEchoTest(requestParameters, options) {
        return (0, exports.PayAtServiceApiFp)(this.configuration).payAtServiceEchoTest(requestParameters.modelPayAtEchoTestRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PayAtServiceApiPayAtServiceEnquiryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayAtServiceApi
     */
    payAtServiceEnquiry(requestParameters, options) {
        return (0, exports.PayAtServiceApiFp)(this.configuration).payAtServiceEnquiry(requestParameters.modelPayAtEnquiryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PayAtServiceApiPayAtServiceReverseAuthorizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PayAtServiceApi
     */
    payAtServiceReverseAuthorization(requestParameters, options) {
        return (0, exports.PayAtServiceApiFp)(this.configuration).payAtServiceReverseAuthorization(requestParameters.modelPayAtReverseAuthorizationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PayAtServiceApi = PayAtServiceApi;
/**
 * PaymentPlanServiceApi - axios parameter creator
 * @export
 */
const PaymentPlanServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelPaymentPlanRequest} modelPaymentPlanRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceCreate: async (modelPaymentPlanRequest, id, options = {}) => {
            // verify required parameter 'modelPaymentPlanRequest' is not null or undefined
            (0, common_1.assertParamExists)('paymentPlanServiceCreate', 'modelPaymentPlanRequest', modelPaymentPlanRequest);
            const localVarPath = `/v1/payment-plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPaymentPlanRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelPaymentPlanPreviewRequest} modelPaymentPlanPreviewRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceCreatePreview: async (modelPaymentPlanPreviewRequest, options = {}) => {
            // verify required parameter 'modelPaymentPlanPreviewRequest' is not null or undefined
            (0, common_1.assertParamExists)('paymentPlanServiceCreatePreview', 'modelPaymentPlanPreviewRequest', modelPaymentPlanPreviewRequest);
            const localVarPath = `/v1/payment-plan/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPaymentPlanPreviewRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelPaymentPlanSplitBody} modelPaymentPlanSplitBody
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceCreateSplitPayment: async (modelPaymentPlanSplitBody, id, options = {}) => {
            // verify required parameter 'modelPaymentPlanSplitBody' is not null or undefined
            (0, common_1.assertParamExists)('paymentPlanServiceCreateSplitPayment', 'modelPaymentPlanSplitBody', modelPaymentPlanSplitBody);
            const localVarPath = `/v1/payment-plan-split`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPaymentPlanSplitBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceDel: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('paymentPlanServiceDel', 'id', id);
            const localVarPath = `/v1/payment-plan/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {Array<string>} [populate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceGet: async (id, populate, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('paymentPlanServiceGet', 'id', id);
            const localVarPath = `/v1/payment-plan/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (populate) {
                localVarQueryParameter['populate'] = populate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} token
         * @param {string} [msisdn]
         * @param {Array<string>} [populate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceGetByMsisdnAndToken: async (token, msisdn, populate, options = {}) => {
            // verify required parameter 'token' is not null or undefined
            (0, common_1.assertParamExists)('paymentPlanServiceGetByMsisdnAndToken', 'token', token);
            const localVarPath = `/v1/payment-plan/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (msisdn !== undefined) {
                localVarQueryParameter['msisdn'] = msisdn;
            }
            if (populate) {
                localVarQueryParameter['populate'] = populate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [frequency]
         * @param {number} [offset]
         * @param {string} [paymentPlanId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceGetPreview: async (id, frequency, offset, paymentPlanId, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('paymentPlanServiceGetPreview', 'id', id);
            const localVarPath = `/v1/payment-plan/preview/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (frequency !== undefined) {
                localVarQueryParameter['frequency'] = frequency;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (paymentPlanId !== undefined) {
                localVarQueryParameter['paymentPlanId'] = paymentPlanId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelPaymentPlanSendNotificationRequest} modelPaymentPlanSendNotificationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceSendPaymentPlanNotification: async (modelPaymentPlanSendNotificationRequest, options = {}) => {
            // verify required parameter 'modelPaymentPlanSendNotificationRequest' is not null or undefined
            (0, common_1.assertParamExists)('paymentPlanServiceSendPaymentPlanNotification', 'modelPaymentPlanSendNotificationRequest', modelPaymentPlanSendNotificationRequest);
            const localVarPath = `/v1/payment-plan-send-notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPaymentPlanSendNotificationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {ModelPaymentPlanRequest} modelPaymentPlanRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceUpdate: async (id, modelPaymentPlanRequest, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('paymentPlanServiceUpdate', 'id', id);
            // verify required parameter 'modelPaymentPlanRequest' is not null or undefined
            (0, common_1.assertParamExists)('paymentPlanServiceUpdate', 'modelPaymentPlanRequest', modelPaymentPlanRequest);
            const localVarPath = `/v1/payment-plan/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPaymentPlanRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PaymentPlanServiceApiAxiosParamCreator = PaymentPlanServiceApiAxiosParamCreator;
/**
 * PaymentPlanServiceApi - functional programming interface
 * @export
 */
const PaymentPlanServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PaymentPlanServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelPaymentPlanRequest} modelPaymentPlanRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentPlanServiceCreate(modelPaymentPlanRequest, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentPlanServiceCreate(modelPaymentPlanRequest, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentPlanServiceApi.paymentPlanServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelPaymentPlanPreviewRequest} modelPaymentPlanPreviewRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentPlanServiceCreatePreview(modelPaymentPlanPreviewRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentPlanServiceCreatePreview(modelPaymentPlanPreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentPlanServiceApi.paymentPlanServiceCreatePreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelPaymentPlanSplitBody} modelPaymentPlanSplitBody
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentPlanServiceCreateSplitPayment(modelPaymentPlanSplitBody, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentPlanServiceCreateSplitPayment(modelPaymentPlanSplitBody, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentPlanServiceApi.paymentPlanServiceCreateSplitPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentPlanServiceDel(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentPlanServiceDel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentPlanServiceApi.paymentPlanServiceDel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {Array<string>} [populate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentPlanServiceGet(id, populate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentPlanServiceGet(id, populate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentPlanServiceApi.paymentPlanServiceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} token
         * @param {string} [msisdn]
         * @param {Array<string>} [populate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentPlanServiceGetByMsisdnAndToken(token, msisdn, populate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentPlanServiceGetByMsisdnAndToken(token, msisdn, populate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentPlanServiceApi.paymentPlanServiceGetByMsisdnAndToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {string} [frequency]
         * @param {number} [offset]
         * @param {string} [paymentPlanId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentPlanServiceGetPreview(id, frequency, offset, paymentPlanId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentPlanServiceGetPreview(id, frequency, offset, paymentPlanId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentPlanServiceApi.paymentPlanServiceGetPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelPaymentPlanSendNotificationRequest} modelPaymentPlanSendNotificationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentPlanServiceSendPaymentPlanNotification(modelPaymentPlanSendNotificationRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentPlanServiceSendPaymentPlanNotification(modelPaymentPlanSendNotificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentPlanServiceApi.paymentPlanServiceSendPaymentPlanNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {ModelPaymentPlanRequest} modelPaymentPlanRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentPlanServiceUpdate(id, modelPaymentPlanRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentPlanServiceUpdate(id, modelPaymentPlanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentPlanServiceApi.paymentPlanServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.PaymentPlanServiceApiFp = PaymentPlanServiceApiFp;
/**
 * PaymentPlanServiceApi - factory interface
 * @export
 */
const PaymentPlanServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PaymentPlanServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {PaymentPlanServiceApiPaymentPlanServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceCreate(requestParameters, options) {
            return localVarFp.paymentPlanServiceCreate(requestParameters.modelPaymentPlanRequest, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentPlanServiceApiPaymentPlanServiceCreatePreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceCreatePreview(requestParameters, options) {
            return localVarFp.paymentPlanServiceCreatePreview(requestParameters.modelPaymentPlanPreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentPlanServiceApiPaymentPlanServiceCreateSplitPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceCreateSplitPayment(requestParameters, options) {
            return localVarFp.paymentPlanServiceCreateSplitPayment(requestParameters.modelPaymentPlanSplitBody, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentPlanServiceApiPaymentPlanServiceDelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceDel(requestParameters, options) {
            return localVarFp.paymentPlanServiceDel(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentPlanServiceApiPaymentPlanServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceGet(requestParameters, options) {
            return localVarFp.paymentPlanServiceGet(requestParameters.id, requestParameters.populate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentPlanServiceApiPaymentPlanServiceGetByMsisdnAndTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceGetByMsisdnAndToken(requestParameters, options) {
            return localVarFp.paymentPlanServiceGetByMsisdnAndToken(requestParameters.token, requestParameters.msisdn, requestParameters.populate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentPlanServiceApiPaymentPlanServiceGetPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceGetPreview(requestParameters, options) {
            return localVarFp.paymentPlanServiceGetPreview(requestParameters.id, requestParameters.frequency, requestParameters.offset, requestParameters.paymentPlanId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentPlanServiceApiPaymentPlanServiceSendPaymentPlanNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceSendPaymentPlanNotification(requestParameters, options) {
            return localVarFp.paymentPlanServiceSendPaymentPlanNotification(requestParameters.modelPaymentPlanSendNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentPlanServiceApiPaymentPlanServiceUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlanServiceUpdate(requestParameters, options) {
            return localVarFp.paymentPlanServiceUpdate(requestParameters.id, requestParameters.modelPaymentPlanRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PaymentPlanServiceApiFactory = PaymentPlanServiceApiFactory;
/**
 * PaymentPlanServiceApi - object-oriented interface
 * @export
 * @class PaymentPlanServiceApi
 * @extends {BaseAPI}
 */
class PaymentPlanServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {PaymentPlanServiceApiPaymentPlanServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanServiceApi
     */
    paymentPlanServiceCreate(requestParameters, options) {
        return (0, exports.PaymentPlanServiceApiFp)(this.configuration).paymentPlanServiceCreate(requestParameters.modelPaymentPlanRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentPlanServiceApiPaymentPlanServiceCreatePreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanServiceApi
     */
    paymentPlanServiceCreatePreview(requestParameters, options) {
        return (0, exports.PaymentPlanServiceApiFp)(this.configuration).paymentPlanServiceCreatePreview(requestParameters.modelPaymentPlanPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentPlanServiceApiPaymentPlanServiceCreateSplitPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanServiceApi
     */
    paymentPlanServiceCreateSplitPayment(requestParameters, options) {
        return (0, exports.PaymentPlanServiceApiFp)(this.configuration).paymentPlanServiceCreateSplitPayment(requestParameters.modelPaymentPlanSplitBody, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentPlanServiceApiPaymentPlanServiceDelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanServiceApi
     */
    paymentPlanServiceDel(requestParameters, options) {
        return (0, exports.PaymentPlanServiceApiFp)(this.configuration).paymentPlanServiceDel(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentPlanServiceApiPaymentPlanServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanServiceApi
     */
    paymentPlanServiceGet(requestParameters, options) {
        return (0, exports.PaymentPlanServiceApiFp)(this.configuration).paymentPlanServiceGet(requestParameters.id, requestParameters.populate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentPlanServiceApiPaymentPlanServiceGetByMsisdnAndTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanServiceApi
     */
    paymentPlanServiceGetByMsisdnAndToken(requestParameters, options) {
        return (0, exports.PaymentPlanServiceApiFp)(this.configuration).paymentPlanServiceGetByMsisdnAndToken(requestParameters.token, requestParameters.msisdn, requestParameters.populate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentPlanServiceApiPaymentPlanServiceGetPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanServiceApi
     */
    paymentPlanServiceGetPreview(requestParameters, options) {
        return (0, exports.PaymentPlanServiceApiFp)(this.configuration).paymentPlanServiceGetPreview(requestParameters.id, requestParameters.frequency, requestParameters.offset, requestParameters.paymentPlanId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentPlanServiceApiPaymentPlanServiceSendPaymentPlanNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanServiceApi
     */
    paymentPlanServiceSendPaymentPlanNotification(requestParameters, options) {
        return (0, exports.PaymentPlanServiceApiFp)(this.configuration).paymentPlanServiceSendPaymentPlanNotification(requestParameters.modelPaymentPlanSendNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentPlanServiceApiPaymentPlanServiceUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlanServiceApi
     */
    paymentPlanServiceUpdate(requestParameters, options) {
        return (0, exports.PaymentPlanServiceApiFp)(this.configuration).paymentPlanServiceUpdate(requestParameters.id, requestParameters.modelPaymentPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PaymentPlanServiceApi = PaymentPlanServiceApi;
/**
 * PaymentProviderSettlementServiceApi - axios parameter creator
 * @export
 */
const PaymentProviderSettlementServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelPaymentProviderSettlementsRequest} modelPaymentProviderSettlementsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentProviderSettlementServiceCreate: async (modelPaymentProviderSettlementsRequest, options = {}) => {
            // verify required parameter 'modelPaymentProviderSettlementsRequest' is not null or undefined
            (0, common_1.assertParamExists)('paymentProviderSettlementServiceCreate', 'modelPaymentProviderSettlementsRequest', modelPaymentProviderSettlementsRequest);
            const localVarPath = `/v1/paymentProviderSettlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPaymentProviderSettlementsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} bankTransactionBatchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentProviderSettlementServiceLinkBatch: async (ids, bankTransactionBatchId, options = {}) => {
            // verify required parameter 'ids' is not null or undefined
            (0, common_1.assertParamExists)('paymentProviderSettlementServiceLinkBatch', 'ids', ids);
            // verify required parameter 'bankTransactionBatchId' is not null or undefined
            (0, common_1.assertParamExists)('paymentProviderSettlementServiceLinkBatch', 'bankTransactionBatchId', bankTransactionBatchId);
            const localVarPath = `/v1/paymentProviderSettlements/link-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (bankTransactionBatchId !== undefined) {
                localVarQueryParameter['bankTransactionBatchId'] = bankTransactionBatchId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} paymentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentProviderSettlementServiceLinkPayment: async (id, paymentId, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('paymentProviderSettlementServiceLinkPayment', 'id', id);
            // verify required parameter 'paymentId' is not null or undefined
            (0, common_1.assertParamExists)('paymentProviderSettlementServiceLinkPayment', 'paymentId', paymentId);
            const localVarPath = `/v1/paymentProviderSettlements/{id}/linkPayment/{paymentId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PaymentProviderSettlementServiceApiAxiosParamCreator = PaymentProviderSettlementServiceApiAxiosParamCreator;
/**
 * PaymentProviderSettlementServiceApi - functional programming interface
 * @export
 */
const PaymentProviderSettlementServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PaymentProviderSettlementServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelPaymentProviderSettlementsRequest} modelPaymentProviderSettlementsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentProviderSettlementServiceCreate(modelPaymentProviderSettlementsRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentProviderSettlementServiceCreate(modelPaymentProviderSettlementsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentProviderSettlementServiceApi.paymentProviderSettlementServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<string>} ids
         * @param {string} bankTransactionBatchId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentProviderSettlementServiceLinkBatch(ids, bankTransactionBatchId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentProviderSettlementServiceLinkBatch(ids, bankTransactionBatchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentProviderSettlementServiceApi.paymentProviderSettlementServiceLinkBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {string} paymentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentProviderSettlementServiceLinkPayment(id, paymentId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentProviderSettlementServiceLinkPayment(id, paymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentProviderSettlementServiceApi.paymentProviderSettlementServiceLinkPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.PaymentProviderSettlementServiceApiFp = PaymentProviderSettlementServiceApiFp;
/**
 * PaymentProviderSettlementServiceApi - factory interface
 * @export
 */
const PaymentProviderSettlementServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PaymentProviderSettlementServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {PaymentProviderSettlementServiceApiPaymentProviderSettlementServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentProviderSettlementServiceCreate(requestParameters, options) {
            return localVarFp.paymentProviderSettlementServiceCreate(requestParameters.modelPaymentProviderSettlementsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentProviderSettlementServiceApiPaymentProviderSettlementServiceLinkBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentProviderSettlementServiceLinkBatch(requestParameters, options) {
            return localVarFp.paymentProviderSettlementServiceLinkBatch(requestParameters.ids, requestParameters.bankTransactionBatchId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentProviderSettlementServiceApiPaymentProviderSettlementServiceLinkPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentProviderSettlementServiceLinkPayment(requestParameters, options) {
            return localVarFp.paymentProviderSettlementServiceLinkPayment(requestParameters.id, requestParameters.paymentId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PaymentProviderSettlementServiceApiFactory = PaymentProviderSettlementServiceApiFactory;
/**
 * PaymentProviderSettlementServiceApi - object-oriented interface
 * @export
 * @class PaymentProviderSettlementServiceApi
 * @extends {BaseAPI}
 */
class PaymentProviderSettlementServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {PaymentProviderSettlementServiceApiPaymentProviderSettlementServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentProviderSettlementServiceApi
     */
    paymentProviderSettlementServiceCreate(requestParameters, options) {
        return (0, exports.PaymentProviderSettlementServiceApiFp)(this.configuration).paymentProviderSettlementServiceCreate(requestParameters.modelPaymentProviderSettlementsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentProviderSettlementServiceApiPaymentProviderSettlementServiceLinkBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentProviderSettlementServiceApi
     */
    paymentProviderSettlementServiceLinkBatch(requestParameters, options) {
        return (0, exports.PaymentProviderSettlementServiceApiFp)(this.configuration).paymentProviderSettlementServiceLinkBatch(requestParameters.ids, requestParameters.bankTransactionBatchId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentProviderSettlementServiceApiPaymentProviderSettlementServiceLinkPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentProviderSettlementServiceApi
     */
    paymentProviderSettlementServiceLinkPayment(requestParameters, options) {
        return (0, exports.PaymentProviderSettlementServiceApiFp)(this.configuration).paymentProviderSettlementServiceLinkPayment(requestParameters.id, requestParameters.paymentId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PaymentProviderSettlementServiceApi = PaymentProviderSettlementServiceApi;
/**
 * PaymentServiceApi - axios parameter creator
 * @export
 */
const PaymentServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelPaymentRequest} modelPaymentRequest
         * @param {string} [id]
         * @param {string} [secret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceCreate: async (modelPaymentRequest, id, secret, options = {}) => {
            // verify required parameter 'modelPaymentRequest' is not null or undefined
            (0, common_1.assertParamExists)('paymentServiceCreate', 'modelPaymentRequest', modelPaymentRequest);
            const localVarPath = `/v1/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            if (secret !== undefined) {
                localVarQueryParameter['secret'] = secret;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPaymentRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelOfflinePaymentRequest} modelOfflinePaymentRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceCreateOffline: async (modelOfflinePaymentRequest, id, options = {}) => {
            // verify required parameter 'modelOfflinePaymentRequest' is not null or undefined
            (0, common_1.assertParamExists)('paymentServiceCreateOffline', 'modelOfflinePaymentRequest', modelOfflinePaymentRequest);
            const localVarPath = `/v1/offline-payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelOfflinePaymentRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceDelete: async (id, options = {}) => {
            const localVarPath = `/v1/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceDeleteOffline: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('paymentServiceDeleteOffline', 'id', id);
            const localVarPath = `/v1/offline-payments/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {string} [verify]
         * @param {string} [force]
         * @param {string} [msisdn]
         * @param {string} [token]
         * @param {boolean} [isEmbeddedCheckout]
         * @param {string} [registrationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceGet: async (id, verify, force, msisdn, token, isEmbeddedCheckout, registrationId, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('paymentServiceGet', 'id', id);
            const localVarPath = `/v1/payments/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (verify !== undefined) {
                localVarQueryParameter['verify'] = verify;
            }
            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }
            if (msisdn !== undefined) {
                localVarQueryParameter['msisdn'] = msisdn;
            }
            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }
            if (isEmbeddedCheckout !== undefined) {
                localVarQueryParameter['isEmbeddedCheckout'] = isEmbeddedCheckout;
            }
            if (registrationId !== undefined) {
                localVarQueryParameter['registrationId'] = registrationId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [skip] The number of results to skip for pagination.
         * @param {number} [limit] The maximum number of results to return.
         * @param {boolean} [paid] Filter payments by paid status.
         * @param {string} [orderId] Filter payments by order ID.
         * @param {string} [paymentPlanId] Filter payments by payment plan ID.
         * @param {string} [userId] Filter payments by user ID.
         * @param {string} [fromDate] The start date for filtering payments (ISO 8601 format).
         * @param {string} [toDate] The end date for filtering payments (ISO 8601 format).
         * @param {string} [method] Filter payments by payment method (e.g., card, eft, cash).
         * @param {string} [type] Filter payments by payment type.
         * @param {string} [search] Search term to filter payments.
         * @param {string} [fromDatePayments] Filter by payment creation start date (ISO 8601 format).
         * @param {string} [toDatePayments] Filter by payment creation end date (ISO 8601 format).
         * @param {string} [settled] Filter payments by settlement status (true, false, or null).
         * @param {string} [sort] Array of fields by which to sort the results. Prefix with \&#39;-\&#39; for descending order.
         * @param {boolean} [failed] Filter payments by failed status.
         * @param {string} [provider] Filter payments by payment provider (e.g., PEACH, ABSA, PAYAT, DASHPAY).
         * @param {string} [destinationId] Filter payments by destination ID.
         * @param {string} [destinationType] Filter payments by destination type (e.g., paymentPlan, order).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceGetMany: async (skip, limit, paid, orderId, paymentPlanId, userId, fromDate, toDate, method, type, search, fromDatePayments, toDatePayments, settled, sort, failed, provider, destinationId, destinationType, options = {}) => {
            const localVarPath = `/v1/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (paid !== undefined) {
                localVarQueryParameter['paid'] = paid;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (paymentPlanId !== undefined) {
                localVarQueryParameter['paymentPlanId'] = paymentPlanId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }
            if (method !== undefined) {
                localVarQueryParameter['method'] = method;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (fromDatePayments !== undefined) {
                localVarQueryParameter['fromDatePayments'] = fromDatePayments;
            }
            if (toDatePayments !== undefined) {
                localVarQueryParameter['toDatePayments'] = toDatePayments;
            }
            if (settled !== undefined) {
                localVarQueryParameter['settled'] = settled;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (failed !== undefined) {
                localVarQueryParameter['failed'] = failed;
            }
            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }
            if (destinationId !== undefined) {
                localVarQueryParameter['destinationId'] = destinationId;
            }
            if (destinationType !== undefined) {
                localVarQueryParameter['destinationType'] = destinationType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [bodyAmount]
         * @param {string} [bodyRefundReference]
         * @param {string} [bodyPaymentId]
         * @param {boolean} [bodyExcludeFees]
         * @param {string} [bodyRefundMethod]
         * @param {boolean} [bodyAutoRefund]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceManualRefund: async (bodyAmount, bodyRefundReference, bodyPaymentId, bodyExcludeFees, bodyRefundMethod, bodyAutoRefund, options = {}) => {
            const localVarPath = `/v1/manual-refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (bodyAmount !== undefined) {
                localVarQueryParameter['body.amount'] = bodyAmount;
            }
            if (bodyRefundReference !== undefined) {
                localVarQueryParameter['body.refundReference'] = bodyRefundReference;
            }
            if (bodyPaymentId !== undefined) {
                localVarQueryParameter['body.paymentId'] = bodyPaymentId;
            }
            if (bodyExcludeFees !== undefined) {
                localVarQueryParameter['body.excludeFees'] = bodyExcludeFees;
            }
            if (bodyRefundMethod !== undefined) {
                localVarQueryParameter['body.refundMethod'] = bodyRefundMethod;
            }
            if (bodyAutoRefund !== undefined) {
                localVarQueryParameter['body.autoRefund'] = bodyAutoRefund;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [bodyAmount]
         * @param {string} [bodyRefundReference]
         * @param {string} [bodyPaymentId]
         * @param {boolean} [bodyExcludeFees]
         * @param {string} [bodyRefundMethod]
         * @param {boolean} [bodyAutoRefund]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceRealtimeRefund: async (bodyAmount, bodyRefundReference, bodyPaymentId, bodyExcludeFees, bodyRefundMethod, bodyAutoRefund, options = {}) => {
            const localVarPath = `/v1/realtime-refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (bodyAmount !== undefined) {
                localVarQueryParameter['body.amount'] = bodyAmount;
            }
            if (bodyRefundReference !== undefined) {
                localVarQueryParameter['body.refundReference'] = bodyRefundReference;
            }
            if (bodyPaymentId !== undefined) {
                localVarQueryParameter['body.paymentId'] = bodyPaymentId;
            }
            if (bodyExcludeFees !== undefined) {
                localVarQueryParameter['body.excludeFees'] = bodyExcludeFees;
            }
            if (bodyRefundMethod !== undefined) {
                localVarQueryParameter['body.refundMethod'] = bodyRefundMethod;
            }
            if (bodyAutoRefund !== undefined) {
                localVarQueryParameter['body.autoRefund'] = bodyAutoRefund;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [bodyAmount]
         * @param {string} [bodyRefundReference]
         * @param {string} [bodyPaymentId]
         * @param {boolean} [bodyExcludeFees]
         * @param {string} [bodyRefundMethod]
         * @param {boolean} [bodyAutoRefund]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceRefund: async (bodyAmount, bodyRefundReference, bodyPaymentId, bodyExcludeFees, bodyRefundMethod, bodyAutoRefund, options = {}) => {
            const localVarPath = `/v1/generate-refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (bodyAmount !== undefined) {
                localVarQueryParameter['body.amount'] = bodyAmount;
            }
            if (bodyRefundReference !== undefined) {
                localVarQueryParameter['body.refundReference'] = bodyRefundReference;
            }
            if (bodyPaymentId !== undefined) {
                localVarQueryParameter['body.paymentId'] = bodyPaymentId;
            }
            if (bodyExcludeFees !== undefined) {
                localVarQueryParameter['body.excludeFees'] = bodyExcludeFees;
            }
            if (bodyRefundMethod !== undefined) {
                localVarQueryParameter['body.refundMethod'] = bodyRefundMethod;
            }
            if (bodyAutoRefund !== undefined) {
                localVarQueryParameter['body.autoRefund'] = bodyAutoRefund;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceRefundPaymentMailer: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('paymentServiceRefundPaymentMailer', 'id', id);
            const localVarPath = `/v1/refund-payments/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelTransferPaymentRequest} modelTransferPaymentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceTransferPayment: async (modelTransferPaymentRequest, options = {}) => {
            // verify required parameter 'modelTransferPaymentRequest' is not null or undefined
            (0, common_1.assertParamExists)('paymentServiceTransferPayment', 'modelTransferPaymentRequest', modelTransferPaymentRequest);
            const localVarPath = `/v1/transfer-payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelTransferPaymentRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelTransferPaymentRequest} modelTransferPaymentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceUndoTransfer: async (modelTransferPaymentRequest, options = {}) => {
            // verify required parameter 'modelTransferPaymentRequest' is not null or undefined
            (0, common_1.assertParamExists)('paymentServiceUndoTransfer', 'modelTransferPaymentRequest', modelTransferPaymentRequest);
            const localVarPath = `/v1/undo-transfer-payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelTransferPaymentRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {ModelPaymentRequest} modelPaymentRequest
         * @param {string} [secret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceUpdateById: async (id, modelPaymentRequest, secret, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('paymentServiceUpdateById', 'id', id);
            // verify required parameter 'modelPaymentRequest' is not null or undefined
            (0, common_1.assertParamExists)('paymentServiceUpdateById', 'modelPaymentRequest', modelPaymentRequest);
            const localVarPath = `/v1/payments/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (secret !== undefined) {
                localVarQueryParameter['secret'] = secret;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPaymentRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PaymentServiceApiAxiosParamCreator = PaymentServiceApiAxiosParamCreator;
/**
 * PaymentServiceApi - functional programming interface
 * @export
 */
const PaymentServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PaymentServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelPaymentRequest} modelPaymentRequest
         * @param {string} [id]
         * @param {string} [secret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceCreate(modelPaymentRequest, id, secret, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceCreate(modelPaymentRequest, id, secret, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceApi.paymentServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelOfflinePaymentRequest} modelOfflinePaymentRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceCreateOffline(modelOfflinePaymentRequest, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceCreateOffline(modelOfflinePaymentRequest, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceApi.paymentServiceCreateOffline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceDelete(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceApi.paymentServiceDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceDeleteOffline(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceDeleteOffline(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceApi.paymentServiceDeleteOffline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {string} [verify]
         * @param {string} [force]
         * @param {string} [msisdn]
         * @param {string} [token]
         * @param {boolean} [isEmbeddedCheckout]
         * @param {string} [registrationId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceGet(id, verify, force, msisdn, token, isEmbeddedCheckout, registrationId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceGet(id, verify, force, msisdn, token, isEmbeddedCheckout, registrationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceApi.paymentServiceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [skip] The number of results to skip for pagination.
         * @param {number} [limit] The maximum number of results to return.
         * @param {boolean} [paid] Filter payments by paid status.
         * @param {string} [orderId] Filter payments by order ID.
         * @param {string} [paymentPlanId] Filter payments by payment plan ID.
         * @param {string} [userId] Filter payments by user ID.
         * @param {string} [fromDate] The start date for filtering payments (ISO 8601 format).
         * @param {string} [toDate] The end date for filtering payments (ISO 8601 format).
         * @param {string} [method] Filter payments by payment method (e.g., card, eft, cash).
         * @param {string} [type] Filter payments by payment type.
         * @param {string} [search] Search term to filter payments.
         * @param {string} [fromDatePayments] Filter by payment creation start date (ISO 8601 format).
         * @param {string} [toDatePayments] Filter by payment creation end date (ISO 8601 format).
         * @param {string} [settled] Filter payments by settlement status (true, false, or null).
         * @param {string} [sort] Array of fields by which to sort the results. Prefix with \&#39;-\&#39; for descending order.
         * @param {boolean} [failed] Filter payments by failed status.
         * @param {string} [provider] Filter payments by payment provider (e.g., PEACH, ABSA, PAYAT, DASHPAY).
         * @param {string} [destinationId] Filter payments by destination ID.
         * @param {string} [destinationType] Filter payments by destination type (e.g., paymentPlan, order).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceGetMany(skip, limit, paid, orderId, paymentPlanId, userId, fromDate, toDate, method, type, search, fromDatePayments, toDatePayments, settled, sort, failed, provider, destinationId, destinationType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceGetMany(skip, limit, paid, orderId, paymentPlanId, userId, fromDate, toDate, method, type, search, fromDatePayments, toDatePayments, settled, sort, failed, provider, destinationId, destinationType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceApi.paymentServiceGetMany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [bodyAmount]
         * @param {string} [bodyRefundReference]
         * @param {string} [bodyPaymentId]
         * @param {boolean} [bodyExcludeFees]
         * @param {string} [bodyRefundMethod]
         * @param {boolean} [bodyAutoRefund]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceManualRefund(bodyAmount, bodyRefundReference, bodyPaymentId, bodyExcludeFees, bodyRefundMethod, bodyAutoRefund, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceManualRefund(bodyAmount, bodyRefundReference, bodyPaymentId, bodyExcludeFees, bodyRefundMethod, bodyAutoRefund, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceApi.paymentServiceManualRefund']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [bodyAmount]
         * @param {string} [bodyRefundReference]
         * @param {string} [bodyPaymentId]
         * @param {boolean} [bodyExcludeFees]
         * @param {string} [bodyRefundMethod]
         * @param {boolean} [bodyAutoRefund]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceRealtimeRefund(bodyAmount, bodyRefundReference, bodyPaymentId, bodyExcludeFees, bodyRefundMethod, bodyAutoRefund, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceRealtimeRefund(bodyAmount, bodyRefundReference, bodyPaymentId, bodyExcludeFees, bodyRefundMethod, bodyAutoRefund, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceApi.paymentServiceRealtimeRefund']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [bodyAmount]
         * @param {string} [bodyRefundReference]
         * @param {string} [bodyPaymentId]
         * @param {boolean} [bodyExcludeFees]
         * @param {string} [bodyRefundMethod]
         * @param {boolean} [bodyAutoRefund]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceRefund(bodyAmount, bodyRefundReference, bodyPaymentId, bodyExcludeFees, bodyRefundMethod, bodyAutoRefund, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceRefund(bodyAmount, bodyRefundReference, bodyPaymentId, bodyExcludeFees, bodyRefundMethod, bodyAutoRefund, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceApi.paymentServiceRefund']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceRefundPaymentMailer(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceRefundPaymentMailer(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceApi.paymentServiceRefundPaymentMailer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelTransferPaymentRequest} modelTransferPaymentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceTransferPayment(modelTransferPaymentRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceTransferPayment(modelTransferPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceApi.paymentServiceTransferPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelTransferPaymentRequest} modelTransferPaymentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceUndoTransfer(modelTransferPaymentRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceUndoTransfer(modelTransferPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceApi.paymentServiceUndoTransfer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {ModelPaymentRequest} modelPaymentRequest
         * @param {string} [secret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceUpdateById(id, modelPaymentRequest, secret, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceUpdateById(id, modelPaymentRequest, secret, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceApi.paymentServiceUpdateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.PaymentServiceApiFp = PaymentServiceApiFp;
/**
 * PaymentServiceApi - factory interface
 * @export
 */
const PaymentServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PaymentServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {PaymentServiceApiPaymentServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceCreate(requestParameters, options) {
            return localVarFp.paymentServiceCreate(requestParameters.modelPaymentRequest, requestParameters.id, requestParameters.secret, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentServiceApiPaymentServiceCreateOfflineRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceCreateOffline(requestParameters, options) {
            return localVarFp.paymentServiceCreateOffline(requestParameters.modelOfflinePaymentRequest, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentServiceApiPaymentServiceDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceDelete(requestParameters = {}, options) {
            return localVarFp.paymentServiceDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentServiceApiPaymentServiceDeleteOfflineRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceDeleteOffline(requestParameters, options) {
            return localVarFp.paymentServiceDeleteOffline(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentServiceApiPaymentServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceGet(requestParameters, options) {
            return localVarFp.paymentServiceGet(requestParameters.id, requestParameters.verify, requestParameters.force, requestParameters.msisdn, requestParameters.token, requestParameters.isEmbeddedCheckout, requestParameters.registrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentServiceApiPaymentServiceGetManyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceGetMany(requestParameters = {}, options) {
            return localVarFp.paymentServiceGetMany(requestParameters.skip, requestParameters.limit, requestParameters.paid, requestParameters.orderId, requestParameters.paymentPlanId, requestParameters.userId, requestParameters.fromDate, requestParameters.toDate, requestParameters.method, requestParameters.type, requestParameters.search, requestParameters.fromDatePayments, requestParameters.toDatePayments, requestParameters.settled, requestParameters.sort, requestParameters.failed, requestParameters.provider, requestParameters.destinationId, requestParameters.destinationType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentServiceApiPaymentServiceManualRefundRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceManualRefund(requestParameters = {}, options) {
            return localVarFp.paymentServiceManualRefund(requestParameters.bodyAmount, requestParameters.bodyRefundReference, requestParameters.bodyPaymentId, requestParameters.bodyExcludeFees, requestParameters.bodyRefundMethod, requestParameters.bodyAutoRefund, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentServiceApiPaymentServiceRealtimeRefundRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceRealtimeRefund(requestParameters = {}, options) {
            return localVarFp.paymentServiceRealtimeRefund(requestParameters.bodyAmount, requestParameters.bodyRefundReference, requestParameters.bodyPaymentId, requestParameters.bodyExcludeFees, requestParameters.bodyRefundMethod, requestParameters.bodyAutoRefund, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentServiceApiPaymentServiceRefundRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceRefund(requestParameters = {}, options) {
            return localVarFp.paymentServiceRefund(requestParameters.bodyAmount, requestParameters.bodyRefundReference, requestParameters.bodyPaymentId, requestParameters.bodyExcludeFees, requestParameters.bodyRefundMethod, requestParameters.bodyAutoRefund, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentServiceApiPaymentServiceRefundPaymentMailerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceRefundPaymentMailer(requestParameters, options) {
            return localVarFp.paymentServiceRefundPaymentMailer(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentServiceApiPaymentServiceTransferPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceTransferPayment(requestParameters, options) {
            return localVarFp.paymentServiceTransferPayment(requestParameters.modelTransferPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentServiceApiPaymentServiceUndoTransferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceUndoTransfer(requestParameters, options) {
            return localVarFp.paymentServiceUndoTransfer(requestParameters.modelTransferPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentServiceApiPaymentServiceUpdateByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceUpdateById(requestParameters, options) {
            return localVarFp.paymentServiceUpdateById(requestParameters.id, requestParameters.modelPaymentRequest, requestParameters.secret, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PaymentServiceApiFactory = PaymentServiceApiFactory;
/**
 * PaymentServiceApi - object-oriented interface
 * @export
 * @class PaymentServiceApi
 * @extends {BaseAPI}
 */
class PaymentServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {PaymentServiceApiPaymentServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceApi
     */
    paymentServiceCreate(requestParameters, options) {
        return (0, exports.PaymentServiceApiFp)(this.configuration).paymentServiceCreate(requestParameters.modelPaymentRequest, requestParameters.id, requestParameters.secret, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentServiceApiPaymentServiceCreateOfflineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceApi
     */
    paymentServiceCreateOffline(requestParameters, options) {
        return (0, exports.PaymentServiceApiFp)(this.configuration).paymentServiceCreateOffline(requestParameters.modelOfflinePaymentRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentServiceApiPaymentServiceDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceApi
     */
    paymentServiceDelete(requestParameters = {}, options) {
        return (0, exports.PaymentServiceApiFp)(this.configuration).paymentServiceDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentServiceApiPaymentServiceDeleteOfflineRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceApi
     */
    paymentServiceDeleteOffline(requestParameters, options) {
        return (0, exports.PaymentServiceApiFp)(this.configuration).paymentServiceDeleteOffline(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentServiceApiPaymentServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceApi
     */
    paymentServiceGet(requestParameters, options) {
        return (0, exports.PaymentServiceApiFp)(this.configuration).paymentServiceGet(requestParameters.id, requestParameters.verify, requestParameters.force, requestParameters.msisdn, requestParameters.token, requestParameters.isEmbeddedCheckout, requestParameters.registrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentServiceApiPaymentServiceGetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceApi
     */
    paymentServiceGetMany(requestParameters = {}, options) {
        return (0, exports.PaymentServiceApiFp)(this.configuration).paymentServiceGetMany(requestParameters.skip, requestParameters.limit, requestParameters.paid, requestParameters.orderId, requestParameters.paymentPlanId, requestParameters.userId, requestParameters.fromDate, requestParameters.toDate, requestParameters.method, requestParameters.type, requestParameters.search, requestParameters.fromDatePayments, requestParameters.toDatePayments, requestParameters.settled, requestParameters.sort, requestParameters.failed, requestParameters.provider, requestParameters.destinationId, requestParameters.destinationType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentServiceApiPaymentServiceManualRefundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceApi
     */
    paymentServiceManualRefund(requestParameters = {}, options) {
        return (0, exports.PaymentServiceApiFp)(this.configuration).paymentServiceManualRefund(requestParameters.bodyAmount, requestParameters.bodyRefundReference, requestParameters.bodyPaymentId, requestParameters.bodyExcludeFees, requestParameters.bodyRefundMethod, requestParameters.bodyAutoRefund, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentServiceApiPaymentServiceRealtimeRefundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceApi
     */
    paymentServiceRealtimeRefund(requestParameters = {}, options) {
        return (0, exports.PaymentServiceApiFp)(this.configuration).paymentServiceRealtimeRefund(requestParameters.bodyAmount, requestParameters.bodyRefundReference, requestParameters.bodyPaymentId, requestParameters.bodyExcludeFees, requestParameters.bodyRefundMethod, requestParameters.bodyAutoRefund, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentServiceApiPaymentServiceRefundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceApi
     */
    paymentServiceRefund(requestParameters = {}, options) {
        return (0, exports.PaymentServiceApiFp)(this.configuration).paymentServiceRefund(requestParameters.bodyAmount, requestParameters.bodyRefundReference, requestParameters.bodyPaymentId, requestParameters.bodyExcludeFees, requestParameters.bodyRefundMethod, requestParameters.bodyAutoRefund, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentServiceApiPaymentServiceRefundPaymentMailerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceApi
     */
    paymentServiceRefundPaymentMailer(requestParameters, options) {
        return (0, exports.PaymentServiceApiFp)(this.configuration).paymentServiceRefundPaymentMailer(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentServiceApiPaymentServiceTransferPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceApi
     */
    paymentServiceTransferPayment(requestParameters, options) {
        return (0, exports.PaymentServiceApiFp)(this.configuration).paymentServiceTransferPayment(requestParameters.modelTransferPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentServiceApiPaymentServiceUndoTransferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceApi
     */
    paymentServiceUndoTransfer(requestParameters, options) {
        return (0, exports.PaymentServiceApiFp)(this.configuration).paymentServiceUndoTransfer(requestParameters.modelTransferPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentServiceApiPaymentServiceUpdateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceApi
     */
    paymentServiceUpdateById(requestParameters, options) {
        return (0, exports.PaymentServiceApiFp)(this.configuration).paymentServiceUpdateById(requestParameters.id, requestParameters.modelPaymentRequest, requestParameters.secret, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PaymentServiceApi = PaymentServiceApi;
/**
 * PaymentServiceV2Api - axios parameter creator
 * @export
 */
const PaymentServiceV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelPaymentRequestV2} modelPaymentRequestV2
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceV2Create: async (modelPaymentRequestV2, id, options = {}) => {
            // verify required parameter 'modelPaymentRequestV2' is not null or undefined
            (0, common_1.assertParamExists)('paymentServiceV2Create', 'modelPaymentRequestV2', modelPaymentRequestV2);
            const localVarPath = `/v2/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelPaymentRequestV2, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [merchantId]
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {boolean} [paid]
         * @param {string} [orderId]
         * @param {string} [paymentPlanId]
         * @param {string} [userId]
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {string} [method]
         * @param {string} [type]
         * @param {string} [search]
         * @param {string} [fromDatePayments]
         * @param {string} [toDatePayments]
         * @param {string} [settled]
         * @param {string} [sort]
         * @param {boolean} [failed]
         * @param {string} [provider]
         * @param {string} [destinationId]
         * @param {string} [destinationType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceV2GetReport: async (merchantId, skip, limit, paid, orderId, paymentPlanId, userId, fromDate, toDate, method, type, search, fromDatePayments, toDatePayments, settled, sort, failed, provider, destinationId, destinationType, options = {}) => {
            const localVarPath = `/v2/payments-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (paid !== undefined) {
                localVarQueryParameter['paid'] = paid;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (paymentPlanId !== undefined) {
                localVarQueryParameter['paymentPlanId'] = paymentPlanId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }
            if (method !== undefined) {
                localVarQueryParameter['method'] = method;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (fromDatePayments !== undefined) {
                localVarQueryParameter['fromDatePayments'] = fromDatePayments;
            }
            if (toDatePayments !== undefined) {
                localVarQueryParameter['toDatePayments'] = toDatePayments;
            }
            if (settled !== undefined) {
                localVarQueryParameter['settled'] = settled;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (failed !== undefined) {
                localVarQueryParameter['failed'] = failed;
            }
            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }
            if (destinationId !== undefined) {
                localVarQueryParameter['destinationId'] = destinationId;
            }
            if (destinationType !== undefined) {
                localVarQueryParameter['destinationType'] = destinationType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PaymentServiceV2ApiAxiosParamCreator = PaymentServiceV2ApiAxiosParamCreator;
/**
 * PaymentServiceV2Api - functional programming interface
 * @export
 */
const PaymentServiceV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PaymentServiceV2ApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelPaymentRequestV2} modelPaymentRequestV2
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceV2Create(modelPaymentRequestV2, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceV2Create(modelPaymentRequestV2, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceV2Api.paymentServiceV2Create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [merchantId]
         * @param {number} [skip]
         * @param {number} [limit]
         * @param {boolean} [paid]
         * @param {string} [orderId]
         * @param {string} [paymentPlanId]
         * @param {string} [userId]
         * @param {string} [fromDate]
         * @param {string} [toDate]
         * @param {string} [method]
         * @param {string} [type]
         * @param {string} [search]
         * @param {string} [fromDatePayments]
         * @param {string} [toDatePayments]
         * @param {string} [settled]
         * @param {string} [sort]
         * @param {boolean} [failed]
         * @param {string} [provider]
         * @param {string} [destinationId]
         * @param {string} [destinationType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentServiceV2GetReport(merchantId, skip, limit, paid, orderId, paymentPlanId, userId, fromDate, toDate, method, type, search, fromDatePayments, toDatePayments, settled, sort, failed, provider, destinationId, destinationType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentServiceV2GetReport(merchantId, skip, limit, paid, orderId, paymentPlanId, userId, fromDate, toDate, method, type, search, fromDatePayments, toDatePayments, settled, sort, failed, provider, destinationId, destinationType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['PaymentServiceV2Api.paymentServiceV2GetReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.PaymentServiceV2ApiFp = PaymentServiceV2ApiFp;
/**
 * PaymentServiceV2Api - factory interface
 * @export
 */
const PaymentServiceV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PaymentServiceV2ApiFp)(configuration);
    return {
        /**
         *
         * @param {PaymentServiceV2ApiPaymentServiceV2CreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceV2Create(requestParameters, options) {
            return localVarFp.paymentServiceV2Create(requestParameters.modelPaymentRequestV2, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PaymentServiceV2ApiPaymentServiceV2GetReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentServiceV2GetReport(requestParameters = {}, options) {
            return localVarFp.paymentServiceV2GetReport(requestParameters.merchantId, requestParameters.skip, requestParameters.limit, requestParameters.paid, requestParameters.orderId, requestParameters.paymentPlanId, requestParameters.userId, requestParameters.fromDate, requestParameters.toDate, requestParameters.method, requestParameters.type, requestParameters.search, requestParameters.fromDatePayments, requestParameters.toDatePayments, requestParameters.settled, requestParameters.sort, requestParameters.failed, requestParameters.provider, requestParameters.destinationId, requestParameters.destinationType, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PaymentServiceV2ApiFactory = PaymentServiceV2ApiFactory;
/**
 * PaymentServiceV2Api - object-oriented interface
 * @export
 * @class PaymentServiceV2Api
 * @extends {BaseAPI}
 */
class PaymentServiceV2Api extends base_1.BaseAPI {
    /**
     *
     * @param {PaymentServiceV2ApiPaymentServiceV2CreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceV2Api
     */
    paymentServiceV2Create(requestParameters, options) {
        return (0, exports.PaymentServiceV2ApiFp)(this.configuration).paymentServiceV2Create(requestParameters.modelPaymentRequestV2, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PaymentServiceV2ApiPaymentServiceV2GetReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentServiceV2Api
     */
    paymentServiceV2GetReport(requestParameters = {}, options) {
        return (0, exports.PaymentServiceV2ApiFp)(this.configuration).paymentServiceV2GetReport(requestParameters.merchantId, requestParameters.skip, requestParameters.limit, requestParameters.paid, requestParameters.orderId, requestParameters.paymentPlanId, requestParameters.userId, requestParameters.fromDate, requestParameters.toDate, requestParameters.method, requestParameters.type, requestParameters.search, requestParameters.fromDatePayments, requestParameters.toDatePayments, requestParameters.settled, requestParameters.sort, requestParameters.failed, requestParameters.provider, requestParameters.destinationId, requestParameters.destinationType, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PaymentServiceV2Api = PaymentServiceV2Api;
/**
 * SettlementServiceApi - axios parameter creator
 * @export
 */
const SettlementServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelSettlementRequest} modelSettlementRequest
         * @param {string} [id]
         * @param {string} [taskToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlementServiceCreate: async (modelSettlementRequest, id, taskToken, options = {}) => {
            // verify required parameter 'modelSettlementRequest' is not null or undefined
            (0, common_1.assertParamExists)('settlementServiceCreate', 'modelSettlementRequest', modelSettlementRequest);
            const localVarPath = `/v2/settlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            if (taskToken !== undefined) {
                localVarQueryParameter['taskToken'] = taskToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelSettlementRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Redirect to pre-signed URL
         * @param {string} merchantId
         * @param {string} settlementReferenceWithExtension The settlement reference with file extension.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlementServiceDownloadReport: async (merchantId, settlementReferenceWithExtension, options = {}) => {
            // verify required parameter 'merchantId' is not null or undefined
            (0, common_1.assertParamExists)('settlementServiceDownloadReport', 'merchantId', merchantId);
            // verify required parameter 'settlementReferenceWithExtension' is not null or undefined
            (0, common_1.assertParamExists)('settlementServiceDownloadReport', 'settlementReferenceWithExtension', settlementReferenceWithExtension);
            const localVarPath = `/v3/settlement-reports/{merchantId}/{settlementReferenceWithExtension}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"settlementReferenceWithExtension"}}`, encodeURIComponent(String(settlementReferenceWithExtension)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Redirect to pre-signed URL
         * @param {string} settlementReferenceWithExtension The settlement reference with file extension.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlementServiceDownloadReportV3: async (settlementReferenceWithExtension, options = {}) => {
            // verify required parameter 'settlementReferenceWithExtension' is not null or undefined
            (0, common_1.assertParamExists)('settlementServiceDownloadReportV3', 'settlementReferenceWithExtension', settlementReferenceWithExtension);
            const localVarPath = `/v3/settlements/files/{settlementReferenceWithExtension}`
                .replace(`{${"settlementReferenceWithExtension"}}`, encodeURIComponent(String(settlementReferenceWithExtension)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit] The maximum number of results to return.
         * @param {number} [skip] The number of results to skip.
         * @param {string} [fromDate] The start date for the report.
         * @param {string} [toDate] The end date for the report.
         * @param {string} [search] Search term to filter results.
         * @param {string} [sort] The field by which to sort the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlementServiceGetReport: async (limit, skip, fromDate, toDate, search, sort, options = {}) => {
            const localVarPath = `/v2/settlements-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {boolean} [report]
         * @param {boolean} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlementServiceGetSettlement: async (id, report, email, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('settlementServiceGetSettlement', 'id', id);
            const localVarPath = `/v2/settlements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (report !== undefined) {
                localVarQueryParameter['report'] = report;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit] The maximum number of results to return.
         * @param {number} [skip] The number of results to skip.
         * @param {string} [fromDate] The start date for the report.
         * @param {string} [toDate] The end date for the report.
         * @param {string} [search] Search term to filter results.
         * @param {string} [sort] The field by which to sort the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlementServiceGetSettlements: async (limit, skip, fromDate, toDate, search, sort, options = {}) => {
            const localVarPath = `/v3/settlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }
            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.SettlementServiceApiAxiosParamCreator = SettlementServiceApiAxiosParamCreator;
/**
 * SettlementServiceApi - functional programming interface
 * @export
 */
const SettlementServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SettlementServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelSettlementRequest} modelSettlementRequest
         * @param {string} [id]
         * @param {string} [taskToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settlementServiceCreate(modelSettlementRequest, id, taskToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settlementServiceCreate(modelSettlementRequest, id, taskToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['SettlementServiceApi.settlementServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Redirect to pre-signed URL
         * @param {string} merchantId
         * @param {string} settlementReferenceWithExtension The settlement reference with file extension.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settlementServiceDownloadReport(merchantId, settlementReferenceWithExtension, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settlementServiceDownloadReport(merchantId, settlementReferenceWithExtension, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['SettlementServiceApi.settlementServiceDownloadReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Redirect to pre-signed URL
         * @param {string} settlementReferenceWithExtension The settlement reference with file extension.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settlementServiceDownloadReportV3(settlementReferenceWithExtension, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settlementServiceDownloadReportV3(settlementReferenceWithExtension, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['SettlementServiceApi.settlementServiceDownloadReportV3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [limit] The maximum number of results to return.
         * @param {number} [skip] The number of results to skip.
         * @param {string} [fromDate] The start date for the report.
         * @param {string} [toDate] The end date for the report.
         * @param {string} [search] Search term to filter results.
         * @param {string} [sort] The field by which to sort the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settlementServiceGetReport(limit, skip, fromDate, toDate, search, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settlementServiceGetReport(limit, skip, fromDate, toDate, search, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['SettlementServiceApi.settlementServiceGetReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {boolean} [report]
         * @param {boolean} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settlementServiceGetSettlement(id, report, email, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settlementServiceGetSettlement(id, report, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['SettlementServiceApi.settlementServiceGetSettlement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [limit] The maximum number of results to return.
         * @param {number} [skip] The number of results to skip.
         * @param {string} [fromDate] The start date for the report.
         * @param {string} [toDate] The end date for the report.
         * @param {string} [search] Search term to filter results.
         * @param {string} [sort] The field by which to sort the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settlementServiceGetSettlements(limit, skip, fromDate, toDate, search, sort, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settlementServiceGetSettlements(limit, skip, fromDate, toDate, search, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['SettlementServiceApi.settlementServiceGetSettlements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.SettlementServiceApiFp = SettlementServiceApiFp;
/**
 * SettlementServiceApi - factory interface
 * @export
 */
const SettlementServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SettlementServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {SettlementServiceApiSettlementServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlementServiceCreate(requestParameters, options) {
            return localVarFp.settlementServiceCreate(requestParameters.modelSettlementRequest, requestParameters.id, requestParameters.taskToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Redirect to pre-signed URL
         * @param {SettlementServiceApiSettlementServiceDownloadReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlementServiceDownloadReport(requestParameters, options) {
            return localVarFp.settlementServiceDownloadReport(requestParameters.merchantId, requestParameters.settlementReferenceWithExtension, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Redirect to pre-signed URL
         * @param {SettlementServiceApiSettlementServiceDownloadReportV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlementServiceDownloadReportV3(requestParameters, options) {
            return localVarFp.settlementServiceDownloadReportV3(requestParameters.settlementReferenceWithExtension, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SettlementServiceApiSettlementServiceGetReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlementServiceGetReport(requestParameters = {}, options) {
            return localVarFp.settlementServiceGetReport(requestParameters.limit, requestParameters.skip, requestParameters.fromDate, requestParameters.toDate, requestParameters.search, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SettlementServiceApiSettlementServiceGetSettlementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlementServiceGetSettlement(requestParameters, options) {
            return localVarFp.settlementServiceGetSettlement(requestParameters.id, requestParameters.report, requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SettlementServiceApiSettlementServiceGetSettlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settlementServiceGetSettlements(requestParameters = {}, options) {
            return localVarFp.settlementServiceGetSettlements(requestParameters.limit, requestParameters.skip, requestParameters.fromDate, requestParameters.toDate, requestParameters.search, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SettlementServiceApiFactory = SettlementServiceApiFactory;
/**
 * SettlementServiceApi - object-oriented interface
 * @export
 * @class SettlementServiceApi
 * @extends {BaseAPI}
 */
class SettlementServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {SettlementServiceApiSettlementServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettlementServiceApi
     */
    settlementServiceCreate(requestParameters, options) {
        return (0, exports.SettlementServiceApiFp)(this.configuration).settlementServiceCreate(requestParameters.modelSettlementRequest, requestParameters.id, requestParameters.taskToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Redirect to pre-signed URL
     * @param {SettlementServiceApiSettlementServiceDownloadReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettlementServiceApi
     */
    settlementServiceDownloadReport(requestParameters, options) {
        return (0, exports.SettlementServiceApiFp)(this.configuration).settlementServiceDownloadReport(requestParameters.merchantId, requestParameters.settlementReferenceWithExtension, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Redirect to pre-signed URL
     * @param {SettlementServiceApiSettlementServiceDownloadReportV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettlementServiceApi
     */
    settlementServiceDownloadReportV3(requestParameters, options) {
        return (0, exports.SettlementServiceApiFp)(this.configuration).settlementServiceDownloadReportV3(requestParameters.settlementReferenceWithExtension, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SettlementServiceApiSettlementServiceGetReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettlementServiceApi
     */
    settlementServiceGetReport(requestParameters = {}, options) {
        return (0, exports.SettlementServiceApiFp)(this.configuration).settlementServiceGetReport(requestParameters.limit, requestParameters.skip, requestParameters.fromDate, requestParameters.toDate, requestParameters.search, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SettlementServiceApiSettlementServiceGetSettlementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettlementServiceApi
     */
    settlementServiceGetSettlement(requestParameters, options) {
        return (0, exports.SettlementServiceApiFp)(this.configuration).settlementServiceGetSettlement(requestParameters.id, requestParameters.report, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SettlementServiceApiSettlementServiceGetSettlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettlementServiceApi
     */
    settlementServiceGetSettlements(requestParameters = {}, options) {
        return (0, exports.SettlementServiceApiFp)(this.configuration).settlementServiceGetSettlements(requestParameters.limit, requestParameters.skip, requestParameters.fromDate, requestParameters.toDate, requestParameters.search, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SettlementServiceApi = SettlementServiceApi;
/**
 * ShopifyServiceApi - axios parameter creator
 * @export
 */
const ShopifyServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [customerDataFirstName]
         * @param {string} [customerDataLastName]
         * @param {string} [customerDataEmail]
         * @param {string} [customerDataPhone]
         * @param {string} [customerDataAddress]
         * @param {string} [customerDataAddress2]
         * @param {string} [customerDataCity]
         * @param {string} [customerDataProvince]
         * @param {string} [customerDataPostalCode]
         * @param {string} [shopDomain]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceCalculateShipping: async (customerDataFirstName, customerDataLastName, customerDataEmail, customerDataPhone, customerDataAddress, customerDataAddress2, customerDataCity, customerDataProvince, customerDataPostalCode, shopDomain, options = {}) => {
            const localVarPath = `/v1/integrations/shopify/calculate-shipping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (customerDataFirstName !== undefined) {
                localVarQueryParameter['customerData.firstName'] = customerDataFirstName;
            }
            if (customerDataLastName !== undefined) {
                localVarQueryParameter['customerData.lastName'] = customerDataLastName;
            }
            if (customerDataEmail !== undefined) {
                localVarQueryParameter['customerData.email'] = customerDataEmail;
            }
            if (customerDataPhone !== undefined) {
                localVarQueryParameter['customerData.phone'] = customerDataPhone;
            }
            if (customerDataAddress !== undefined) {
                localVarQueryParameter['customerData.address'] = customerDataAddress;
            }
            if (customerDataAddress2 !== undefined) {
                localVarQueryParameter['customerData.address2'] = customerDataAddress2;
            }
            if (customerDataCity !== undefined) {
                localVarQueryParameter['customerData.city'] = customerDataCity;
            }
            if (customerDataProvince !== undefined) {
                localVarQueryParameter['customerData.province'] = customerDataProvince;
            }
            if (customerDataPostalCode !== undefined) {
                localVarQueryParameter['customerData.postalCode'] = customerDataPostalCode;
            }
            if (shopDomain !== undefined) {
                localVarQueryParameter['shopDomain'] = shopDomain;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shopDomain1
         * @param {string} [accessToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceCreateShop: async (shopDomain1, accessToken, options = {}) => {
            // verify required parameter 'shopDomain1' is not null or undefined
            (0, common_1.assertParamExists)('shopifyServiceCreateShop', 'shopDomain1', shopDomain1);
            const localVarPath = `/v1/integrations/shopify/shop-settings/{shopDomain_1}`
                .replace(`{${"shopDomain_1"}}`, encodeURIComponent(String(shopDomain1)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (accessToken !== undefined) {
                localVarQueryParameter['accessToken'] = accessToken;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shopDomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceDeleteShop: async (shopDomain, options = {}) => {
            // verify required parameter 'shopDomain' is not null or undefined
            (0, common_1.assertParamExists)('shopifyServiceDeleteShop', 'shopDomain', shopDomain);
            const localVarPath = `/v1/integrations/shopify/uninstall/{shopDomain}`
                .replace(`{${"shopDomain"}}`, encodeURIComponent(String(shopDomain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shopDomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceGetLinkedOrders: async (shopDomain, options = {}) => {
            // verify required parameter 'shopDomain' is not null or undefined
            (0, common_1.assertParamExists)('shopifyServiceGetLinkedOrders', 'shopDomain', shopDomain);
            const localVarPath = `/v1/integrations/shopify/linked-orders/{shopDomain}`
                .replace(`{${"shopDomain"}}`, encodeURIComponent(String(shopDomain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [shopDomain]
         * @param {string} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceGetOrderNotes: async (shopDomain, orderId, options = {}) => {
            const localVarPath = `/v1/integrations/shopify/shopify-order-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (shopDomain !== undefined) {
                localVarQueryParameter['shopDomain'] = shopDomain;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shopDomain
         * @param {string} [accessToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceGetShopSettings: async (shopDomain, accessToken, options = {}) => {
            // verify required parameter 'shopDomain' is not null or undefined
            (0, common_1.assertParamExists)('shopifyServiceGetShopSettings', 'shopDomain', shopDomain);
            const localVarPath = `/v1/integrations/shopify/shop-settings/{shopDomain}`
                .replace(`{${"shopDomain"}}`, encodeURIComponent(String(shopDomain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (accessToken !== undefined) {
                localVarQueryParameter['accessToken'] = accessToken;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [shopDomain]
         * @param {string} [draftOrderId]
         * @param {string} [draftOrderStatus]
         * @param {string} [draftOrderCreatedAt]
         * @param {string} [draftOrderName]
         * @param {string} [draftOrderCustomerName]
         * @param {string} [draftOrderCustomerEmail]
         * @param {string} [draftOrderCustomerPhone]
         * @param {string} [draftOrderCustomerDisplayName]
         * @param {string} [draftOrderTotalPriceSet]
         * @param {boolean} [draftOrderTaxesIncluded]
         * @param {string} [draftOrderShippingLineDiscountedPriceSet]
         * @param {string} [draftOrderTotalTaxSet]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceLinkOrder: async (shopDomain, draftOrderId, draftOrderStatus, draftOrderCreatedAt, draftOrderName, draftOrderCustomerName, draftOrderCustomerEmail, draftOrderCustomerPhone, draftOrderCustomerDisplayName, draftOrderTotalPriceSet, draftOrderTaxesIncluded, draftOrderShippingLineDiscountedPriceSet, draftOrderTotalTaxSet, options = {}) => {
            const localVarPath = `/v1/integrations/shopify/link-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (shopDomain !== undefined) {
                localVarQueryParameter['shopDomain'] = shopDomain;
            }
            if (draftOrderId !== undefined) {
                localVarQueryParameter['draftOrder.id'] = draftOrderId;
            }
            if (draftOrderStatus !== undefined) {
                localVarQueryParameter['draftOrder.status'] = draftOrderStatus;
            }
            if (draftOrderCreatedAt !== undefined) {
                localVarQueryParameter['draftOrder.createdAt'] = draftOrderCreatedAt;
            }
            if (draftOrderName !== undefined) {
                localVarQueryParameter['draftOrder.name'] = draftOrderName;
            }
            if (draftOrderCustomerName !== undefined) {
                localVarQueryParameter['draftOrder.customer.name'] = draftOrderCustomerName;
            }
            if (draftOrderCustomerEmail !== undefined) {
                localVarQueryParameter['draftOrder.customer.email'] = draftOrderCustomerEmail;
            }
            if (draftOrderCustomerPhone !== undefined) {
                localVarQueryParameter['draftOrder.customer.phone'] = draftOrderCustomerPhone;
            }
            if (draftOrderCustomerDisplayName !== undefined) {
                localVarQueryParameter['draftOrder.customer.displayName'] = draftOrderCustomerDisplayName;
            }
            if (draftOrderTotalPriceSet !== undefined) {
                localVarQueryParameter['draftOrder.totalPriceSet'] = draftOrderTotalPriceSet;
            }
            if (draftOrderTaxesIncluded !== undefined) {
                localVarQueryParameter['draftOrder.taxesIncluded'] = draftOrderTaxesIncluded;
            }
            if (draftOrderShippingLineDiscountedPriceSet !== undefined) {
                localVarQueryParameter['draftOrder.shippingLine.discountedPriceSet'] = draftOrderShippingLineDiscountedPriceSet;
            }
            if (draftOrderTotalTaxSet !== undefined) {
                localVarQueryParameter['draftOrder.totalTaxSet'] = draftOrderTotalTaxSet;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [discountCode]
         * @param {string} [shopDomain]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceProcessDiscount: async (discountCode, shopDomain, options = {}) => {
            const localVarPath = `/v1/integrations/shopify/discounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (discountCode !== undefined) {
                localVarQueryParameter['discountCode'] = discountCode;
            }
            if (shopDomain !== undefined) {
                localVarQueryParameter['shopDomain'] = shopDomain;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [shopDomain]
         * @param {number} [amount]
         * @param {string} [shippingDataAmount]
         * @param {string} [shippingDataHandle]
         * @param {string} [shippingDataTitle]
         * @param {string} [discountDiscountType]
         * @param {string} [discountDiscountValue]
         * @param {string} [discountDiscountAllocation]
         * @param {string} [discountDiscountSelection]
         * @param {string} [discountDiscountTitle]
         * @param {Array<number>} [discountEntitledProductIds]
         * @param {Array<number>} [discountEntitledVariantIds]
         * @param {string} [locationData]
         * @param {string} [customerDataFirstName]
         * @param {string} [customerDataLastName]
         * @param {string} [customerDataEmail]
         * @param {string} [customerDataPhone]
         * @param {string} [customerDataAddress]
         * @param {string} [customerDataAddress2]
         * @param {string} [customerDataCity]
         * @param {string} [customerDataProvince]
         * @param {string} [customerDataPostalCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceProcessOrder: async (shopDomain, amount, shippingDataAmount, shippingDataHandle, shippingDataTitle, discountDiscountType, discountDiscountValue, discountDiscountAllocation, discountDiscountSelection, discountDiscountTitle, discountEntitledProductIds, discountEntitledVariantIds, locationData, customerDataFirstName, customerDataLastName, customerDataEmail, customerDataPhone, customerDataAddress, customerDataAddress2, customerDataCity, customerDataProvince, customerDataPostalCode, options = {}) => {
            const localVarPath = `/v1/integrations/shopify/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (shopDomain !== undefined) {
                localVarQueryParameter['shopDomain'] = shopDomain;
            }
            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }
            if (shippingDataAmount !== undefined) {
                localVarQueryParameter['shippingData.amount'] = shippingDataAmount;
            }
            if (shippingDataHandle !== undefined) {
                localVarQueryParameter['shippingData.handle'] = shippingDataHandle;
            }
            if (shippingDataTitle !== undefined) {
                localVarQueryParameter['shippingData.title'] = shippingDataTitle;
            }
            if (discountDiscountType !== undefined) {
                localVarQueryParameter['discount.discountType'] = discountDiscountType;
            }
            if (discountDiscountValue !== undefined) {
                localVarQueryParameter['discount.discountValue'] = discountDiscountValue;
            }
            if (discountDiscountAllocation !== undefined) {
                localVarQueryParameter['discount.discountAllocation'] = discountDiscountAllocation;
            }
            if (discountDiscountSelection !== undefined) {
                localVarQueryParameter['discount.discountSelection'] = discountDiscountSelection;
            }
            if (discountDiscountTitle !== undefined) {
                localVarQueryParameter['discount.discountTitle'] = discountDiscountTitle;
            }
            if (discountEntitledProductIds) {
                localVarQueryParameter['discount.entitledProductIds'] = discountEntitledProductIds;
            }
            if (discountEntitledVariantIds) {
                localVarQueryParameter['discount.entitledVariantIds'] = discountEntitledVariantIds;
            }
            if (locationData !== undefined) {
                localVarQueryParameter['locationData'] = locationData;
            }
            if (customerDataFirstName !== undefined) {
                localVarQueryParameter['customerData.firstName'] = customerDataFirstName;
            }
            if (customerDataLastName !== undefined) {
                localVarQueryParameter['customerData.lastName'] = customerDataLastName;
            }
            if (customerDataEmail !== undefined) {
                localVarQueryParameter['customerData.email'] = customerDataEmail;
            }
            if (customerDataPhone !== undefined) {
                localVarQueryParameter['customerData.phone'] = customerDataPhone;
            }
            if (customerDataAddress !== undefined) {
                localVarQueryParameter['customerData.address'] = customerDataAddress;
            }
            if (customerDataAddress2 !== undefined) {
                localVarQueryParameter['customerData.address2'] = customerDataAddress2;
            }
            if (customerDataCity !== undefined) {
                localVarQueryParameter['customerData.city'] = customerDataCity;
            }
            if (customerDataProvince !== undefined) {
                localVarQueryParameter['customerData.province'] = customerDataProvince;
            }
            if (customerDataPostalCode !== undefined) {
                localVarQueryParameter['customerData.postalCode'] = customerDataPostalCode;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} shopDomain
         * @param {string} [accessToken]
         * @param {boolean} [bodyEnabledOnAll]
         * @param {boolean} [bodyEnabledOnProduct]
         * @param {boolean} [bodyEnabledOnCart]
         * @param {boolean} [bodyEnabledAccept]
         * @param {string} [bodyAcceptMsg]
         * @param {string} [bodyAcceptBtn]
         * @param {string} [bodyTerms]
         * @param {string} [bodyLogoUrl]
         * @param {string} [bodyLearnMore]
         * @param {string} [bodyMerchantName]
         * @param {number} [bodyDeposit]
         * @param {string} [bodyDepositType]
         * @param {number} [bodyMinMonths]
         * @param {number} [bodyMaxMonths]
         * @param {boolean} [bodyEnabledDiscount]
         * @param {boolean} [bodyEnabledOnPopupCart]
         * @param {string} [bodyPopupCartSelector]
         * @param {string} [bodyPopupCartQuantitySelector]
         * @param {string} [bodyPopupCartRemoveSelector]
         * @param {string} [bodyButtonLayout]
         * @param {boolean} [bodyTestMode]
         * @param {string} [bodyMerchantId]
         * @param {string} [bodyMerchantApiKey]
         * @param {number} [bodyShippingFee]
         * @param {number} [bodyFreeShippingMin]
         * @param {string} [bodyPreviewTemplate]
         * @param {boolean} [bodyReserveStock]
         * @param {boolean} [bodyDynamicDeposit]
         * @param {boolean} [bodyKeepDraftOrders]
         * @param {string} [bodySelectorsRenderSelector]
         * @param {string} [bodySelectorsVariantSelector]
         * @param {string} [bodySelectorsQuantitySelector]
         * @param {string} [bodySelectorsCartQuantitySelector]
         * @param {string} [bodySelectorsCartRemoveSelector]
         * @param {string} [bodySelectorsCartRenderSelector]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceUpdateShop: async (shopDomain, accessToken, bodyEnabledOnAll, bodyEnabledOnProduct, bodyEnabledOnCart, bodyEnabledAccept, bodyAcceptMsg, bodyAcceptBtn, bodyTerms, bodyLogoUrl, bodyLearnMore, bodyMerchantName, bodyDeposit, bodyDepositType, bodyMinMonths, bodyMaxMonths, bodyEnabledDiscount, bodyEnabledOnPopupCart, bodyPopupCartSelector, bodyPopupCartQuantitySelector, bodyPopupCartRemoveSelector, bodyButtonLayout, bodyTestMode, bodyMerchantId, bodyMerchantApiKey, bodyShippingFee, bodyFreeShippingMin, bodyPreviewTemplate, bodyReserveStock, bodyDynamicDeposit, bodyKeepDraftOrders, bodySelectorsRenderSelector, bodySelectorsVariantSelector, bodySelectorsQuantitySelector, bodySelectorsCartQuantitySelector, bodySelectorsCartRemoveSelector, bodySelectorsCartRenderSelector, options = {}) => {
            // verify required parameter 'shopDomain' is not null or undefined
            (0, common_1.assertParamExists)('shopifyServiceUpdateShop', 'shopDomain', shopDomain);
            const localVarPath = `/v1/integrations/shopify/shop-settings/{shopDomain}`
                .replace(`{${"shopDomain"}}`, encodeURIComponent(String(shopDomain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (accessToken !== undefined) {
                localVarQueryParameter['accessToken'] = accessToken;
            }
            if (bodyEnabledOnAll !== undefined) {
                localVarQueryParameter['body.enabledOnAll'] = bodyEnabledOnAll;
            }
            if (bodyEnabledOnProduct !== undefined) {
                localVarQueryParameter['body.enabledOnProduct'] = bodyEnabledOnProduct;
            }
            if (bodyEnabledOnCart !== undefined) {
                localVarQueryParameter['body.enabledOnCart'] = bodyEnabledOnCart;
            }
            if (bodyEnabledAccept !== undefined) {
                localVarQueryParameter['body.enabledAccept'] = bodyEnabledAccept;
            }
            if (bodyAcceptMsg !== undefined) {
                localVarQueryParameter['body.acceptMsg'] = bodyAcceptMsg;
            }
            if (bodyAcceptBtn !== undefined) {
                localVarQueryParameter['body.acceptBtn'] = bodyAcceptBtn;
            }
            if (bodyTerms !== undefined) {
                localVarQueryParameter['body.terms'] = bodyTerms;
            }
            if (bodyLogoUrl !== undefined) {
                localVarQueryParameter['body.logoUrl'] = bodyLogoUrl;
            }
            if (bodyLearnMore !== undefined) {
                localVarQueryParameter['body.learnMore'] = bodyLearnMore;
            }
            if (bodyMerchantName !== undefined) {
                localVarQueryParameter['body.merchantName'] = bodyMerchantName;
            }
            if (bodyDeposit !== undefined) {
                localVarQueryParameter['body.deposit'] = bodyDeposit;
            }
            if (bodyDepositType !== undefined) {
                localVarQueryParameter['body.depositType'] = bodyDepositType;
            }
            if (bodyMinMonths !== undefined) {
                localVarQueryParameter['body.minMonths'] = bodyMinMonths;
            }
            if (bodyMaxMonths !== undefined) {
                localVarQueryParameter['body.maxMonths'] = bodyMaxMonths;
            }
            if (bodyEnabledDiscount !== undefined) {
                localVarQueryParameter['body.enabledDiscount'] = bodyEnabledDiscount;
            }
            if (bodyEnabledOnPopupCart !== undefined) {
                localVarQueryParameter['body.enabledOnPopupCart'] = bodyEnabledOnPopupCart;
            }
            if (bodyPopupCartSelector !== undefined) {
                localVarQueryParameter['body.popupCartSelector'] = bodyPopupCartSelector;
            }
            if (bodyPopupCartQuantitySelector !== undefined) {
                localVarQueryParameter['body.popupCartQuantitySelector'] = bodyPopupCartQuantitySelector;
            }
            if (bodyPopupCartRemoveSelector !== undefined) {
                localVarQueryParameter['body.popupCartRemoveSelector'] = bodyPopupCartRemoveSelector;
            }
            if (bodyButtonLayout !== undefined) {
                localVarQueryParameter['body.buttonLayout'] = bodyButtonLayout;
            }
            if (bodyTestMode !== undefined) {
                localVarQueryParameter['body.testMode'] = bodyTestMode;
            }
            if (bodyMerchantId !== undefined) {
                localVarQueryParameter['body.merchantId'] = bodyMerchantId;
            }
            if (bodyMerchantApiKey !== undefined) {
                localVarQueryParameter['body.merchantApiKey'] = bodyMerchantApiKey;
            }
            if (bodyShippingFee !== undefined) {
                localVarQueryParameter['body.shippingFee'] = bodyShippingFee;
            }
            if (bodyFreeShippingMin !== undefined) {
                localVarQueryParameter['body.freeShippingMin'] = bodyFreeShippingMin;
            }
            if (bodyPreviewTemplate !== undefined) {
                localVarQueryParameter['body.previewTemplate'] = bodyPreviewTemplate;
            }
            if (bodyReserveStock !== undefined) {
                localVarQueryParameter['body.reserveStock'] = bodyReserveStock;
            }
            if (bodyDynamicDeposit !== undefined) {
                localVarQueryParameter['body.dynamicDeposit'] = bodyDynamicDeposit;
            }
            if (bodyKeepDraftOrders !== undefined) {
                localVarQueryParameter['body.keepDraftOrders'] = bodyKeepDraftOrders;
            }
            if (bodySelectorsRenderSelector !== undefined) {
                localVarQueryParameter['body.selectors.renderSelector'] = bodySelectorsRenderSelector;
            }
            if (bodySelectorsVariantSelector !== undefined) {
                localVarQueryParameter['body.selectors.variantSelector'] = bodySelectorsVariantSelector;
            }
            if (bodySelectorsQuantitySelector !== undefined) {
                localVarQueryParameter['body.selectors.quantitySelector'] = bodySelectorsQuantitySelector;
            }
            if (bodySelectorsCartQuantitySelector !== undefined) {
                localVarQueryParameter['body.selectors.cartQuantitySelector'] = bodySelectorsCartQuantitySelector;
            }
            if (bodySelectorsCartRemoveSelector !== undefined) {
                localVarQueryParameter['body.selectors.cartRemoveSelector'] = bodySelectorsCartRemoveSelector;
            }
            if (bodySelectorsCartRenderSelector !== undefined) {
                localVarQueryParameter['body.selectors.cartRenderSelector'] = bodySelectorsCartRenderSelector;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ShopifyServiceApiAxiosParamCreator = ShopifyServiceApiAxiosParamCreator;
/**
 * ShopifyServiceApi - functional programming interface
 * @export
 */
const ShopifyServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ShopifyServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [customerDataFirstName]
         * @param {string} [customerDataLastName]
         * @param {string} [customerDataEmail]
         * @param {string} [customerDataPhone]
         * @param {string} [customerDataAddress]
         * @param {string} [customerDataAddress2]
         * @param {string} [customerDataCity]
         * @param {string} [customerDataProvince]
         * @param {string} [customerDataPostalCode]
         * @param {string} [shopDomain]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopifyServiceCalculateShipping(customerDataFirstName, customerDataLastName, customerDataEmail, customerDataPhone, customerDataAddress, customerDataAddress2, customerDataCity, customerDataProvince, customerDataPostalCode, shopDomain, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopifyServiceCalculateShipping(customerDataFirstName, customerDataLastName, customerDataEmail, customerDataPhone, customerDataAddress, customerDataAddress2, customerDataCity, customerDataProvince, customerDataPostalCode, shopDomain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['ShopifyServiceApi.shopifyServiceCalculateShipping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} shopDomain1
         * @param {string} [accessToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopifyServiceCreateShop(shopDomain1, accessToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopifyServiceCreateShop(shopDomain1, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['ShopifyServiceApi.shopifyServiceCreateShop']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} shopDomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopifyServiceDeleteShop(shopDomain, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopifyServiceDeleteShop(shopDomain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['ShopifyServiceApi.shopifyServiceDeleteShop']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} shopDomain
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopifyServiceGetLinkedOrders(shopDomain, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopifyServiceGetLinkedOrders(shopDomain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['ShopifyServiceApi.shopifyServiceGetLinkedOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [shopDomain]
         * @param {string} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopifyServiceGetOrderNotes(shopDomain, orderId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopifyServiceGetOrderNotes(shopDomain, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['ShopifyServiceApi.shopifyServiceGetOrderNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} shopDomain
         * @param {string} [accessToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopifyServiceGetShopSettings(shopDomain, accessToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopifyServiceGetShopSettings(shopDomain, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['ShopifyServiceApi.shopifyServiceGetShopSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [shopDomain]
         * @param {string} [draftOrderId]
         * @param {string} [draftOrderStatus]
         * @param {string} [draftOrderCreatedAt]
         * @param {string} [draftOrderName]
         * @param {string} [draftOrderCustomerName]
         * @param {string} [draftOrderCustomerEmail]
         * @param {string} [draftOrderCustomerPhone]
         * @param {string} [draftOrderCustomerDisplayName]
         * @param {string} [draftOrderTotalPriceSet]
         * @param {boolean} [draftOrderTaxesIncluded]
         * @param {string} [draftOrderShippingLineDiscountedPriceSet]
         * @param {string} [draftOrderTotalTaxSet]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopifyServiceLinkOrder(shopDomain, draftOrderId, draftOrderStatus, draftOrderCreatedAt, draftOrderName, draftOrderCustomerName, draftOrderCustomerEmail, draftOrderCustomerPhone, draftOrderCustomerDisplayName, draftOrderTotalPriceSet, draftOrderTaxesIncluded, draftOrderShippingLineDiscountedPriceSet, draftOrderTotalTaxSet, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopifyServiceLinkOrder(shopDomain, draftOrderId, draftOrderStatus, draftOrderCreatedAt, draftOrderName, draftOrderCustomerName, draftOrderCustomerEmail, draftOrderCustomerPhone, draftOrderCustomerDisplayName, draftOrderTotalPriceSet, draftOrderTaxesIncluded, draftOrderShippingLineDiscountedPriceSet, draftOrderTotalTaxSet, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['ShopifyServiceApi.shopifyServiceLinkOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [discountCode]
         * @param {string} [shopDomain]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopifyServiceProcessDiscount(discountCode, shopDomain, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopifyServiceProcessDiscount(discountCode, shopDomain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['ShopifyServiceApi.shopifyServiceProcessDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [shopDomain]
         * @param {number} [amount]
         * @param {string} [shippingDataAmount]
         * @param {string} [shippingDataHandle]
         * @param {string} [shippingDataTitle]
         * @param {string} [discountDiscountType]
         * @param {string} [discountDiscountValue]
         * @param {string} [discountDiscountAllocation]
         * @param {string} [discountDiscountSelection]
         * @param {string} [discountDiscountTitle]
         * @param {Array<number>} [discountEntitledProductIds]
         * @param {Array<number>} [discountEntitledVariantIds]
         * @param {string} [locationData]
         * @param {string} [customerDataFirstName]
         * @param {string} [customerDataLastName]
         * @param {string} [customerDataEmail]
         * @param {string} [customerDataPhone]
         * @param {string} [customerDataAddress]
         * @param {string} [customerDataAddress2]
         * @param {string} [customerDataCity]
         * @param {string} [customerDataProvince]
         * @param {string} [customerDataPostalCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopifyServiceProcessOrder(shopDomain, amount, shippingDataAmount, shippingDataHandle, shippingDataTitle, discountDiscountType, discountDiscountValue, discountDiscountAllocation, discountDiscountSelection, discountDiscountTitle, discountEntitledProductIds, discountEntitledVariantIds, locationData, customerDataFirstName, customerDataLastName, customerDataEmail, customerDataPhone, customerDataAddress, customerDataAddress2, customerDataCity, customerDataProvince, customerDataPostalCode, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopifyServiceProcessOrder(shopDomain, amount, shippingDataAmount, shippingDataHandle, shippingDataTitle, discountDiscountType, discountDiscountValue, discountDiscountAllocation, discountDiscountSelection, discountDiscountTitle, discountEntitledProductIds, discountEntitledVariantIds, locationData, customerDataFirstName, customerDataLastName, customerDataEmail, customerDataPhone, customerDataAddress, customerDataAddress2, customerDataCity, customerDataProvince, customerDataPostalCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['ShopifyServiceApi.shopifyServiceProcessOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} shopDomain
         * @param {string} [accessToken]
         * @param {boolean} [bodyEnabledOnAll]
         * @param {boolean} [bodyEnabledOnProduct]
         * @param {boolean} [bodyEnabledOnCart]
         * @param {boolean} [bodyEnabledAccept]
         * @param {string} [bodyAcceptMsg]
         * @param {string} [bodyAcceptBtn]
         * @param {string} [bodyTerms]
         * @param {string} [bodyLogoUrl]
         * @param {string} [bodyLearnMore]
         * @param {string} [bodyMerchantName]
         * @param {number} [bodyDeposit]
         * @param {string} [bodyDepositType]
         * @param {number} [bodyMinMonths]
         * @param {number} [bodyMaxMonths]
         * @param {boolean} [bodyEnabledDiscount]
         * @param {boolean} [bodyEnabledOnPopupCart]
         * @param {string} [bodyPopupCartSelector]
         * @param {string} [bodyPopupCartQuantitySelector]
         * @param {string} [bodyPopupCartRemoveSelector]
         * @param {string} [bodyButtonLayout]
         * @param {boolean} [bodyTestMode]
         * @param {string} [bodyMerchantId]
         * @param {string} [bodyMerchantApiKey]
         * @param {number} [bodyShippingFee]
         * @param {number} [bodyFreeShippingMin]
         * @param {string} [bodyPreviewTemplate]
         * @param {boolean} [bodyReserveStock]
         * @param {boolean} [bodyDynamicDeposit]
         * @param {boolean} [bodyKeepDraftOrders]
         * @param {string} [bodySelectorsRenderSelector]
         * @param {string} [bodySelectorsVariantSelector]
         * @param {string} [bodySelectorsQuantitySelector]
         * @param {string} [bodySelectorsCartQuantitySelector]
         * @param {string} [bodySelectorsCartRemoveSelector]
         * @param {string} [bodySelectorsCartRenderSelector]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shopifyServiceUpdateShop(shopDomain, accessToken, bodyEnabledOnAll, bodyEnabledOnProduct, bodyEnabledOnCart, bodyEnabledAccept, bodyAcceptMsg, bodyAcceptBtn, bodyTerms, bodyLogoUrl, bodyLearnMore, bodyMerchantName, bodyDeposit, bodyDepositType, bodyMinMonths, bodyMaxMonths, bodyEnabledDiscount, bodyEnabledOnPopupCart, bodyPopupCartSelector, bodyPopupCartQuantitySelector, bodyPopupCartRemoveSelector, bodyButtonLayout, bodyTestMode, bodyMerchantId, bodyMerchantApiKey, bodyShippingFee, bodyFreeShippingMin, bodyPreviewTemplate, bodyReserveStock, bodyDynamicDeposit, bodyKeepDraftOrders, bodySelectorsRenderSelector, bodySelectorsVariantSelector, bodySelectorsQuantitySelector, bodySelectorsCartQuantitySelector, bodySelectorsCartRemoveSelector, bodySelectorsCartRenderSelector, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shopifyServiceUpdateShop(shopDomain, accessToken, bodyEnabledOnAll, bodyEnabledOnProduct, bodyEnabledOnCart, bodyEnabledAccept, bodyAcceptMsg, bodyAcceptBtn, bodyTerms, bodyLogoUrl, bodyLearnMore, bodyMerchantName, bodyDeposit, bodyDepositType, bodyMinMonths, bodyMaxMonths, bodyEnabledDiscount, bodyEnabledOnPopupCart, bodyPopupCartSelector, bodyPopupCartQuantitySelector, bodyPopupCartRemoveSelector, bodyButtonLayout, bodyTestMode, bodyMerchantId, bodyMerchantApiKey, bodyShippingFee, bodyFreeShippingMin, bodyPreviewTemplate, bodyReserveStock, bodyDynamicDeposit, bodyKeepDraftOrders, bodySelectorsRenderSelector, bodySelectorsVariantSelector, bodySelectorsQuantitySelector, bodySelectorsCartQuantitySelector, bodySelectorsCartRemoveSelector, bodySelectorsCartRenderSelector, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['ShopifyServiceApi.shopifyServiceUpdateShop']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.ShopifyServiceApiFp = ShopifyServiceApiFp;
/**
 * ShopifyServiceApi - factory interface
 * @export
 */
const ShopifyServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ShopifyServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {ShopifyServiceApiShopifyServiceCalculateShippingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceCalculateShipping(requestParameters = {}, options) {
            return localVarFp.shopifyServiceCalculateShipping(requestParameters.customerDataFirstName, requestParameters.customerDataLastName, requestParameters.customerDataEmail, requestParameters.customerDataPhone, requestParameters.customerDataAddress, requestParameters.customerDataAddress2, requestParameters.customerDataCity, requestParameters.customerDataProvince, requestParameters.customerDataPostalCode, requestParameters.shopDomain, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ShopifyServiceApiShopifyServiceCreateShopRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceCreateShop(requestParameters, options) {
            return localVarFp.shopifyServiceCreateShop(requestParameters.shopDomain1, requestParameters.accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ShopifyServiceApiShopifyServiceDeleteShopRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceDeleteShop(requestParameters, options) {
            return localVarFp.shopifyServiceDeleteShop(requestParameters.shopDomain, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ShopifyServiceApiShopifyServiceGetLinkedOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceGetLinkedOrders(requestParameters, options) {
            return localVarFp.shopifyServiceGetLinkedOrders(requestParameters.shopDomain, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ShopifyServiceApiShopifyServiceGetOrderNotesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceGetOrderNotes(requestParameters = {}, options) {
            return localVarFp.shopifyServiceGetOrderNotes(requestParameters.shopDomain, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ShopifyServiceApiShopifyServiceGetShopSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceGetShopSettings(requestParameters, options) {
            return localVarFp.shopifyServiceGetShopSettings(requestParameters.shopDomain, requestParameters.accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ShopifyServiceApiShopifyServiceLinkOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceLinkOrder(requestParameters = {}, options) {
            return localVarFp.shopifyServiceLinkOrder(requestParameters.shopDomain, requestParameters.draftOrderId, requestParameters.draftOrderStatus, requestParameters.draftOrderCreatedAt, requestParameters.draftOrderName, requestParameters.draftOrderCustomerName, requestParameters.draftOrderCustomerEmail, requestParameters.draftOrderCustomerPhone, requestParameters.draftOrderCustomerDisplayName, requestParameters.draftOrderTotalPriceSet, requestParameters.draftOrderTaxesIncluded, requestParameters.draftOrderShippingLineDiscountedPriceSet, requestParameters.draftOrderTotalTaxSet, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ShopifyServiceApiShopifyServiceProcessDiscountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceProcessDiscount(requestParameters = {}, options) {
            return localVarFp.shopifyServiceProcessDiscount(requestParameters.discountCode, requestParameters.shopDomain, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ShopifyServiceApiShopifyServiceProcessOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceProcessOrder(requestParameters = {}, options) {
            return localVarFp.shopifyServiceProcessOrder(requestParameters.shopDomain, requestParameters.amount, requestParameters.shippingDataAmount, requestParameters.shippingDataHandle, requestParameters.shippingDataTitle, requestParameters.discountDiscountType, requestParameters.discountDiscountValue, requestParameters.discountDiscountAllocation, requestParameters.discountDiscountSelection, requestParameters.discountDiscountTitle, requestParameters.discountEntitledProductIds, requestParameters.discountEntitledVariantIds, requestParameters.locationData, requestParameters.customerDataFirstName, requestParameters.customerDataLastName, requestParameters.customerDataEmail, requestParameters.customerDataPhone, requestParameters.customerDataAddress, requestParameters.customerDataAddress2, requestParameters.customerDataCity, requestParameters.customerDataProvince, requestParameters.customerDataPostalCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ShopifyServiceApiShopifyServiceUpdateShopRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shopifyServiceUpdateShop(requestParameters, options) {
            return localVarFp.shopifyServiceUpdateShop(requestParameters.shopDomain, requestParameters.accessToken, requestParameters.bodyEnabledOnAll, requestParameters.bodyEnabledOnProduct, requestParameters.bodyEnabledOnCart, requestParameters.bodyEnabledAccept, requestParameters.bodyAcceptMsg, requestParameters.bodyAcceptBtn, requestParameters.bodyTerms, requestParameters.bodyLogoUrl, requestParameters.bodyLearnMore, requestParameters.bodyMerchantName, requestParameters.bodyDeposit, requestParameters.bodyDepositType, requestParameters.bodyMinMonths, requestParameters.bodyMaxMonths, requestParameters.bodyEnabledDiscount, requestParameters.bodyEnabledOnPopupCart, requestParameters.bodyPopupCartSelector, requestParameters.bodyPopupCartQuantitySelector, requestParameters.bodyPopupCartRemoveSelector, requestParameters.bodyButtonLayout, requestParameters.bodyTestMode, requestParameters.bodyMerchantId, requestParameters.bodyMerchantApiKey, requestParameters.bodyShippingFee, requestParameters.bodyFreeShippingMin, requestParameters.bodyPreviewTemplate, requestParameters.bodyReserveStock, requestParameters.bodyDynamicDeposit, requestParameters.bodyKeepDraftOrders, requestParameters.bodySelectorsRenderSelector, requestParameters.bodySelectorsVariantSelector, requestParameters.bodySelectorsQuantitySelector, requestParameters.bodySelectorsCartQuantitySelector, requestParameters.bodySelectorsCartRemoveSelector, requestParameters.bodySelectorsCartRenderSelector, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ShopifyServiceApiFactory = ShopifyServiceApiFactory;
/**
 * ShopifyServiceApi - object-oriented interface
 * @export
 * @class ShopifyServiceApi
 * @extends {BaseAPI}
 */
class ShopifyServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {ShopifyServiceApiShopifyServiceCalculateShippingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyServiceApi
     */
    shopifyServiceCalculateShipping(requestParameters = {}, options) {
        return (0, exports.ShopifyServiceApiFp)(this.configuration).shopifyServiceCalculateShipping(requestParameters.customerDataFirstName, requestParameters.customerDataLastName, requestParameters.customerDataEmail, requestParameters.customerDataPhone, requestParameters.customerDataAddress, requestParameters.customerDataAddress2, requestParameters.customerDataCity, requestParameters.customerDataProvince, requestParameters.customerDataPostalCode, requestParameters.shopDomain, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ShopifyServiceApiShopifyServiceCreateShopRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyServiceApi
     */
    shopifyServiceCreateShop(requestParameters, options) {
        return (0, exports.ShopifyServiceApiFp)(this.configuration).shopifyServiceCreateShop(requestParameters.shopDomain1, requestParameters.accessToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ShopifyServiceApiShopifyServiceDeleteShopRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyServiceApi
     */
    shopifyServiceDeleteShop(requestParameters, options) {
        return (0, exports.ShopifyServiceApiFp)(this.configuration).shopifyServiceDeleteShop(requestParameters.shopDomain, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ShopifyServiceApiShopifyServiceGetLinkedOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyServiceApi
     */
    shopifyServiceGetLinkedOrders(requestParameters, options) {
        return (0, exports.ShopifyServiceApiFp)(this.configuration).shopifyServiceGetLinkedOrders(requestParameters.shopDomain, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ShopifyServiceApiShopifyServiceGetOrderNotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyServiceApi
     */
    shopifyServiceGetOrderNotes(requestParameters = {}, options) {
        return (0, exports.ShopifyServiceApiFp)(this.configuration).shopifyServiceGetOrderNotes(requestParameters.shopDomain, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ShopifyServiceApiShopifyServiceGetShopSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyServiceApi
     */
    shopifyServiceGetShopSettings(requestParameters, options) {
        return (0, exports.ShopifyServiceApiFp)(this.configuration).shopifyServiceGetShopSettings(requestParameters.shopDomain, requestParameters.accessToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ShopifyServiceApiShopifyServiceLinkOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyServiceApi
     */
    shopifyServiceLinkOrder(requestParameters = {}, options) {
        return (0, exports.ShopifyServiceApiFp)(this.configuration).shopifyServiceLinkOrder(requestParameters.shopDomain, requestParameters.draftOrderId, requestParameters.draftOrderStatus, requestParameters.draftOrderCreatedAt, requestParameters.draftOrderName, requestParameters.draftOrderCustomerName, requestParameters.draftOrderCustomerEmail, requestParameters.draftOrderCustomerPhone, requestParameters.draftOrderCustomerDisplayName, requestParameters.draftOrderTotalPriceSet, requestParameters.draftOrderTaxesIncluded, requestParameters.draftOrderShippingLineDiscountedPriceSet, requestParameters.draftOrderTotalTaxSet, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ShopifyServiceApiShopifyServiceProcessDiscountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyServiceApi
     */
    shopifyServiceProcessDiscount(requestParameters = {}, options) {
        return (0, exports.ShopifyServiceApiFp)(this.configuration).shopifyServiceProcessDiscount(requestParameters.discountCode, requestParameters.shopDomain, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ShopifyServiceApiShopifyServiceProcessOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyServiceApi
     */
    shopifyServiceProcessOrder(requestParameters = {}, options) {
        return (0, exports.ShopifyServiceApiFp)(this.configuration).shopifyServiceProcessOrder(requestParameters.shopDomain, requestParameters.amount, requestParameters.shippingDataAmount, requestParameters.shippingDataHandle, requestParameters.shippingDataTitle, requestParameters.discountDiscountType, requestParameters.discountDiscountValue, requestParameters.discountDiscountAllocation, requestParameters.discountDiscountSelection, requestParameters.discountDiscountTitle, requestParameters.discountEntitledProductIds, requestParameters.discountEntitledVariantIds, requestParameters.locationData, requestParameters.customerDataFirstName, requestParameters.customerDataLastName, requestParameters.customerDataEmail, requestParameters.customerDataPhone, requestParameters.customerDataAddress, requestParameters.customerDataAddress2, requestParameters.customerDataCity, requestParameters.customerDataProvince, requestParameters.customerDataPostalCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ShopifyServiceApiShopifyServiceUpdateShopRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShopifyServiceApi
     */
    shopifyServiceUpdateShop(requestParameters, options) {
        return (0, exports.ShopifyServiceApiFp)(this.configuration).shopifyServiceUpdateShop(requestParameters.shopDomain, requestParameters.accessToken, requestParameters.bodyEnabledOnAll, requestParameters.bodyEnabledOnProduct, requestParameters.bodyEnabledOnCart, requestParameters.bodyEnabledAccept, requestParameters.bodyAcceptMsg, requestParameters.bodyAcceptBtn, requestParameters.bodyTerms, requestParameters.bodyLogoUrl, requestParameters.bodyLearnMore, requestParameters.bodyMerchantName, requestParameters.bodyDeposit, requestParameters.bodyDepositType, requestParameters.bodyMinMonths, requestParameters.bodyMaxMonths, requestParameters.bodyEnabledDiscount, requestParameters.bodyEnabledOnPopupCart, requestParameters.bodyPopupCartSelector, requestParameters.bodyPopupCartQuantitySelector, requestParameters.bodyPopupCartRemoveSelector, requestParameters.bodyButtonLayout, requestParameters.bodyTestMode, requestParameters.bodyMerchantId, requestParameters.bodyMerchantApiKey, requestParameters.bodyShippingFee, requestParameters.bodyFreeShippingMin, requestParameters.bodyPreviewTemplate, requestParameters.bodyReserveStock, requestParameters.bodyDynamicDeposit, requestParameters.bodyKeepDraftOrders, requestParameters.bodySelectorsRenderSelector, requestParameters.bodySelectorsVariantSelector, requestParameters.bodySelectorsQuantitySelector, requestParameters.bodySelectorsCartQuantitySelector, requestParameters.bodySelectorsCartRemoveSelector, requestParameters.bodySelectorsCartRenderSelector, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ShopifyServiceApi = ShopifyServiceApi;
/**
 * SmsOriginNumberServiceApi - axios parameter creator
 * @export
 */
const SmsOriginNumberServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsOriginNumberServiceDel: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('smsOriginNumberServiceDel', 'id', id);
            const localVarPath = `/v1/sms-origin-numbers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsOriginNumberServiceGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('smsOriginNumberServiceGet', 'id', id);
            const localVarPath = `/v1/sms-origin-numbers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsOriginNumberServiceGetMany: async (options = {}) => {
            const localVarPath = `/v1/sms-origin-numbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelSmsOriginNumberRequest} modelSmsOriginNumberRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsOriginNumberServiceUpdate: async (modelSmsOriginNumberRequest, id, options = {}) => {
            // verify required parameter 'modelSmsOriginNumberRequest' is not null or undefined
            (0, common_1.assertParamExists)('smsOriginNumberServiceUpdate', 'modelSmsOriginNumberRequest', modelSmsOriginNumberRequest);
            const localVarPath = `/v1/sms-origin-numbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelSmsOriginNumberRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.SmsOriginNumberServiceApiAxiosParamCreator = SmsOriginNumberServiceApiAxiosParamCreator;
/**
 * SmsOriginNumberServiceApi - functional programming interface
 * @export
 */
const SmsOriginNumberServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SmsOriginNumberServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async smsOriginNumberServiceDel(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.smsOriginNumberServiceDel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['SmsOriginNumberServiceApi.smsOriginNumberServiceDel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async smsOriginNumberServiceGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.smsOriginNumberServiceGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['SmsOriginNumberServiceApi.smsOriginNumberServiceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async smsOriginNumberServiceGetMany(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.smsOriginNumberServiceGetMany(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['SmsOriginNumberServiceApi.smsOriginNumberServiceGetMany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelSmsOriginNumberRequest} modelSmsOriginNumberRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async smsOriginNumberServiceUpdate(modelSmsOriginNumberRequest, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.smsOriginNumberServiceUpdate(modelSmsOriginNumberRequest, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['SmsOriginNumberServiceApi.smsOriginNumberServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.SmsOriginNumberServiceApiFp = SmsOriginNumberServiceApiFp;
/**
 * SmsOriginNumberServiceApi - factory interface
 * @export
 */
const SmsOriginNumberServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SmsOriginNumberServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {SmsOriginNumberServiceApiSmsOriginNumberServiceDelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsOriginNumberServiceDel(requestParameters, options) {
            return localVarFp.smsOriginNumberServiceDel(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SmsOriginNumberServiceApiSmsOriginNumberServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsOriginNumberServiceGet(requestParameters, options) {
            return localVarFp.smsOriginNumberServiceGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsOriginNumberServiceGetMany(options) {
            return localVarFp.smsOriginNumberServiceGetMany(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SmsOriginNumberServiceApiSmsOriginNumberServiceUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsOriginNumberServiceUpdate(requestParameters, options) {
            return localVarFp.smsOriginNumberServiceUpdate(requestParameters.modelSmsOriginNumberRequest, requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SmsOriginNumberServiceApiFactory = SmsOriginNumberServiceApiFactory;
/**
 * SmsOriginNumberServiceApi - object-oriented interface
 * @export
 * @class SmsOriginNumberServiceApi
 * @extends {BaseAPI}
 */
class SmsOriginNumberServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {SmsOriginNumberServiceApiSmsOriginNumberServiceDelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsOriginNumberServiceApi
     */
    smsOriginNumberServiceDel(requestParameters, options) {
        return (0, exports.SmsOriginNumberServiceApiFp)(this.configuration).smsOriginNumberServiceDel(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SmsOriginNumberServiceApiSmsOriginNumberServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsOriginNumberServiceApi
     */
    smsOriginNumberServiceGet(requestParameters, options) {
        return (0, exports.SmsOriginNumberServiceApiFp)(this.configuration).smsOriginNumberServiceGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsOriginNumberServiceApi
     */
    smsOriginNumberServiceGetMany(options) {
        return (0, exports.SmsOriginNumberServiceApiFp)(this.configuration).smsOriginNumberServiceGetMany(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SmsOriginNumberServiceApiSmsOriginNumberServiceUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsOriginNumberServiceApi
     */
    smsOriginNumberServiceUpdate(requestParameters, options) {
        return (0, exports.SmsOriginNumberServiceApiFp)(this.configuration).smsOriginNumberServiceUpdate(requestParameters.modelSmsOriginNumberRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SmsOriginNumberServiceApi = SmsOriginNumberServiceApi;
/**
 * TerminalPaymentAppsServiceApi - axios parameter creator
 * @export
 */
const TerminalPaymentAppsServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminalPaymentAppsServiceGetMany: async (options = {}) => {
            const localVarPath = `/v1/terminalPaymentApps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TerminalPaymentAppsServiceApiAxiosParamCreator = TerminalPaymentAppsServiceApiAxiosParamCreator;
/**
 * TerminalPaymentAppsServiceApi - functional programming interface
 * @export
 */
const TerminalPaymentAppsServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TerminalPaymentAppsServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terminalPaymentAppsServiceGetMany(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terminalPaymentAppsServiceGetMany(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['TerminalPaymentAppsServiceApi.terminalPaymentAppsServiceGetMany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.TerminalPaymentAppsServiceApiFp = TerminalPaymentAppsServiceApiFp;
/**
 * TerminalPaymentAppsServiceApi - factory interface
 * @export
 */
const TerminalPaymentAppsServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TerminalPaymentAppsServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminalPaymentAppsServiceGetMany(options) {
            return localVarFp.terminalPaymentAppsServiceGetMany(options).then((request) => request(axios, basePath));
        },
    };
};
exports.TerminalPaymentAppsServiceApiFactory = TerminalPaymentAppsServiceApiFactory;
/**
 * TerminalPaymentAppsServiceApi - object-oriented interface
 * @export
 * @class TerminalPaymentAppsServiceApi
 * @extends {BaseAPI}
 */
class TerminalPaymentAppsServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminalPaymentAppsServiceApi
     */
    terminalPaymentAppsServiceGetMany(options) {
        return (0, exports.TerminalPaymentAppsServiceApiFp)(this.configuration).terminalPaymentAppsServiceGetMany(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TerminalPaymentAppsServiceApi = TerminalPaymentAppsServiceApi;
/**
 * TerminalServiceApi - axios parameter creator
 * @export
 */
const TerminalServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelTerminalCreateRequest} modelTerminalCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminalServiceCreate: async (modelTerminalCreateRequest, options = {}) => {
            // verify required parameter 'modelTerminalCreateRequest' is not null or undefined
            (0, common_1.assertParamExists)('terminalServiceCreate', 'modelTerminalCreateRequest', modelTerminalCreateRequest);
            const localVarPath = `/v1/terminals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelTerminalCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ModelTerminalCreateBulkRequest} modelTerminalCreateBulkRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminalServiceCreateBulk: async (modelTerminalCreateBulkRequest, options = {}) => {
            // verify required parameter 'modelTerminalCreateBulkRequest' is not null or undefined
            (0, common_1.assertParamExists)('terminalServiceCreateBulk', 'modelTerminalCreateBulkRequest', modelTerminalCreateBulkRequest);
            const localVarPath = `/v1/terminals/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelTerminalCreateBulkRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminalServiceGet: async (options = {}) => {
            const localVarPath = `/v1/terminals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} serial
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminalServiceGetBySerial: async (serial, options = {}) => {
            // verify required parameter 'serial' is not null or undefined
            (0, common_1.assertParamExists)('terminalServiceGetBySerial', 'serial', serial);
            const localVarPath = `/v1/terminals/{serial}`
                .replace(`{${"serial"}}`, encodeURIComponent(String(serial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {ModelTerminalServiceupdateBody} modelTerminalServiceupdateBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminalServiceUpdate: async (id, modelTerminalServiceupdateBody, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('terminalServiceUpdate', 'id', id);
            // verify required parameter 'modelTerminalServiceupdateBody' is not null or undefined
            (0, common_1.assertParamExists)('terminalServiceUpdate', 'modelTerminalServiceupdateBody', modelTerminalServiceupdateBody);
            const localVarPath = `/v1/terminals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelTerminalServiceupdateBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TerminalServiceApiAxiosParamCreator = TerminalServiceApiAxiosParamCreator;
/**
 * TerminalServiceApi - functional programming interface
 * @export
 */
const TerminalServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TerminalServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelTerminalCreateRequest} modelTerminalCreateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terminalServiceCreate(modelTerminalCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terminalServiceCreate(modelTerminalCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['TerminalServiceApi.terminalServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {ModelTerminalCreateBulkRequest} modelTerminalCreateBulkRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terminalServiceCreateBulk(modelTerminalCreateBulkRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terminalServiceCreateBulk(modelTerminalCreateBulkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['TerminalServiceApi.terminalServiceCreateBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terminalServiceGet(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terminalServiceGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['TerminalServiceApi.terminalServiceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} serial
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terminalServiceGetBySerial(serial, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terminalServiceGetBySerial(serial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['TerminalServiceApi.terminalServiceGetBySerial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {ModelTerminalServiceupdateBody} modelTerminalServiceupdateBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async terminalServiceUpdate(id, modelTerminalServiceupdateBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.terminalServiceUpdate(id, modelTerminalServiceupdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['TerminalServiceApi.terminalServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.TerminalServiceApiFp = TerminalServiceApiFp;
/**
 * TerminalServiceApi - factory interface
 * @export
 */
const TerminalServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TerminalServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {TerminalServiceApiTerminalServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminalServiceCreate(requestParameters, options) {
            return localVarFp.terminalServiceCreate(requestParameters.modelTerminalCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TerminalServiceApiTerminalServiceCreateBulkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminalServiceCreateBulk(requestParameters, options) {
            return localVarFp.terminalServiceCreateBulk(requestParameters.modelTerminalCreateBulkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminalServiceGet(options) {
            return localVarFp.terminalServiceGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TerminalServiceApiTerminalServiceGetBySerialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminalServiceGetBySerial(requestParameters, options) {
            return localVarFp.terminalServiceGetBySerial(requestParameters.serial, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TerminalServiceApiTerminalServiceUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminalServiceUpdate(requestParameters, options) {
            return localVarFp.terminalServiceUpdate(requestParameters.id, requestParameters.modelTerminalServiceupdateBody, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TerminalServiceApiFactory = TerminalServiceApiFactory;
/**
 * TerminalServiceApi - object-oriented interface
 * @export
 * @class TerminalServiceApi
 * @extends {BaseAPI}
 */
class TerminalServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {TerminalServiceApiTerminalServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminalServiceApi
     */
    terminalServiceCreate(requestParameters, options) {
        return (0, exports.TerminalServiceApiFp)(this.configuration).terminalServiceCreate(requestParameters.modelTerminalCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TerminalServiceApiTerminalServiceCreateBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminalServiceApi
     */
    terminalServiceCreateBulk(requestParameters, options) {
        return (0, exports.TerminalServiceApiFp)(this.configuration).terminalServiceCreateBulk(requestParameters.modelTerminalCreateBulkRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminalServiceApi
     */
    terminalServiceGet(options) {
        return (0, exports.TerminalServiceApiFp)(this.configuration).terminalServiceGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TerminalServiceApiTerminalServiceGetBySerialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminalServiceApi
     */
    terminalServiceGetBySerial(requestParameters, options) {
        return (0, exports.TerminalServiceApiFp)(this.configuration).terminalServiceGetBySerial(requestParameters.serial, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TerminalServiceApiTerminalServiceUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminalServiceApi
     */
    terminalServiceUpdate(requestParameters, options) {
        return (0, exports.TerminalServiceApiFp)(this.configuration).terminalServiceUpdate(requestParameters.id, requestParameters.modelTerminalServiceupdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TerminalServiceApi = TerminalServiceApi;
/**
 * TokenServiceApi - axios parameter creator
 * @export
 */
const TokenServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ModelTokenRequest} modelTokenRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenServiceCreate: async (modelTokenRequest, id, options = {}) => {
            // verify required parameter 'modelTokenRequest' is not null or undefined
            (0, common_1.assertParamExists)('tokenServiceCreate', 'modelTokenRequest', modelTokenRequest);
            const localVarPath = `/v1/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelTokenRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TokenServiceApiAxiosParamCreator = TokenServiceApiAxiosParamCreator;
/**
 * TokenServiceApi - functional programming interface
 * @export
 */
const TokenServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TokenServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {ModelTokenRequest} modelTokenRequest
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenServiceCreate(modelTokenRequest, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenServiceCreate(modelTokenRequest, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['TokenServiceApi.tokenServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.TokenServiceApiFp = TokenServiceApiFp;
/**
 * TokenServiceApi - factory interface
 * @export
 */
const TokenServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TokenServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {TokenServiceApiTokenServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenServiceCreate(requestParameters, options) {
            return localVarFp.tokenServiceCreate(requestParameters.modelTokenRequest, requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TokenServiceApiFactory = TokenServiceApiFactory;
/**
 * TokenServiceApi - object-oriented interface
 * @export
 * @class TokenServiceApi
 * @extends {BaseAPI}
 */
class TokenServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {TokenServiceApiTokenServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenServiceApi
     */
    tokenServiceCreate(requestParameters, options) {
        return (0, exports.TokenServiceApiFp)(this.configuration).tokenServiceCreate(requestParameters.modelTokenRequest, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TokenServiceApi = TokenServiceApi;
/**
 * UserServiceApi - axios parameter creator
 * @export
 */
const UserServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Description
         * @param {ModelUserRequest} modelUserRequest
         * @param {string} [id]
         * @param {string} [avs]
         * @param {boolean} [isRealtimeVerification]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceCreate: async (modelUserRequest, id, avs, isRealtimeVerification, options = {}) => {
            // verify required parameter 'modelUserRequest' is not null or undefined
            (0, common_1.assertParamExists)('userServiceCreate', 'modelUserRequest', modelUserRequest);
            const localVarPath = `/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            if (avs !== undefined) {
                localVarQueryParameter['avs'] = avs;
            }
            if (isRealtimeVerification !== undefined) {
                localVarQueryParameter['isRealtimeVerification'] = isRealtimeVerification;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelUserRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Description
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceDel: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('userServiceDel', 'id', id);
            const localVarPath = `/v1/users/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceGet: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('userServiceGet', 'id', id);
            const localVarPath = `/v1/users/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceGetMany: async (limit, orderId, options = {}) => {
            const localVarPath = `/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} id
         * @param {ModelUserRequest} modelUserRequest
         * @param {string} [avs]
         * @param {boolean} [isRealtimeVerification]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceUpdate: async (id, modelUserRequest, avs, isRealtimeVerification, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('userServiceUpdate', 'id', id);
            // verify required parameter 'modelUserRequest' is not null or undefined
            (0, common_1.assertParamExists)('userServiceUpdate', 'modelUserRequest', modelUserRequest);
            const localVarPath = `/v1/users/{_id}`
                .replace(`{${"_id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (avs !== undefined) {
                localVarQueryParameter['avs'] = avs;
            }
            if (isRealtimeVerification !== undefined) {
                localVarQueryParameter['isRealtimeVerification'] = isRealtimeVerification;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modelUserRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.UserServiceApiAxiosParamCreator = UserServiceApiAxiosParamCreator;
/**
 * UserServiceApi - functional programming interface
 * @export
 */
const UserServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UserServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Description
         * @param {ModelUserRequest} modelUserRequest
         * @param {string} [id]
         * @param {string} [avs]
         * @param {boolean} [isRealtimeVerification]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userServiceCreate(modelUserRequest, id, avs, isRealtimeVerification, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userServiceCreate(modelUserRequest, id, avs, isRealtimeVerification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['UserServiceApi.userServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Description
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userServiceDel(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userServiceDel(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['UserServiceApi.userServiceDel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userServiceGet(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userServiceGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['UserServiceApi.userServiceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userServiceGetMany(limit, orderId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userServiceGetMany(limit, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['UserServiceApi.userServiceGetMany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} id
         * @param {ModelUserRequest} modelUserRequest
         * @param {string} [avs]
         * @param {boolean} [isRealtimeVerification]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userServiceUpdate(id, modelUserRequest, avs, isRealtimeVerification, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userServiceUpdate(id, modelUserRequest, avs, isRealtimeVerification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['UserServiceApi.userServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.UserServiceApiFp = UserServiceApiFp;
/**
 * UserServiceApi - factory interface
 * @export
 */
const UserServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UserServiceApiFp)(configuration);
    return {
        /**
         *
         * @summary Description
         * @param {UserServiceApiUserServiceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceCreate(requestParameters, options) {
            return localVarFp.userServiceCreate(requestParameters.modelUserRequest, requestParameters.id, requestParameters.avs, requestParameters.isRealtimeVerification, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Description
         * @param {UserServiceApiUserServiceDelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceDel(requestParameters, options) {
            return localVarFp.userServiceDel(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserServiceApiUserServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceGet(requestParameters, options) {
            return localVarFp.userServiceGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserServiceApiUserServiceGetManyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceGetMany(requestParameters = {}, options) {
            return localVarFp.userServiceGetMany(requestParameters.limit, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UserServiceApiUserServiceUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userServiceUpdate(requestParameters, options) {
            return localVarFp.userServiceUpdate(requestParameters.id, requestParameters.modelUserRequest, requestParameters.avs, requestParameters.isRealtimeVerification, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UserServiceApiFactory = UserServiceApiFactory;
/**
 * UserServiceApi - object-oriented interface
 * @export
 * @class UserServiceApi
 * @extends {BaseAPI}
 */
class UserServiceApi extends base_1.BaseAPI {
    /**
     *
     * @summary Description
     * @param {UserServiceApiUserServiceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserServiceApi
     */
    userServiceCreate(requestParameters, options) {
        return (0, exports.UserServiceApiFp)(this.configuration).userServiceCreate(requestParameters.modelUserRequest, requestParameters.id, requestParameters.avs, requestParameters.isRealtimeVerification, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Description
     * @param {UserServiceApiUserServiceDelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserServiceApi
     */
    userServiceDel(requestParameters, options) {
        return (0, exports.UserServiceApiFp)(this.configuration).userServiceDel(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserServiceApiUserServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserServiceApi
     */
    userServiceGet(requestParameters, options) {
        return (0, exports.UserServiceApiFp)(this.configuration).userServiceGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserServiceApiUserServiceGetManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserServiceApi
     */
    userServiceGetMany(requestParameters = {}, options) {
        return (0, exports.UserServiceApiFp)(this.configuration).userServiceGetMany(requestParameters.limit, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserServiceApiUserServiceUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserServiceApi
     */
    userServiceUpdate(requestParameters, options) {
        return (0, exports.UserServiceApiFp)(this.configuration).userServiceUpdate(requestParameters.id, requestParameters.modelUserRequest, requestParameters.avs, requestParameters.isRealtimeVerification, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserServiceApi = UserServiceApi;
/**
 * VerifyServiceApi - axios parameter creator
 * @export
 */
const VerifyServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [token]
         * @param {string} [msisdn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyServiceGet: async (token, msisdn, options = {}) => {
            const localVarPath = `/v1/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication apiKey required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "apikey", configuration);
            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }
            if (msisdn !== undefined) {
                localVarQueryParameter['msisdn'] = msisdn;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.VerifyServiceApiAxiosParamCreator = VerifyServiceApiAxiosParamCreator;
/**
 * VerifyServiceApi - functional programming interface
 * @export
 */
const VerifyServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.VerifyServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [token]
         * @param {string} [msisdn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyServiceGet(token, msisdn, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyServiceGet(token, msisdn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['VerifyServiceApi.verifyServiceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.VerifyServiceApiFp = VerifyServiceApiFp;
/**
 * VerifyServiceApi - factory interface
 * @export
 */
const VerifyServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.VerifyServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {VerifyServiceApiVerifyServiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyServiceGet(requestParameters = {}, options) {
            return localVarFp.verifyServiceGet(requestParameters.token, requestParameters.msisdn, options).then((request) => request(axios, basePath));
        },
    };
};
exports.VerifyServiceApiFactory = VerifyServiceApiFactory;
/**
 * VerifyServiceApi - object-oriented interface
 * @export
 * @class VerifyServiceApi
 * @extends {BaseAPI}
 */
class VerifyServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {VerifyServiceApiVerifyServiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifyServiceApi
     */
    verifyServiceGet(requestParameters = {}, options) {
        return (0, exports.VerifyServiceApiFp)(this.configuration).verifyServiceGet(requestParameters.token, requestParameters.msisdn, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.VerifyServiceApi = VerifyServiceApi;
//# sourceMappingURL=api.js.map